/* Peakside 24/7 Tuning (sections/pk-247-tuning.liquid, templates/page.24-7-tuning.json).
   VIN -> vPIC decode -> Continue -> exact route (rules 2026-10-18) -> Cummins device choice / EFI Live form /
   EZ-Lynk VIN-only checkout / matching collection -> one atomic POST {routes.cart_add_url}.js.
   Data: <script type="application/json" id="pk247-data"> rendered by the section (catalog via all_products,
   Shopify-formatted prices, cart currency, routes). No build step, no libraries, ES2017, one global: window.PK247.
   Pure logic (VIN check, identify, route, quote, payload, cleanup) is exposed on window.PK247.__test.
   Brent 2026-10-17: EZ-Lynk support package is a variant choice (Limited / Unlimited, no default); the page is
   visible but unlinked. SPEC 13: 2017-2023 L5P routes to EZ-Lynk with an optional Allison add-on and a 2017-2018
   ECM eligibility gate. SPEC 15 (Brent 2026-10-18): 2006-2007 5.9L Cummins (EFI Live, injectors + transmission
   type, no ECM identifiers) and 2007.5-2012 6.7L Cummins (EFI Live, the 2013-2021 form; 2007-2009 without ECM
   Serial / E/C Number, no AISIN add-on before 2013); E/C Number for Cummins 2010-2021. SPEC 18 (Brent 2026-10-18):
   every tune and add-on line carries the hidden marker _247: "1", every tune line the auto-patcher JSON _247_order,
   and a verified add also sets the order information (SPEC 18f: cart attributes "Order Source: 24/7 Builder" and
   _247_rules -> the order's note_attributes; the note is never touched); 2013-2018 Cummins EFI Live asks for
   Injectors. SPEC 19 (Brent 2026-10-18): every GM route carries the drive type (vPIC DriveType, or a required
   4x4 / 4x2 choice when the VIN does not say) and, on a 4x4, the transfer case (Auto preselected / Manual); GM EFI
   Live and the AISIN add-on are auto-patched (GM AISIN Patcher); 2022-2024 Cummins EZ-Lynk asks for the E/C Number.
   SPEC 21 (Brent 2026-10-18: "a box for an option PO (Purchase Order) for people or dealers to use when they need one"):
   an optional PO Number in Order Details on every route that adds to the cart (visible "PO Number" on every line of
   the build, _247_order.po, the fingerprint, the "PO Number" cart attribute); 2013-2018 manual Cummins is auto-patched
   (DO68); every auto-patched Cummins line goes to the GM AISIN Patcher's one-pass cummins kind, and the cases that
   patcher refuses (Modified Injectors + SOTF, manual + Modified Injectors, 2019-2021 manual, cab & chassis) are
   autoPatch false. SPEC 22 (Brent 2026-10-18: "adding 6.0 and 6.4 SCT support"; "Three choices for tCU strat. 6.4 can
   choose sct or ez"): 2003-2007 Super Duty / 2003-2010 E-Series 6.0L Powerstroke -> SCT (auto-assigned: the product
   page's tune names, 1-5 files, SCT serial, ECM strategy, turbo, injectors (larger than 330CC -> the product page),
   transmission); 2008-2010 6.4L -> device choice EZ-Lynk / SCT (single files 1-5 or SOTF, TCU strategy, Non-VGT). SCT
   lines are autoPatch false ("SCT builds by hand"). SPEC 23 (Brent 2026-10-18): 2006-2007 5.9L with Stock Injectors is
   auto-patched (patcher kind cummins59: trans / tune / vin; Modified Injectors build by hand); 2007.5-2012 6.7L Cummins
   gets "Order On The Product Page" links (the Cummins EFI Live product on the truck's Truck Year variant, the 68RFE TCM
   product) while the one flag flags.cmns_07_12_efi_live is off (the SPEC 15 EFI Live route stays for when it is on);
   the 6.0 SCT asks Idle Sound (Non-VGT forces Rumble; a Rumble note for 2003-2004 and the Excursion) and Sensors (Stock
   Sensors preselected), and the 2003-2005 Excursion routes to the 6.0 SCT; the 6.4 SCT has no Non-VGT choice (Brent:
   "remove the option to select non vgt for 6.4 powerstroke"); a 2013-2021 Cummins cab & chassis VIN on EFI Live gets only
   Level 1-5 or OBD SOTF and the AISIN add-on (Brent: "only show it Level 1-5 and OBD SOTF. No other modifers for efi
   live"; "C&C can add AISIN tuning"; 2013-2018 = Level 1-5 only, auto-patched as DO70); the 6.0 E-Series goes to the 6.0
   SCT product page, 2003-2004 Super Duty and the Excursion are the FSM8 family, 2005-2007 Super Duty TTP1; SCT serials
   need an XP / X4 / LT / LX / BD prefix; every SCT line carries a patcher block (kind sct60 / sct64) and stays autoPatch
   false while the one flag SCT_AUTOPATCH is false. Rules version 2026-10-18.4. SPEC 24 (review fixes 2026-10-18, rules
   version unchanged): a cab & chassis line is auto-patched only when the installed GM AISIN Patcher plans it (AISIN, a VIN
   with 4th character W and 8th character L), 68RFE / Manual and the VINs its DO70 rule refuses are held with a reason; the
   device chooser's EFI Live card follows the cab & chassis rule; with link codes the EFI Live device serial must be a
   12-digit AutoCal serial starting 005 / 006 (Order Flow's rule); a Ford whose engine names Navistar is diesel (vPIC
   decodes the 2004 F-450 / 2003-2004 F-550 6.0L as Gasoline); Make "GM" shows as GM.
   SPEC 26 (Brent 2026-10-21: "add 17-23 L5P HP Tuners trucks to the auto tuner ... levels 1-5 or SOTF ... upload an infolog
   and make it required and an HPT file required ... enter their serial number"): the 2017-2023 L5P becomes a device choice,
   EZ-Lynk (unchanged, byte-equal lines) or HP Tuners (section setting l5p_hp_tuners; off = EZ-Lynk only, as before). The HP
   Tuners form asks Single Tune Level 1-5 or Switch On The Fly, the 10-digit device serial, the infolog (.txt; only its
   connected E41 block is read, for the VIN and OS) and the stock read (.hpt; never read). The line goes to the cart in one
   multipart add carrying both files (hidden _247_infolog / _247_stock_hpt, Shopify-hosted /uploads/ URLs) and is
   auto-built by Peakside L5P Studio (patcher kind l5p_hpt) when the infolog VIN and OS match. No credit or licence data is
   read or shown (Brent: "HP Tuners licensing does not pertain to the file"). Rules version 2026-10-21.
   Contract: design/ORDER-CONTRACT.md. Styles: pk-247-tuning.css. */
(function () {
  'use strict';

  /* =========================================================================
     1. Constants, copy and rule tables
     ========================================================================= */
  // SPEC 26: the L5P device choice (EZ-Lynk / HP Tuners) and the HP Tuners field rules. Earlier: 2026-10-18.4 (SPEC 23g: 5.9
  // auto-patch, 2007.5-2012 product pages, 6.0 SCT additions, no 6.4 Non-VGT, the 2013-2021 cab & chassis form, the 6.0
  // families / E-Series product page / SCT serial prefixes / SCT patcher blocks), 2026-10-18.3 (the first cut of the 6.0 Idle
  // Sound + Sensors, 06e8b25), 2026-10-18.2 SPEC 22e, 2026-10-18 SPEC 21d, 2026-10-17 before. The SCT Patcher accepts only the
  // versions in its RULES_ACCEPTED: it must list 2026-10-21 before this page reaches the live theme (SPEC 26 3a).
  var RULES_VERSION = '2026-11-02';
  var DEFAULT_DECODER = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/';
  var DEFAULT_TIMEOUT = 10000;
  var DEFAULT_CART_TIMEOUT = 10000;
  var MONEY_SAMPLE_SUBUNITS = '123456789';   // the section renders {{ 123456789 | money }}
  var QUOTE_FLASH_MS = 320;
  var REDIRECT_DELAY_MS = 450;
  var REVIEW_GUARD_MS = 600;     // a second activation this soon after Review Configuration never adds to the cart
  var CART_CHECK_MS = 3000;      // the /cart.js duplicate check before an add, and the bfcache currency check
  var ATTR_BUDGET_MS = 3000;     // SPEC 18a / 18f: the /cart/update.js order label (one retry included) before navigating
  // SPEC 18f (Brent: "Add it to the actual order information"): the visible cart attribute that becomes the order's
  // note_attributes ("Additional details" on the order page). Never the note.
  var ORDER_SOURCE_KEY = 'Order Source';
  var ORDER_SOURCE_VALUE = '24/7 Builder';
  // SPEC 21a: the optional PO Number: visible line property and cart attribute name; letters, digits, space - _ / # .
  var PO_KEY = 'PO Number';
  var PO_CHARS = /^[A-Za-z0-9 \-_\/#.]+$/;
  // SPEC 23f / SPEC 25: the one switch for SCT auto-patching. ON since 2026-10-19 (SCT Patcher v1.1.1 verified, Brent's
  // test flash done): every SCT line goes out autoPatch true with its patcher block (kind sct60 / sct64). Off = "SCT builds by hand".
  var SCT_AUTOPATCH = true;
  // SPEC 24c: link codes are made for AutoCal serials only: 12 digits starting 005 (AutoCal V2) or 006 (AutoCal V3), the
  // keys of Order Flow's config autocal_firmware (it holds any other serial). Change both together.
  var LINK_SERIAL_PREFIXES = ['005', '006'];
  // SPEC 26g: the one switch for HP Tuners auto-building (Peakside L5P Studio). Off = every HP Tuners line goes out
  // autoPatch false "HP Tuners builds by hand" and Order Flow holds it for Brent.
  var HPT_AUTOPATCH = true;
  // SPEC 26f: true = an infolog with no connected E41 ECM block is a field error (Studio refuses those too); false = the line
  // can be bought and goes out autoPatch false "L5P infolog not recognised" (use it if real logs in another format are refused).
  var HPT_INFOLOG_STRICT = true;
  // SPEC 26g: Peakside L5P Studio 1.1.1's nine OS profiles (--inspect-library; README "Fixed L1-L5 profiles"); SOTF exists on
  // all nine. qa/test_247.py spec26 cross-checks this list against the installed Studio. Change both together.
  var HPT_OS_PROFILES = ['12708517', '12709842', '12709843', '12709844', '12718488', '12725870', '12730511', '12730512', '12731638'];
  var HPT_INFOLOG_MAX = 2097152;  // SPEC 26e: 2 MB (a real infolog is ~18.5 KB)
  var HPT_STOCK_MAX = 8388608;    // SPEC 26e: 8 MB (a real L5P stock read is 1.75-1.95 MB)
  var CUMMINS_HPT_STOCK_MAX = 33554432;
  var CUMMINS_HPT_MODES = [{ id: 'CRUISE_SOTF', label: 'Cruise SOTF' }];
  var HPT_NUL_SCAN = 65536;       // SPEC 26e: a NUL in the first 64 KB = not a text infolog
  var HPT_NAME_PROP_MAX = 80;     // SPEC 26e: file names: 80 characters in the visible properties, TEXT_MAX in _247_order
  // SPEC 26i / 3b: the hidden line properties Shopify fills with the uploaded files' /uploads/ URLs (Order Flow reads the
  // same names from its config l5p_hpt.props). One name per file per release; never both these and a fallback.
  var HPT_UPLOAD_KEYS = { infolog: '_247_infolog', stock: '_247_stock_hpt' };
  var DEFAULT_UPLOAD_TIMEOUT = 120000;   // SPEC 26i: data cart.upload_timeout_ms (the multipart add carries ~2 MB)
  var TEXT_MAX = 40;             // maxlength of every text field (serials, E/C, tire, PO): keeps _247_order < 1,000 chars
  var POINTER_HOLD_MS = 2000;    // blur errors wait for the pointer interaction that caused the blur (its click) ...
  var POINTER_CLICK_MS = 400;    // ... or at most this long after pointerup when no click follows

  var T = {
    vinSection: 'Find Your Truck',
    vinLabel: 'Vehicle Identification Number (VIN)',
    vinLabelShort: 'VIN',
    vinPlaceholder: '17-Character VIN',
    vinHelper: 'Use The VIN From Your Truck.',
    vinAction: 'Decode VIN',
    vinBusy: 'Decoding VIN',
    statusEnter: 'Enter Your VIN',
    checkHeading: 'Check Your VIN',
    checkEmpty: 'Enter Your VIN To Continue.',
    checkIoq: 'VINs Never Use The Letters I, O Or Q. Those Are Usually A 1 Or A 0.',
    checkChars: "That VIN Has A Character We Don't Recognise. Check It Against The Door Jamb Sticker.",
    checkDigit: "That VIN Doesn't Pass Its Check Digit. One Character Is Probably Mistyped.",
    checkVpic: 'This VIN Did Not Decode Cleanly. Check It Against The Door Jamb Sticker.',
    found: 'Vehicle Details Found',
    incomplete: 'Vehicle Details Incomplete',
    incompleteEngine: 'We Could Not Confirm The Engine From This VIN.',
    incompleteBasics: 'We Could Not Confirm The Make, Model Or Model Year From This VIN.',
    incompleteSome: 'Some Vehicle Details Could Not Be Confirmed From This VIN.',
    reviewPrompt: 'Review Your Vehicle Details',
    cont: 'Continue',
    editVin: 'Edit VIN',
    retry: 'Try Again',
    errorHeading: 'Unable To Decode VIN',
    errorBody: 'The VIN Lookup Did Not Respond. Your VIN Is Still Entered.',
    yourTruck: 'Your Truck',
    naHeading: 'Configuration Not Available',
    naBody: '24/7 Tuning Does Not Cover This Truck Yet.',
    naUnmapped: 'This Tuning Package Is Not Available To Order Online Right Now.',
    buildTune: 'Build Your Custom Tune',
    shopNow: 'Shop Now',
    manualLegend: 'Select Your Engine',
    manualHelper: 'Choose The Option That Matches Your Truck.',
    manualNone: 'None Of These',
    manualRequired: 'Select Your Engine To Continue.',
    selectedByYou: 'Engine Selected By You',
    deviceHeading: 'Choose Your Tuning Device',
    deviceEfiDesc: 'Choose Single Tune Or Switch On The Fly, Then Enter Your Device And ECM Details.',
    deviceEfiDescCc1318: 'Choose Your Tune Level, Then Enter Your Device And ECM Details.',            // SPEC 24b
    deviceEfiDescCc1921: 'Choose Single Tune Or OBD SOTF, Then Enter Your Device And ECM Details.',    // SPEC 24b
    deviceEzDesc: 'Continue With Your VIN. Your Vehicle Details Carry Through To Checkout.',
    deviceEfiOff2224: 'Not Offered For 2022–2024 Trucks',
    deviceUnavailable: 'Not Available',
    efiCleared: 'EFI Live Details Removed.',
    pathHeading: 'Selected Path',
    pathNextEz: 'Next: Review & Checkout',
    pathNextEfi: 'Next: Configure Your Tune',
    pathVinNote: 'Your Existing VIN Stays With Your Configuration.',
    tuneSection: 'Tune Selection',
    deviceSection: 'Device Details',
    vehicleSection: 'Vehicle Details',
    engineSection: 'Engine Options',
    transSection: 'Transmission Tuning',
    reviewSection: 'Configuration Summary',
    supportSection: 'Support Package',
    tuneType: 'Tune Type',
    tuneLevel: 'Tune Level',
    levelPlaceholder: 'Select A Level',
    serialLabel: 'EFI Live Device Serial Number',
    serialPlaceholder: 'Enter Device Serial Number',
    linkCodes: 'I Need Link Codes',
    ecmSerialLabel: 'ECM Serial Number',
    ecmSerialPlaceholder: 'Enter ECM Serial Number',
    ecmSerialHelper: 'Found On The ECM Sticker',
    // SPEC 15d: E/C Number (Cummins EFI Live, model years 2010-2021)
    ecLabel: 'E/C Number',
    ecPlaceholder: 'Enter E/C Number',
    ecHelper: 'Found On The ECM Sticker',
    errEc: 'Enter The E/C Number From Your ECM Sticker.',
    errEcFormat: 'Use Letters, Numbers, Dots Or Dashes Only.',
    // SPEC 15b: 2006-2007 5.9L Cummins vehicle details
    injectorsLabel: 'Injectors',
    injectorsPlaceholder: 'Select Injectors',
    errInjectors: 'Select Your Injectors.',
    // SPEC 15c: the only AISIN add-on is the 2013-2024 product, so 2007-2012 AISIN trucks get none
    aisinNote: 'AISIN Transmission Tuning Is Available For 2013 And Newer Trucks',
    transClearedAisin: 'Transmission Tuning Removed. AISIN Transmission Tuning Is Available For 2013 And Newer Trucks.',
    fileTypeLabel: 'Transmission Type',
    fileTypePlaceholder: 'Select Transmission Type',
    engineIntro: 'Select The Options That Apply To Your Truck.',
    transToggle: 'Add Transmission Tuning',
    shiftLabel: 'Shift Points',
    shiftPlaceholder: 'Select Shift Points',
    pressureLabel: 'Pressure',
    pressurePlaceholder: 'Select Pressure',
    transClearedManual: 'Transmission Tuning Removed. It Is Not Offered With A Manual Transmission.',
    transClearedBranch: 'Transmission Selections Cleared For The New Transmission Type.',
    transClearedNone: 'Transmission Selections Cleared. Select Your Transmission Type.',   // copy deck 3.12 (PROPOSED, r3)
    gmTransLabel: 'Truck Transmission',
    gmTransPlaceholder: 'Select Transmission',
    tireLabel: 'Tire Diameter',
    tireHelper: 'Default: 33 Inches. Enter Your Current Tire Size.',
    reviewNote: 'Review The Current Price And Selected Options Before Adding Your Tune To The Cart.',
    reviewVehicle: 'Vehicle',
    reviewEngine: 'Engine',
    reviewDevice: 'Tuning Device',
    reviewTrans: 'Transmission Tuning',
    added: 'Added',
    edit: 'Edit',
    notEntered: 'Not Entered',
    notSelected: 'Not Selected',
    noneSelected: 'None Selected',
    notAdded: 'Not Added',
    requested: 'Requested',
    notRequested: 'Not Requested',
    perfHeading: 'Estimated Horsepower',
    perfSotfHeading: 'Power Preview',
    perfSubVehicle: 'Vehicle Preview',
    perfEmptyGain: '+ -- HP',
    perfOver: 'Over Stock',
    perfPending: 'Estimate Pending',
    perfBodyPre: 'Estimates Are Available After The Vehicle And Tune Are Selected.',   // Brent 2026-10-18 (SPEC 20)
    perfBody: 'Estimates Appear When Approved Data Is Available For Your Truck.',
    perfPreviewLabel: 'Preview Level',
    perfPreviewPlaceholder: 'Choose An Available Level',
    perfPreviewHelper: 'Preview Only / Does Not Change Your Package',
    perfStock: 'Stock Power',
    perfTunedPower: 'Tuned Power',
    perfGain: 'Power Gain',
    idleLabel: 'Idle Sound',
    errIdle: 'Select An Idle Sound.',
    perfSource: 'As Listed On The Product Page',
    perfUpTo: 'Up To',
    perfLevels: 'Levels',
    perfEoPending: 'Estimate Pending For The Selected Engine Options',
    // SPEC 17 / 17b: dyno graph (board 5)
    dynoStock: 'Stock',
    dynoSelected: 'Selected Tune',
    dynoTop: 'Top Level',
    dynoTopSub: 'Top Level Preview',
    dynoNote: 'Illustrative Shape Only - Not Vehicle Data',
    dynoTitle: 'Illustrative Dyno Curve: Stock Versus ',
    dynoDesc: 'Illustrative Shape Only, Not Vehicle Data. Estimated Peak Gain ',
    dynoDescEnd: ' As Listed On The Product Page.',
    sumConfig: 'Your Configuration',
    sumOrder: 'Order Summary',
    subtotal: 'Subtotal',
    taxLine: 'Taxes, Discounts And Shipping Are Calculated At Checkout.',
    qAwait: 'Continue To See Price',
    qIncomplete: 'Select Options To See Price',
    qUpdating: 'Updating Price',
    qFailed: 'Price Unavailable',
    ctaReview: 'Review Configuration',
    ctaAdd: 'Add To Cart',
    ctaAddBusy: 'Adding To Cart',
    ctaCheckout: 'Continue To Checkout',
    ctaCheckoutBusy: 'Opening Checkout',
    cartAdded: 'Item Added To Your Cart',
    cartAlready: 'This Configuration Is Already In Your Cart',   // copy deck 3.19 (PROPOSED, r3): nothing was added
    marketChanged: 'Your Cart Currency Has Changed. Reload The Page To See Current Prices.',   // copy deck 3.18 (PROPOSED, r3)
    reloadPage: 'Reload Page',
    cartError: 'There Was An Error While Updating Your Cart. Please Try Again.',
    ctaCheckoutError: 'We Could Not Start Checkout. Please Try Again.',   // copy deck 3.17 ez.cta.error
    cartTimeout: 'The Cart Did Not Respond. Check Your Cart Before Trying Again.',
    ctaHint: 'Complete The Required Fields To Continue.',
    viewCart: 'View Cart',
    checkout: 'Checkout',
    vinIncluded: 'VIN Included',
    readyHeading: 'Ready For Checkout',
    readyVin: 'Your VIN Is Included With Your Tuning Order.',
    readyBody: 'Review Your Tune And Current Price, Then Continue To Checkout.',
    fixFields: 'Complete The Required Fields To Continue.',   // never a visual-only cue (WCAG 1.3.3)
    refHeading: 'Tuning For Your Truck',
    refCta: 'View Tuning Products',
    refStatus: 'Opening Your Matching Collection',
    ecoHeading: 'Browse The Catalog',
    ecoBody: 'There Is No Matching Collection For This EcoDiesel Model Year. Browse All Products In Shop Now.',
    ecoStatus: 'Opening Shop Now',
    subtitleReview: 'Review Your Configuration',
    subtitleEz: 'Your EZ-Lynk Tune',
    dataError: '24/7 Tuning Is Not Available Right Now. Please Reload The Page.',
    errSupport: 'Select A Support Package.',
    errTuneType: 'Select A Tune Type.',
    errLevel: 'Select A Tune Level.',
    errSerial: 'Enter Your EFI Live Device Serial Number.',
    errSerialFormat: 'Use 4 To 20 Letters Or Digits. Spaces And Dashes Are Ignored.',
    errSerialLink: 'Link Codes Need The 12-Digit AutoCal Serial Number, Starting 005 Or 006.',      // SPEC 24c
    errEcm: 'Enter Your ECM Serial Number.',
    errEcmFormat: 'Use Up To 12 Letters Or Digits. Spaces Are Ignored.',
    // SPEC 21c: the GM AISIN Patcher refuses an all-zero ECM serial (EFILive reads it as no serial)
    errEcmZeros: 'That ECM Serial Number Is All Zeros. Check The ECM Sticker.',
    // SPEC 21a: the optional PO Number (Order Details)
    orderSection: 'Order Details',
    poLabel: 'PO Number (Optional)',
    poShort: 'PO Number',
    poPlaceholder: 'Enter PO Number',
    poHelper: 'Shown On Your Order.',
    poNone: 'None',                  // the review's empty optional PO (never "Not Entered", which marks a missing field)
    errPoChars: 'Use Only Letters, Numbers, Spaces And - _ / # .',
    errPoLength: 'Use 40 Characters Or Fewer.',
    errFileType: 'Select Your Transmission Type.',
    errShift: 'Select Shift Points.',
    errPressure: 'Select A Pressure.',
    errTire: 'Enter Your Tire Diameter.',
    errTireFormat: 'Enter A Positive Number With Up To 2 Decimals.',
    errGmTrans: 'Select Your Truck Transmission.',
    // SPEC 19 (GM): drive type from the VIN, or asked; transfer case on a 4x4 (Auto preselected)
    driveLabel: 'Drive Type',
    driveLine: 'Drive: ',
    driveFromVin: ' (From VIN)',
    tcaseLabel: 'Transfer Case',
    errDrive: 'Select Your Drive Type.',
    errTcase: 'Select Your Transfer Case.',
    priceUpdated: 'Price Updated: ',
    // SPEC 13 (L5P EZ-Lynk): the 2017-2018 eligibility gate and the optional Allison transmission add-on
    gateLegend: 'Has This ECM Been Tuned Or Unlocked Before?',
    gateHelp: 'EZ-Lynk Can Only Tune A 2017–2018 L5P If The ECM Has Already Been Unlocked Or Tuned.',
    gateNoTitle: "EZ-Lynk Can't Tune A Locked 2017–2018 L5P",
    errGate: 'Select Yes Or No To Continue.',
    allison: 'Allison Transmission',
    // SPEC 22 (6.0 / 6.4 Powerstroke SCT): level names and option labels come from the product pages
    deviceSctDesc: 'Choose Your Tune Files, Then Enter Your SCT Device Details.',
    sctCleared: 'SCT Details Removed.',
    sctTuningDetails: 'Tune, Device And Strategy Details',
    sctFilesLabel: 'Tune Files',
    sctPowerLabel: 'Power Level',
    sctCountOf: ' Of ',
    sctCountSelected: ' Selected',
    errSctFiles: 'Select At Least One Tune File.',
    errSctPower: 'Select At Least One Power Level.',
    sctCustomQ: 'Custom Request?',
    sctCustomLink: 'Order It On The Product Page',
    sctSotfHelp: 'The SOTF Switch Is Needed To Run SOTF Tunes.',
    sctSerialLabel: 'SCT Device Serial Number',
    sctSerialPlaceholder: 'Enter SCT Device Serial Number',
    sctSerialHelp: 'Exactly 13 Letters Or Numbers, Starting With XP, X4, LT, LX Or BD. Spaces Are Ignored.',   // SPEC 23f
    errSctSerialChars: 'Use Letters And Numbers Only.',
    errSctSerialPrefix: 'SCT Device Serial Numbers Start With XP, X4, LT, LX Or BD.',
    errSctSerial: 'Enter Your SCT Device Serial Number.',
    strategyLabel: 'ECM Strategy',
    strategyPlaceholder: 'Enter ECM Strategy',
    strategyHelp: 'Exactly 7 Letters Or Numbers.',
    errStrategy: 'Enter Your ECM Strategy.',
    errStrategyChars: 'Use Letters And Numbers Only.',
    tcuLabel: 'TCU Strategy',
    tcuPlaceholder: 'Select TCU Strategy',
    errTcu: 'Select Your TCU Strategy.',
    turboLabel: 'Turbo',
    turboPlaceholder: 'Select Turbo',
    errTurbo: 'Select Your Turbo.',
    // SPEC 23 (6.0 SCT): the EBP / MAP sensors the files are built for, and the Non-VGT idle rule
    sensorsLabel: 'Sensors',
    sensorsPlaceholder: 'Select Sensors',
    errSensors: 'Select Your Sensors.',
    idleNonVgt: 'Non-VGT Turbo Files Use Rumble Idle Only.',
    idleForcedRumble: 'Idle Sound Changed To Rumble For The Non-VGT Turbo.',      // SPEC 23c1
    idleRumbleNote: 'Some Trucks Do Not React To The Rumble Idle.',               // SPEC 23c2 (2003-2004, the Excursion)
    // SPEC 23b: 2007.5-2012 6.7L Cummins are ordered on the product pages while the flag is off
    ppHeading: 'Order On The Product Page',
    ppBody: '24/7 Tuning Does Not Build 2007.5–2012 6.7L Cummins Tunes Yet. Order Yours On The Product Pages Below.',
    ppYear: 'Truck Year ',
    ppTcm: '68RFE Transmission Tuning',
    // SPEC 23f (Brent: "If you get an econoline, direct to 6.0 SCT page.")
    ppBodyEseries: '24/7 Tuning Does Not Build 6.0 Powerstroke E-Series Van Tunes. Order Yours On The Product Page Below.',
    ppEseries: '6.0 Powerstroke E-Series Vans',
    // SPEC 23e: 2013-2021 Cummins cab & chassis on EFI Live
    ccSotf: 'OBD SOTF',
    ccHelp: 'Cab And Chassis 2019-2021 Trucks Get Level 1-5 Or OBD SOTF Files.',
    ccHelp1318: 'Cab And Chassis 2013-2018 Trucks Get Level 1-5 Files.',   // Brent: "Remove SOTF option for cab and chassis for 13-18"
    sctManualTitle: 'Injectors Larger Than 330CC Are Built By Hand.',
    sctManualLink: 'Order On The Product Page',
    // SPEC 26 (2017-2023 L5P on HP Tuners)
    deviceHptDesc: 'For HP Tuners MPVI Devices. Upload Your Stock Read. An Infolog Is Optional. Files Are Delivered By Email.',
    hptCleared: 'HP Tuners Details Removed.',
    cumminsHptDesc: 'For HP Tuners MPVI Devices. Upload The Read From This Truck And Enter The Device Serial. ECM Tune Files Are Delivered By Email.',
    cumminsHptReview: 'Unmatched Calibrations Require Manual Review. We Will Contact You If Your Read Needs Review.',
    hptSotfModeLabel: 'SOTF Control',
    errHptSotfMode: 'Select The Supported Cruise SOTF Tune.',
    errCumminsStockBig: 'The HPT Read Must Be 32 MB Or Smaller.',
    hptTuningDetails: 'Tune, Device Serial And Vehicle Files',
    hptLevelLabel: 'Power Level',
    hptFilesSection: 'Vehicle Files',
    hptSerialLabel: 'HP Tuners Device Serial Number',
    hptSerialShort: 'Device S/N',
    hptSerialPlaceholder: 'Enter Device Serial Number',
    hptSerialHelp: '10 Digits. Your Tune File Is Locked To This Device.',
    hptInfologLabel: 'Infolog (.txt) - Optional',
    hptInfologShort: 'Infolog',
    hptInfologHelp: 'Optional: Save A New Infolog In VCM Suite While Connected To This Truck. If Uploaded, It Must Match Your Stock Read.',
    hptStockLabel: 'Stock Read (.hpt) - Required',
    hptStockShort: 'Stock Read',
    hptStockHelp: "The Original Read Of This Truck's ECM, Saved In VCM Editor.",
    hptChoose: 'Choose File',
    hptChange: 'Change',
    hptRemove: 'Remove',
    hptSelected: 'Selected:',
    hptChecking: 'Checking Infolog...',
    hptMatch: 'Infolog Matches This VIN.',
    hptUploading: 'Uploading Your Files...',
    hptUploadFailed: 'Your Files Did Not Upload. Please Try Again.',
    hptUploadTimeout: 'The Upload Timed Out. Check Your Connection And Try Again.',
    errHptSerial: 'Enter Your HP Tuners Device Serial Number.',
    errHptSerialAutocal: 'That Is An EFI Live AutoCal Serial. Enter Your HP Tuners Device Serial Number.',
    errHptSerialVin: 'That Looks Like A VIN. Enter Your HP Tuners Device Serial Number.',
    errHptSerialDigits: 'Use Digits Only.',
    errHptSerialStart: 'HP Tuners Device Serial Numbers Start With 2.',
    errInfologMissing: 'Upload Your Infolog.',
    errInfologHpt: 'This Looks Like A Tune File. Upload The Infolog (.txt) Here.',
    errInfologExt: 'Infologs Are .txt Files Saved By VCM Suite.',
    errFileEmpty: 'This File Is Empty.',
    errInfologBig: 'This File Is Too Large For An Infolog.',
    errInfologNul: 'This Is Not A Text Infolog.',
    errFileRead: 'This File Could Not Be Read. Choose It Again.',
    errInfologNoE41: 'No Connected L5P ECM (E41) Was Found In This Infolog. Save A New Infolog While Connected To This Truck.',
    errStockMissing: 'Upload Your Stock Read.',
    errStockExt: 'Upload The Stock Read Saved By VCM Editor (.hpt File).',
    errStockBig: 'This File Is Too Large For A Stock Read.',
    yes: 'Yes',
    no: 'No'
  };

  var TUNE_TYPES = [{ id: 'single', label: 'Single Tune' }, { id: 'sotf', label: 'Switch On The Fly' }];
  var IDLE_SOUNDS = [{ id: 'hiss', label: 'Hiss' }, { id: 'rumble', label: 'Rumble' }];   // Cummins EFI Live (Brent 2026-10-18)
  var LEVELS = [1, 2, 3, 4, 5];
  var FILE_TYPES = [{ id: '68rfe', label: '68RFE' }, { id: 'aisin', label: 'AISIN' }, { id: 'manual', label: 'Manual' }];
  var PRESSURES = [
    { id: '180psi', label: '180 PSI' }, { id: '200psi', label: '200 PSI' }, { id: '225psi', label: '225 PSI' },
    { id: 'randys', label: "Randy's Transmission" }, { id: 'revmax', label: 'RevMax Transmission' }
  ];
  var SHIFT_POINTS = {
    '68rfe': [{ id: 'standard', label: 'Standard' }, { id: 'raised', label: 'Raised' }, { id: 'high', label: 'High' }],
    aisin: [{ id: 'raised', label: 'Raised' }, { id: 'high', label: 'High' }, { id: 'extra_high', label: 'Extra High' }]
  };
  var ENGINE_OPTIONS = [
    { id: 'lbfHardcut', label: 'LBF / Hardcut', help: 'Add LBF And Hardcut Together As One Option.' },
    { id: 'modifiedVgtTurbo', label: 'Modified VGT Turbo', help: 'Select If Your Truck Has A Modified VGT Turbo.' },
    { id: 'fiveInchIntakeS400Swap', label: '5" Intake / S400 Swap', help: 'One Combined Selection For This Intake / Turbo Setup.' }
  ];
  var EARLY_ENGINE_OPTIONS = [
    { id: 'fiveInchIntake', label: '5" Intake', help: 'Select for the matching 5-inch intake calibration.' },
    { id: 'map10bar', label: '10 Bar MAP Sensor', help: 'Select only when a 10-bar MAP sensor is installed.' },
    { id: 'hardcut4000', label: '4000 RPM Hardcut', help: 'Add the 4000 RPM hardcut limiter.' }
  ];
  var CMD_FAMILIES = {
    CM01: { trans: '68rfe', cc: false }, CM02: { trans: 'manual', cc: false },
    CM11: { trans: '68rfe', cc: false }, CM17: { trans: 'aisin', cc: true },
    CM18: { trans: 'aisin', cc: true }, CM30: { trans: 'manual', cc: true },
    CM32: { trans: '68rfe', cc: false }, CM34: { trans: '68rfe', cc: false },
    CM35: { trans: 'manual', cc: false }
  };
  var GM_TRANS = [{ id: 'automatic', label: 'Automatic' }, { id: 'manual', label: 'Manual' }];   // GM and the 5.9L
  // 5.9L (SPEC 15b) and 2013-2018 Cummins 6.7L EFI Live (SPEC 18c)
  var INJECTORS = [{ id: 'stock', label: 'Stock Injectors' }, { id: 'modified', label: 'Modified Injectors' }];
  var SUPPORT = [{ id: 'limited', label: 'Limited Support' }, { id: 'unlimited', label: 'Unlimited Support' }];
  var YES_NO = [{ id: 'yes', label: 'Yes' }, { id: 'no', label: 'No' }];
  var DEVICES = [{ id: 'efi_live', label: 'EFI Live' }, { id: 'ez_lynk', label: 'EZ-Lynk' }, { id: 'sct', label: 'SCT' },
    { id: 'hp_tuners', label: 'HP Tuners' }];   // SPEC 26: the L5P chooser (EZ-Lynk, HP Tuners)
  var DEFAULT_DEVICES = ['efi_live', 'ez_lynk'];   // the Cummins chooser; a route may list its own (SPEC 22: ford-64)
  var SUPER_DUTY = ['F-250', 'F-350', 'F-450', 'F-550'];
  // SPEC 22 (Brent 2026-10-18). The 6.0 product page's "Tune Selection" values (BCPO checkboxes, page order), without
  // its seventh value "Custom Request (List Below)", which needs the page's free text (a link goes there instead); the
  // 6.4 product page's "Power Level (Single Power Files Only)" values (the page writes "level 3"). Level N = the Nth.
  // SPEC 23i (Brent 2026-10-18: "Ignore performance locked, we only want the 5 power levels"): the five power levels only
  var SCT60_LEVELS = ['HD 12K Tow (0HP)', 'Tow (50HP)', 'Street (75HP)', 'Hot Street (100HP)', 'Performance (150HP)'];
  var SCT64_LEVELS = ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5'];
  var SCT_TURBOS = [
    { id: 'stock_stage1', label: 'Stock / Stage 1 Turbo' }, { id: 'stage2_vgt', label: 'Stage 2 VGT Turbo' },
    { id: 'stage3_vgt', label: 'Stage 3 VGT Turbo' }, { id: 'non_vgt', label: 'Non-VGT Turbo' }
  ];
  // "Larger Than 330CC" is a manual build: the product page, never the cart (Brent: "Larger then that direct to product
  // page for manual building")
  var SCT_INJECTORS = [
    { id: 'stock', label: 'Stock' }, { id: '155_205', label: '155-205CC' }, { id: '225_330', label: '225-330CC' },
    { id: 'over_330', label: 'Larger Than 330CC' }
  ];
  // SPEC 23 (Brent 2026-10-18: "add the selector the all the 6.0 files"; "03/04 will have it too"): the 6.0's EBP / MAP
  // sensors. Every 6.0 SCT file exists for each choice; the id names the sensor modifiers the file carries.
  var SCT_SENSORS = [
    { id: 'stock', label: 'Stock Sensors' }, { id: 'ebp64', label: '6.4 EBP Sensor' },
    { id: 'its100', label: 'ITS 100PSI MAP Sensor' }, { id: 'ebp64_its100', label: '6.4 EBP + ITS 100PSI MAP Sensors' }
  ];
  var SCT_LIMITERS = [{ id: 'standard', label: 'Standard' }, { id: 'hardcut4200', label: '4200 RPM Hardcut' }];
  var SENSORS_DEFAULT = 'stock';   // SPEC 23c3: Stock Sensors preselected (optional: changed only when a sensor is installed)
  function sensorsEbp(id) { return id === 'ebp64' || id === 'ebp64_its100'; }
  function sensorsIts(id) { return id === 'its100' || id === 'ebp64_its100'; }
  // SPEC 23f: the sct60 patcher's turbo ids (its file tree has one Stage 2-3 VGT branch)
  var SCT60_PATCHER_TURBO = { stock_stage1: 'stock_stage1', stage2_vgt: 'stage2_3_vgt', stage3_vgt: 'stage2_3_vgt', non_vgt: 'nonvgt' };
  var SCT_SERIAL_PREFIXES = ['XP', 'X4', 'LT', 'LX', 'BD'];   // SPEC 23f: the CEF builder refuses any other SCT serial
  var TCU_STRATEGIES = [{ id: 'tqjf', label: 'TQJF1-4' }, { id: 'tqje', label: 'TQJE1-4' }, { id: 'manual', label: 'Manual' }];   // "Three choices"
  var SCT_TUNE_TYPES = [{ id: 'single', label: 'Single Files' }, { id: 'sotf', label: 'SOTF (Fuel Temp)' }];
  var SCT_FILES = [/^Single$/, /^2 Files$/, /^3 Files$/, /^4 Files$/, /^5 Files$/];        // 6.0 option "Files"
  var SCT64_FILES = [/^1 File$/, /^2 Files$/, /^3 Files$/, /^4 Files$/, /^5 Files$/];      // 6.4 option "Tune File Type"
  // SPEC 19a / 19b (Brent 2026-10-18: "the gm/chev trucks use a different file"; "If a 4x4 ask if auto tcase or manual,
  // default to auto tcase"). vPIC DriveType -> drive: exactly these values (verified on 2WD LLY / LBZ / LMM / LML / L5P
  // patterns); anything else, blank or missing is unknown and the customer is asked (4x4 / 4x2, no default).
  var DRIVES = [{ id: '4x4', label: '4x4' }, { id: '4x2', label: '4x2' }];
  var TCASES = [{ id: 'auto', label: 'Auto (Push Button)', short: 'Auto' }, { id: 'manual', label: 'Manual (Floor Lever)', short: 'Manual' }];
  var VPIC_DRIVE = { '4wd/4-wheel drive/4x4': '4x4', '4x2': '4x2', 'rwd/rear-wheel drive': '4x2' };
  // GM AISIN Patcher (Desktop\Auto Tune 24-7\Patcher, ENGINES): the model years each Duramax file set covers, and the
  // engines it builds as Allison automatic only (there is no manual LMM / LML file)
  var GM_ENGINES = { LB7: [2001, 2004], LLY: [2004, 2005], LBZ: [2006, 2007], LMM: [2007, 2010], LML: [2011, 2016] };
  var GM_AUTO_ONLY = { LMM: true, LML: true };

  // Routing table: route ids from SPEC section 2, matches from SPEC 12b (resolveRoute below).
  // Products are mapped by handle, variants by title matcher, never by variant id.
  var ROUTES = {
    'eco-14-19': { type: 'catalog_redirect', collection: '2014-2019-3-0-ecodiesel', destTitle: '2014–2019 3.0 EcoDiesel' },
    'eco-other': { type: 'catalog_redirect', page: 'shop_now', fallback: true },
    'ford-73': { type: 'catalog_redirect', collection: '94-03-powerstroke', destTitle: '94–03 Powerstroke' },
    // SPEC 22: only the 6.0s the SCT product does not list (the Excursion, other models / years) still go here
    'ford-60': { type: 'catalog_redirect', collection: '03-07-powerstroke', destTitle: '03–07 Powerstroke' },
    // SPEC 22 (Brent 2026-10-18): 2003-2007 Super Duty and 2003-2010 E-Series 6.0L -> SCT, auto-assigned (SCT only).
    // The number of tune files picked (1-5; SPEC 23i: all five names can be picked) selects the variant.
    'ford-60-sct': {
      type: 'sct', platform: 'ford',
      sct: { kind: '60', handle: '2003-2007-6-0-powerstroke-custom-tuning', levels: SCT60_LEVELS, max: 5, files: SCT_FILES }
    },
    // SPEC 23f (Brent 2026-10-18: "If you get an econoline, direct to 6.0 SCT page."): a 6.0 E-Series van (any year) gets
    // the 6.0 SCT product page, no 24/7 build
    'ford-60-econoline': {
      type: 'product_page', platform: 'ford', ppBody: T.ppBodyEseries,
      pages: [{ role: 'sct60', handle: '2003-2007-6-0-powerstroke-custom-tuning', detail: T.ppEseries }]
    },
    'ford-30': { type: 'ez_lynk', platform: 'ford', ez: '2018-2020-3-0-powerstroke-ez-lynk-support-packages' },
    // SPEC 22 ("6.4 can choose sct or ez"): the device chooser with EZ-Lynk (the package, unchanged) and SCT (single
    // files 1-5, or the SOTF (Fuel Temp) file)
    'ford-64': {
      type: 'device_choice', platform: 'ford', devices: ['ez_lynk', 'sct'], ez: '2008-2010-6-4-powerstroke-ez-lynk-tuning',
      sct: { kind: '64', handle: '2008-2010-powerstroke-sct-custom-tune-files', levels: SCT64_LEVELS, max: 5, files: SCT64_FILES, sotf: /^SOTF \(Fuel Temp\)$/ }
    },
    'ford-67-20-22': { type: 'ez_lynk', platform: 'ford', ez: '2020-2022-6-7-powerstroke-ezlynk-tuning' },
    'ford-67-23-26': { type: 'ez_lynk', platform: 'ford', ez: '2023-2026-6-7-powerstroke-ezlynk-tuning' },
    'ford-67-11-19': { type: 'catalog_redirect', collection: '11-19-powerstroke', destTitle: '11–19 Powerstroke' },
    // SPEC 18c: EFI Live model years 2013-2018 also ask for Injectors (the Master Patcher's DO66 / DO67 injector
    // branch); 2019-2021 has no modified-injector branch, so the field is not shown there.
    'cmns-13-21': {
      // SPEC 23e: ccForm = a cab & chassis VIN gets the cab & chassis EFI Live form (Level 1-5 / OBD SOTF, AISIN add-on)
      type: 'device_choice', platform: 'cummins', ez: '2013-2021-cummins-ezlynk-support-packages', injectors: { from: 2013, to: 2018 }, ccForm: true,
      efi: {
        handle: '2006-2021-cummins-efilive-custom-tune-files',
        byYear: [
          { from: 2013, to: 2018, single: /^2013-2018 \/ Single$/, sotf: /^2013-2018 \/ Switch on the Fly$/i },
          { from: 2019, to: 2021, single: /^2019-2024 \/ Single$/, sotf: /^2019-2024 \/ Switch on the Fly$/i }
        ]
      }
    },
    // SPEC 19c: EZ-Lynk on 2022-2024 also asks for the E/C Number (the live builder's requiresEcmEc)
    'cmns-22-24': {
      type: 'device_choice', platform: 'cummins', devices: ['efi_live', 'ez_lynk', 'hp_tuners'],
      ez: '22-24-6-7-cummins-ezlynk-support-packages', efi: null, efiOffReason: T.deviceEfiOff2224, ezEc: true,
      hpt: { platform: 'cummins_hpt', flag: 'cummins_hpt_22_24', handle: '2022-2024-6-7-cummins-hp-tuners-tune-files', single: /^Single File$/, sotf: /^SOTF File$/ }
    },
    // SPEC 15 (Brent 2026-10-18): EFI Live only, auto-assigned (no EZ-Lynk product for these years).
    // 2007.5-2012 6.7L: the 2013-2021 Cummins form; ECM Serial + E/C Number from model year 2010 (ecmIdsFrom);
    // AISIN transmission tuning is not offered (the only AISIN product is the 2013-2024 one).
    'cmns-07-12': {
      type: 'efi_live', platform: 'cummins', ecmIdsFrom: 2010, noAisinTrans: true,
      efi: {
        handle: '2006-2021-cummins-efilive-custom-tune-files',
        byYear: [
          { from: 2007, to: 2009, single: /^2007-2009 \/ Single$/, sotf: /^2007-2009 \/ Switch on the Fly$/i },
          { from: 2010, to: 2012, single: /^2010-2012 \/ Single$/, sotf: /^2010-2012 \/ Switch on the Fly$/i }
        ]
      }
    },
    // SPEC 23b (Brent 2026-10-18: "remove from the 24/7 tune menu for now and send customers to the product pages for
    // regular ordering"): while flags.cmns_07_12_efi_live is off (data block; section setting), 2007.5-2012 6.7L trucks get
    // links to the product pages instead of the cmns-07-12 form above: the Cummins EFI Live product opened on the truck's
    // Truck Year band (?variant=<that band's Single variant>, never the VIN) and the 68RFE TCM product. No fields, no cart.
    'cmns-07-12-product': {
      type: 'product_page', platform: 'cummins',
      pages: [
        { role: 'tune', handle: '2006-2021-cummins-efilive-custom-tune-files', byYear: [
          { from: 2007, to: 2009, variant: /^2007-2009 \/ Single$/ }, { from: 2010, to: 2012, variant: /^2010-2012 \/ Single$/ }] },
        { role: 'tcm', handle: '2007-5-cummins-efi-live-tcm-tuning', variant: /^Default Title$/ }
      ]
    },
    // 2006-2007 5.9L: tune, device serial, link codes, injectors and transmission type only (SPEC 23a: Stock Injectors
    // are auto-patched, kind cummins59)
    'cmns59-06-07': { type: 'efi_live', platform: 'cummins59', efi: { handle: '2006-2007-5-9-cummins-efi-live-files', single: /^Single File$/, sotf: /^SOTF File$/ } },
    // SPEC 19: every GM route carries the drive type (and the transfer case on a 4x4): drive: true
    'gm-dmax-01-10': { type: 'efi_live', platform: 'gm', drive: true, efi: { handle: '2001-2010-duramax-efi-live-tune-files', single: /^Single Level$/, sotf: /^DSP5 SOTF$/ } },
    'gm-dmax-lml': { type: 'efi_live', platform: 'gm', drive: true, efi: { handle: '2011-2016-lml-duramax-efi-live-tuning', single: /^Single File$/, sotf: /^SOTF File/ } },
    // SPEC 13 (Brent 2026-10-17): 2017-2023 L5P -> EZ-Lynk. The only EZ-Lynk route with an add-on (the optional Allison TCM
    // tune, no shift or pressure inputs) and with the 2017-2018 eligibility gate.
    // SPEC 26 (Brent 2026-10-21): a device choice, EZ-Lynk (every SPEC 13 / 19 key kept) or HP Tuners (hpt: the "No Credits"
    // variants of the HP Tuners L5P product, matched by title; its lines carry platform gm_hpt). flag: the section setting
    // l5p_hp_tuners; off = the route resolves as type ez_lynk, auto-assigned, exactly as before SPEC 26 (resolveRoute).
    // legacyEz: the EZ-Lynk side keeps its pre-SPEC 26 _247_config (no device key), so its lines stay byte-equal.
    'gm-l5p-17-23': {
      type: 'device_choice', devices: ['ez_lynk', 'hp_tuners'], platform: 'gm_ez', drive: true, flag: 'l5p_hp_tuners', legacyEz: true,
      ez: '2017-2023-ezlynk-l5p-tuning',
      addon: { handle: '2017-2019-duramax-ezlynk-tcm-tuning-add-on', variant: /^Default Title$/, forLabel: '24/7 Tuning EZ-Lynk L5P Tune' },
      gateYears: [2017, 2018],
      hpt: { platform: 'gm_hpt', handle: '2017-2023-duramax-mpvi2-mpvi3-tune-files', single: /^Single Tune \(No Credits\)$/, sotf: /^SOTF \(No Credits\)$/ }
    }
  };
  var TRANS_ADDON = {
    '68rfe': { handle: '2007-5-cummins-efi-live-tcm-tuning', variant: /^Default Title$/ },
    aisin: { handle: '2013-2024-aisin-transmission-tuning', variant: /^Default Title$/ }
  };
  var EZ_VARIANTS = { limited: /^Limited/, unlimited: /^Unlimited/ };
  // 12c manual engine resolution (code 14 / missing engine only). Every pick is routed through the same table.
  var MANUAL = {
    ford: [
      { id: 'ford-30', label: '3.0L Powerstroke (F-150)', engine: '3.0L Powerstroke', disp: 3.0, models: ['F-150'] },
      { id: 'ford-60', label: '6.0L Powerstroke', engine: '6.0L Powerstroke', disp: 6.0 },
      { id: 'ford-64', label: '6.4L Powerstroke', engine: '6.4L Powerstroke', disp: 6.4 },
      { id: 'ford-67', label: '6.7L Powerstroke (F-250–F-550)', engine: '6.7L Powerstroke', disp: 6.7, models: SUPER_DUTY },
      { id: 'ford-73', label: '7.3L Powerstroke Diesel', engine: '7.3L Powerstroke', disp: 7.3 }
    ],
    ram: [
      { id: 'ram-67', label: '6.7L Cummins', engine: '6.7L Cummins', disp: 6.7 },
      { id: 'ram-59', label: '5.9L Cummins', engine: '5.9L Cummins', disp: 5.9 },   // SPEC 15a: routes for 2006-2007 only
      { id: 'ram-30', label: '3.0L EcoDiesel (Ram 1500)', engine: '3.0L EcoDiesel', disp: 3.0, models: ['1500'] }
    ],
    gm: [
      { id: 'gm-0110', label: '6.6L Duramax LB7, LLY, LBZ Or LMM (Silverado / Sierra)', engine: '6.6L Duramax', rpo: 'LMM', from: 2001, to: 2010 },
      { id: 'gm-lml', label: '6.6L Duramax LML (Silverado / Sierra)', engine: '6.6L Duramax LML', rpo: 'LML', from: 2011, to: 2016 }
    ]
  };

  /* =========================================================================
     2. Small helpers
     ========================================================================= */
  function str(v) { return v == null ? '' : String(v).trim(); }
  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function pad2(n) { return n < 10 ? '0' + n : String(n); }
  function findBy(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function labelOf(list, id) { var o = findBy(list, id); return o ? o.label : ''; }
  function titleWord(w) { return w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w; }
  function titleCase(s) { return String(s || '').split(/(\s+|-|\/)/).map(function (p) { return /^[A-Za-z]/.test(p) ? titleWord(p) : p; }).join(''); }
  function joinRoot(root, path) {
    var r = String(root || '/');
    if (r.slice(-1) !== '/') r += '/';
    return r + String(path || '').replace(/^\/+/, '');
  }
  function reducedMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

  /* =========================================================================
     3. VIN (SPEC 12a): trim + uppercase only, 17 chars, [A-HJ-NPR-Z0-9], check digit
     ========================================================================= */
  var VIN_TRANSLIT = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
  var VIN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

  function normVin(raw) { return str(raw).toUpperCase(); }

  function vinCheckDigitOk(vin) {
    if (typeof vin !== 'string' || vin.length !== 17) return false;
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      var c = vin.charAt(i);
      var n = /[0-9]/.test(c) ? Number(c) : VIN_TRANSLIT[c];
      if (n === undefined) return false;
      sum += n * VIN_WEIGHTS[i];
    }
    var rem = sum % 11;
    return vin.charAt(8) === (rem === 10 ? 'X' : String(rem));
  }

  function vinProblem(vin) {
    if (!vin) return { code: 'empty', message: T.checkEmpty };
    if (vin.length !== 17) return { code: 'length', message: 'A VIN Is 17 Characters. This One Has ' + vin.length + '.' };
    if (/[IOQ]/.test(vin)) return { code: 'ioq', message: T.checkIoq };
    if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) return { code: 'chars', message: T.checkChars };
    if (!vinCheckDigitOk(vin)) return { code: 'checkdigit', message: T.checkDigit };
    return null;
  }

  /* =========================================================================
     4. vPIC result -> identity -> route (SPEC 12a-12c)
     ========================================================================= */
  var CHECK_CODES = { '1': 1, '3': 1, '4': 1, '6': 1, '7': 1, '11': 1, '400': 1 };

  // 'ok' only for exactly ["0"]; 1/3/4/6/7/11/400 -> check_vin; 14 alone or with 0 -> incomplete; anything else
  // (unknown codes) is never routed and is treated as check_vin.
  function gateCodes(errorCode) {
    var codes = str(errorCode).split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    if (codes.length === 1 && codes[0] === '0') return 'ok';
    var i;
    for (i = 0; i < codes.length; i++) if (CHECK_CODES[codes[i]]) return 'check_vin';
    if (codes.length && codes.indexOf('14') >= 0) {
      var only = true;
      for (i = 0; i < codes.length; i++) if (codes[i] !== '0' && codes[i] !== '14') only = false;
      if (only) return 'incomplete';
    }
    return 'check_vin';
  }

  // SPEC 19a: vPIC DriveType -> '4x4' | '4x2', or null for anything else (blank, missing, any other value)
  function driveFromVpic(v) {
    var k = str(v).toLowerCase();
    return Object.prototype.hasOwnProperty.call(VPIC_DRIVE, k) ? VPIC_DRIVE[k] : null;
  }

  function buildIdentity(r) {
    r = r || {};
    var yearStr = str(r.ModelYear);
    var n = parseFloat(str(r.DisplacementL));
    var engineModel = str(r.EngineModel);
    var m = /\b(LB7|LLY|LBZ|LMM|LML|LGH|L5P)\b/i.exec(engineModel);
    var fuel = str(r.FuelTypePrimary);
    var make = str(r.Make).toUpperCase();
    // SPEC 24d: vPIC answers FuelTypePrimary "Gasoline" for the 2004 F-450 and 2003-2004 F-550 6.0L, which name Navistar
    // as the engine maker. Navistar only built diesels for Ford (Ford's gas engines name Ford), so a FORD whose
    // EngineManufacturer, EngineModel or OtherEngineInfo names Navistar is diesel.
    var navistar = make === 'FORD' && /navistar/i.test([r.EngineManufacturer, r.EngineModel, r.OtherEngineInfo].map(str).join(' '));
    return {
      make: make,
      model: str(r.Model),
      year: /^\d{4}$/.test(yearStr) ? parseInt(yearStr, 10) : null,
      disp: isFinite(n) ? Math.round(n * 10) / 10 : null,
      fuel: fuel,
      diesel: /diesel/i.test(fuel) || navistar,
      engineModel: engineModel,
      engineMfr: str(r.EngineManufacturer),
      rpo: m ? m[1].toUpperCase() : null,
      drive: driveFromVpic(r.DriveType),          // SPEC 19a: '4x4' | '4x2' | null (unknown: asked on GM routes)
      series: str(r.Series),
      bodyClass: str(r.BodyClass)
    };
  }

  function makeGroup(make) {
    if (make === 'RAM' || make === 'DODGE') return 'ram';
    if (make === 'FORD') return 'ford';
    if (make === 'CHEVROLET' || make === 'GMC') return 'gm';
    return 'other';
  }

  function manualOptions(identity) {
    var g = makeGroup(identity && identity.make);
    return MANUAL[g] ? MANUAL[g].slice() : [];
  }

  // identify(Results[0]) -> { status: found | incomplete | check_vin | error, identity, reason, manualAllowed }
  function identify(r) {
    if (!r || typeof r !== 'object' || !Object.prototype.hasOwnProperty.call(r, 'ErrorCode')) return { status: 'error' };
    var gate = gateCodes(r.ErrorCode);
    var id = buildIdentity(r);
    if (gate === 'check_vin') return { status: 'check_vin', identity: id };
    var group = makeGroup(id.make);
    var manualAllowed = !!(id.make && id.year && MANUAL[group]);
    if (gate === 'incomplete') return { status: 'incomplete', identity: id, reason: 'code14', manualAllowed: manualAllowed };
    if (!id.make || !id.model || !id.year) return { status: 'incomplete', identity: id, reason: 'basics', manualAllowed: manualAllowed };
    if ((group === 'ram' || group === 'ford') && (!id.fuel || id.disp === null)) return { status: 'incomplete', identity: id, reason: 'engine', manualAllowed: manualAllowed };
    if (group === 'gm' && !id.engineModel) return { status: 'incomplete', identity: id, reason: 'engine', manualAllowed: manualAllowed };
    return { status: 'found', identity: id };
  }

  function rule(id, extra) {
    var def = ROUTES[id];
    var res = { id: id, type: def.type };
    if (def.reason) res.reason = def.reason;
    if (extra) for (var k in extra) res[k] = extra[k];
    return res;
  }
  function notAvailable(reason, links) {
    return { id: 'unresolved', type: 'unresolved', reason: reason, links: links || ['build_your_tune', 'shop_now'] };
  }

  // SPEC 23b: the page's switches, from the data block's flags (the section settings); a flag the data block does not name
  // takes its section setting's default (SPEC 26: l5p_hp_tuners defaults to on)
  var FLAG_DEFAULTS = { cmns_07_12_efi_live: false, l5p_hp_tuners: true, cummins_hpt_22_24: false };
  function flagOn(flags, k) {
    return flags && Object.prototype.hasOwnProperty.call(flags, k) ? flags[k] === true : FLAG_DEFAULTS[k] === true;
  }

  // SPEC 12b, first match wins. GM never depends on FuelTypePrimary / DisplacementL. No VIN-position fallback.
  // flags (optional): the data block's flags (SPEC 23b cmns_07_12_efi_live); missing = every flag off.
  function resolveRoute(id, pickId, flags) {
    if (!id) return notAvailable('incomplete');
    if (pickId) return resolveManual(id, pickId, flags);
    var y = id.year;
    var yr = function (a, b) { return y !== null && y >= a && y <= b; };
    var group = makeGroup(id.make);
    if (!id.make || !id.model || !y) return notAvailable('incomplete');
    if (group === 'ram') {
      if (id.diesel && id.model === '1500' && id.disp === 3.0) return yr(2014, 2019) ? rule('eco-14-19') : rule('eco-other');
      if (id.diesel && id.disp === 6.7) {
        if (yr(2013, 2021)) return rule('cmns-13-21');
        if (yr(2022, 2024)) return rule('cmns-22-24');
        // SPEC 15a: the 2007.5 trucks decode as 2007 with 6.7. SPEC 23b: the EFI Live form only while the flag is on;
        // otherwise the product pages
        if (yr(2007, 2012)) return rule(flagOn(flags, 'cmns_07_12_efi_live') ? 'cmns-07-12' : 'cmns-07-12-product');
        return notAvailable('cummins_year');
      }
      // SPEC 15a: 5.9L 2006-2007 -> EFI Live; any other 5.9L year has Build Your Custom Tune only
      if (id.diesel && id.disp === 5.9) return yr(2006, 2007) ? rule('cmns59-06-07') : notAvailable('cummins_59', ['build_your_tune']);
      return notAvailable('ram_other');
    }
    if (group === 'ford') {
      if (!id.diesel || id.disp === null || /cummins/i.test(id.engineMfr)) return notAvailable('ford_guard');
      var sd = SUPER_DUTY.indexOf(id.model) >= 0;
      if (id.model === 'F-150' && id.disp === 3.0 && yr(2018, 2020)) return rule('ford-30');
      if (id.disp === 7.3) return rule('ford-73');
      // SPEC 22a: the 6.0 SCT product covers "2003 - 2007 ... F - Series" and "2003 - 2010 ... E - Series" (vPIC Model
      // F-250..F-550 / E-350, E-450); any other 6.0 (the Excursion) keeps the collection, never a nearby product
      // SPEC 23f: a 6.0 E-Series / Econoline van (any year) -> the 6.0 SCT product page; 2003-2007 Super Duty (2003-2004
      // FSM8, 2005-2007 TTP1) and the Excursion (any year, FSM8) -> the 6.0 SCT (SPEC 23c4 added the Excursion)
      if (id.disp === 6.0 && (/^E-\d{3}/.test(id.model) || /econoline/i.test(id.model) || /econoline/i.test(id.series))) return rule('ford-60-econoline');
      if (id.disp === 6.0 && ((sd && yr(2003, 2007)) || id.model === 'Excursion')) return rule('ford-60-sct');
      if (id.disp === 6.0) return rule('ford-60');
      if (id.disp === 6.4 && yr(2008, 2010)) return rule('ford-64');
      if (id.disp === 6.7 && sd) {
        if (yr(2020, 2022)) return rule('ford-67-20-22');
        if (yr(2023, 2026)) return rule('ford-67-23-26');
        if (yr(2011, 2019)) return rule('ford-67-11-19');
      }
      return notAvailable('ford_other');
    }
    if (group === 'gm') {
      if (!id.rpo) return notAvailable('gm_other');
      if (!/^(silverado|sierra)\b/i.test(id.model)) return notAvailable('gm_model');
      if (['LB7', 'LLY', 'LBZ', 'LMM'].indexOf(id.rpo) >= 0) return rule('gm-dmax-01-10');
      if (id.rpo === 'LML') return rule('gm-dmax-lml');
      // SPEC 13: L5P 2017-2023 -> EZ-Lynk; 2024+ has no EZ-Lynk product (Build Your Custom Tune only). LGH stays out.
      // SPEC 26a: the EZ-Lynk / HP Tuners chooser while flags.l5p_hp_tuners is on; off = EZ-Lynk auto-assigned, as before
      if (id.rpo === 'L5P') {
        if (!yr(2017, 2023)) return notAvailable('gm_l5p_year', ['build_your_tune']);
        return flagOn(flags, ROUTES['gm-l5p-17-23'].flag) ? rule('gm-l5p-17-23') : rule('gm-l5p-17-23', { type: 'ez_lynk' });
      }
      return notAvailable('gm_engine');
    }
    return notAvailable('no_rule');
  }

  // GM manual pick -> the RPOs that pick stands for (a decoded RPO outside the family is a conflict).
  var MANUAL_GM_FAMILY = { 'gm-0110': ['LB7', 'LLY', 'LBZ', 'LMM'], 'gm-lml': ['LML'] };

  // A manual pick never skips the table and never overrides what the decode did return: it fills in only the
  // missing engine data, keeps the decoded make, year, model, fuel, displacement, RPO and EngineManufacturer, and
  // routes that. A pick that contradicts any decoded engine field (a gasoline fuel, another displacement, another
  // GM engine) is a conflict and stays unresolved (SPEC 2a / 12b). GM picks also keep SPEC 2's year ranges.
  function resolveManual(id, pickId, flags) {
    if (pickId === 'none') return notAvailable('manual_none');
    var group = makeGroup(id.make);
    var opt = findBy(MANUAL[group] || [], pickId);
    if (!opt || !id.year) return notAvailable('manual_invalid');
    var res;
    if (group === 'gm') {
      var fam = MANUAL_GM_FAMILY[opt.id] || [];
      if (id.rpo ? fam.indexOf(id.rpo) < 0 : !!id.engineModel) res = notAvailable('manual_conflict');
      else if (id.model && !/^(silverado|sierra)\b/i.test(id.model)) res = notAvailable('gm_model');
      else if (id.year < opt.from || id.year > opt.to) res = notAvailable('manual_year');
      else {
        var rpo = id.rpo || opt.rpo;
        res = resolveRoute({ make: id.make, model: id.model || 'Silverado', year: id.year, disp: 6.6, fuel: 'Diesel', diesel: true, engineModel: id.engineModel || rpo, engineMfr: id.engineMfr, rpo: rpo }, null, flags);
      }
    } else if ((id.fuel && !id.diesel) || (id.disp !== null && id.disp !== opt.disp)) {
      res = notAvailable('manual_conflict');
    } else {
      // Rules ford-60 / ford-64 / ford-73 and ram-67 never look at Model, so a blank decoded Model gets a neutral
      // placeholder; picks whose rule does depend on Model (3.0L F-150, 6.7L Super Duty, EcoDiesel 1500) carry it.
      var model = id.model || (opt.models ? opt.models[0] : (group === 'ford' ? 'F-Series' : 'Ram'));
      res = resolveRoute({ make: id.make, model: model, year: id.year, disp: opt.disp, fuel: id.fuel || 'Diesel', diesel: true, engineModel: id.engineModel, engineMfr: id.engineMfr, rpo: null }, null, flags);
    }
    res.manual = opt.id;
    return res;
  }

  function displayMake(make) {
    var map = { RAM: 'Ram', DODGE: 'Dodge', FORD: 'Ford', CHEVROLET: 'Chevrolet', GMC: 'GMC', GM: 'GM', JEEP: 'Jeep' };   // SPEC 24e: GM
    return map[make] || titleCase(make);
  }

  function engineLabel(id, pickId) {
    if (!id) return '';
    if (pickId && pickId !== 'none') {
      var opt = findBy(manualOptions(id), pickId);
      if (opt) return opt.engine;
    }
    var g = makeGroup(id.make);
    if (g === 'gm' && id.rpo) return '6.6L Duramax ' + id.rpo;
    if (id.disp === null) return '';
    var ds = id.disp.toFixed(1) + 'L';
    if (g === 'ram' && id.diesel && (id.disp === 6.7 || id.disp === 5.9)) return ds + ' Cummins';
    if (g === 'ram' && id.diesel && id.disp === 3.0 && id.model === '1500') return ds + ' EcoDiesel';
    if (g === 'ford' && id.diesel) return /cummins/i.test(id.engineMfr) ? ds + ' Cummins' : ds + ' Powerstroke';
    return id.fuel ? ds + ' ' + titleCase(id.fuel) : ds;
  }

  function vehicleTitle(id) {
    if (!id) return '';
    return [id.year || '', displayMake(id.make), id.model].filter(Boolean).join(' ');
  }

  // Cart "Vehicle" property, as in SPEC 5: "2017 RAM 2500 6.7L Cummins" (decoded Make as returned by vPIC).
  function vehicleProperty(id, pickId) {
    if (!id) return '';
    return [id.year || '', id.make, id.model, engineLabel(id, pickId)].filter(Boolean).join(' ');
  }

  /* =========================================================================
     5. Catalog mapping (SPEC 3): handle + title matcher -> exactly one variant
     ========================================================================= */
  function resolveVariant(catalog, handle, re) {
    var p = catalog ? catalog[handle] : null;
    if (!p || !p.variants || !p.variants.length) return { ok: false, error: 'missing_product', handle: handle };
    var m = p.variants.filter(function (v) { return re.test(String(v.title)); });
    if (m.length !== 1) return { ok: false, error: m.length ? 'ambiguous' : 'no_match', handle: handle, product: p };
    var v = m[0];
    if (!v.available) return { ok: false, error: 'unavailable', handle: handle, product: p, variant: v };
    var priceOk = typeof v.price === 'number' && isFinite(v.price) && v.price >= 0;
    return { ok: true, handle: handle, product: p, variant: v, priceOk: priceOk };
  }

  function efiDefFor(routeId, year) {
    var def = ROUTES[routeId];
    if (!def || !def.efi) return null;
    if (!def.efi.byYear) return { handle: def.efi.handle, single: def.efi.single, sotf: def.efi.sotf };
    for (var i = 0; i < def.efi.byYear.length; i++) {
      var b = def.efi.byYear[i];
      if (year >= b.from && year <= b.to) return { handle: def.efi.handle, single: b.single, sotf: b.sotf };
    }
    return null;
  }

  // Everything a route can sell, resolved against the catalog. Brent/SPEC 3: a missing or unavailable mapped
  // variant makes that offer (and, when nothing is left, the route) Configuration Not Available.
  function routeOffer(routeId, identity, data) {
    var def = ROUTES[routeId];
    var catalog = (data && data.catalog) || {};
    var off = { efi: null, ez: null, sct: null, hpt: null, trans: {}, addon: null, dest: null, pages: null, efiOffReason: def && def.efiOffReason || '' };
    if (!def) return off;
    if (def.ez) {
      var lim = resolveVariant(catalog, def.ez, EZ_VARIANTS.limited);
      var unl = resolveVariant(catalog, def.ez, EZ_VARIANTS.unlimited);
      off.ez = { handle: def.ez, limited: lim, unlimited: unl, ok: lim.ok && unl.ok, product: catalog[def.ez] || null };
    }
    // an unavailable add-on only disables its checkbox; the support package itself stays orderable
    if (def.addon) off.addon = resolveVariant(catalog, def.addon.handle, def.addon.variant);
    // SPEC 22: the SCT files product, one variant per file count (1-5) and the 6.4's SOTF file; the offer is only
    // orderable when every mapped variant resolves (a count could otherwise price as a nearby variant)
    if (def.sct) {
      var sfiles = def.sct.files.map(function (re) { return resolveVariant(catalog, def.sct.handle, re); });
      var ssotf = def.sct.sotf ? resolveVariant(catalog, def.sct.handle, def.sct.sotf) : null;
      off.sct = {
        handle: def.sct.handle, files: sfiles, sotf: ssotf, product: catalog[def.sct.handle] || null,
        ok: sfiles.every(function (r) { return r.ok; }) && (!ssotf || ssotf.ok)
      };
    }
    // SPEC 26a: the HP Tuners product's Single Tune / SOTF "No Credits" variants, by title; both must resolve, otherwise the HP
    // Tuners card is disabled (Not Available) and EZ-Lynk stays selectable
    if (def.hpt && (!def.hpt.flag || flagOn(data && data.flags, def.hpt.flag))) {
      var hs = resolveVariant(catalog, def.hpt.handle, def.hpt.single);
      var hf = resolveVariant(catalog, def.hpt.handle, def.hpt.sotf);
      off.hpt = { handle: def.hpt.handle, single: hs, sotf: hf, ok: hs.ok && hf.ok, product: catalog[def.hpt.handle] || null };
    }
    var e = efiDefFor(routeId, identity ? identity.year : null);
    if (e) {
      var s = resolveVariant(catalog, e.handle, e.single);
      var f = resolveVariant(catalog, e.handle, e.sotf);
      off.efi = { handle: e.handle, single: s, sotf: f, ok: s.ok && f.ok };
    }
    if (def.platform === 'cummins') {
      off.trans['68rfe'] = resolveVariant(catalog, TRANS_ADDON['68rfe'].handle, TRANS_ADDON['68rfe'].variant);
      // SPEC 15c: no AISIN add-on for 2007-2012 (the only AISIN product covers 2013-2024)
      if (!def.noAisinTrans) off.trans.aisin = resolveVariant(catalog, TRANS_ADDON.aisin.handle, TRANS_ADDON.aisin.variant);
    }
    if (def.pages) off.pages = productPages(def, identity, catalog);   // SPEC 23b
    if (def.type === 'catalog_redirect') {
      var links = (data && data.links) || {};
      if (def.collection) off.dest = (links.collections && links.collections[def.collection]) || null;
      else if (def.page) off.dest = links[def.page] || null;
    }
    return off;
  }

  // SPEC 23b: the product page links of a product_page route, in order: [{role, handle, title, url, variant, detail}].
  // The tune link opens the product on the truck's Truck Year band (?variant=<the band's Single variant id>; a variant
  // that does not resolve opens the plain product); a product missing from the catalog is left out. URLs carry only the
  // variant id, never the VIN or any other customer data.
  function productPages(def, identity, catalog) {
    var y = identity ? identity.year : null, out = [];
    (def.pages || []).forEach(function (pg) {
      var p = catalog ? catalog[pg.handle] : null;
      if (!p || !p.url) return;
      var re = pg.variant || null;
      if (pg.byYear) {
        re = null;
        pg.byYear.forEach(function (b) { if (y != null && y >= b.from && y <= b.to) re = b.variant; });
      }
      var v = re ? resolveVariant(catalog, pg.handle, re) : null;
      var url = String(p.url), variant = v && v.ok ? v.variant : null;
      if (variant && p.variants && p.variants.length > 1) url += (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + encodeURIComponent(variant.id);
      var detail = pg.detail || (pg.role === 'tune' ? (variant ? T.ppYear + String(variant.title).split(' / ')[0] : '') : T.ppTcm);
      out.push({ role: pg.role, handle: pg.handle, title: p.title, url: url, variant: variant ? variant.id : null, detail: detail });
    });
    return out;
  }

  /* =========================================================================
     6. Form state, cleanup reducers (handoff "Conditional State And Cleanup")
     ========================================================================= */
  function emptyForm(platform) {
    return {
      supportPackage: null,
      tuneType: null, tuneLevel: null, idleSound: null,
      deviceSerial: '', linkCodesRequested: false,
      ecmEc: '', ecmSerial: '', ecmFileType: null,
      engineOptions: { lbfHardcut: false, modifiedVgtTurbo: false, fiveInchIntakeS400Swap: false },
      transTuning: false, transPressure: null, shiftPoints: null,
      tireDiameter: platform === 'gm' ? '33' : '',
      truckTransmission: null,       // GM Truck Transmission; the 5.9L Transmission Type (SPEC 15b)
      injectors: null,               // 5.9L (SPEC 15b) and 2013-2018 Cummins 6.7L EFI Live (SPEC 18c)
      ecmUnlocked: null, ezTransTuning: false,    // SPEC 13 L5P EZ-Lynk only: eligibility gate + Allison add-on
      // SPEC 19 (GM routes): driveType is the customer's answer, used only when the VIN gave no drive; tcase counts
      // only on a 4x4 and starts on Auto ("default to auto tcase")
      driveType: null, tcase: (platform === 'gm' || platform === 'gm_ez') ? 'auto' : null,
      poNumber: '',                  // SPEC 21a: optional PO Number (every route that adds to the cart)
      // SPEC 22 SCT (6.0 / 6.4 Powerstroke): the picked level numbers (1-based, ascending), the SCT serial, the 6.0's
      // ECM strategy / turbo / injectors (truckTransmission is its Transmission Type), the 6.4's TCU strategy, Non-VGT;
      // SPEC 23: the 6.0's sensors (its Idle Sound is idleSound above)
      // (SPEC 23d: the 6.4 Non-VGT checkbox is gone; the 6.0's Non-VGT is its turbo choice)
      sctLevels: [], sctSerial: '', ecmStrategy: '', sctTurbo: null, sctInjectors: null, tcuStrategy: null,
      sctSensors: SENSORS_DEFAULT, sctLimiter: 'standard',   // SPEC 23c3: Stock Sensors preselected (only the 6.0 SCT reads it)
      // SPEC 26 HP Tuners: the device serial as typed (tuneType / tuneLevel above are shared). The two files live outside the
      // form (app state S.files: File objects cannot be cloned or stored); ctx.files carries their metadata only.
      hptSerial: ''
    };
  }
  function cloneForm(f) {
    var c = {};
    for (var k in f) if (Object.prototype.hasOwnProperty.call(f, k)) c[k] = f[k];
    c.engineOptions = {};
    Object.keys(f.engineOptions).forEach(function (key) { c.engineOptions[key] = !!f.engineOptions[key]; });
    c.sctLevels = Array.isArray(f.sctLevels) ? f.sctLevels.slice() : [];
    return c;
  }
  function efiHasInput(f) {
    return !!(f.tuneType || f.tuneLevel || f.idleSound || f.deviceSerial || f.ecmEc || f.ecmSerial || f.ecmFileType || f.linkCodesRequested || f.transTuning ||
      ENGINE_OPTIONS.concat(EARLY_ENGINE_OPTIONS).some(function (o) { return f.engineOptions[o.id]; }) || f.truckTransmission || f.injectors);
  }
  function sctHasInput(f) {
    return !!(f.tuneType || (f.sctLevels && f.sctLevels.length) || f.sctSerial || f.ecmStrategy || f.sctTurbo || f.sctInjectors ||
      f.tcuStrategy || f.truckTransmission || f.idleSound || (f.sctLimiter && f.sctLimiter !== 'standard') || (f.sctSensors && f.sctSensors !== SENSORS_DEFAULT));
  }
  // SPEC 26l: the HP Tuners inputs a device switch clears (files: ctx.files-style metadata {infolog, stock}, either may be null)
  function hptHasInput(f, files) {
    return !!(f.tuneType || f.tuneLevel || f.hptSerial || (files && (files.infolog || files.stock)));
  }

  var PRICE_FIELDS = { supportPackage: 1, tuneType: 1, tuneLevel: 1, linkCodesRequested: 1, idleSound: 1, ecmFileType: 1, transTuning: 1, transPressure: 1, shiftPoints: 1, truckTransmission: 1, injectors: 1, engineOption: 1, ecmUnlocked: 1, ezTransTuning: 1, driveType: 1, tcase: 1,
    sctLevels: 1, sctTurbo: 1, sctInjectors: 1, tcuStrategy: 1, sctSensors: 1, sctLimiter: 1 };   // SPEC 22, SPEC 23

  // SPEC 22: the picked SCT level numbers that are valid for the route's level list, unique, ascending, capped at its
  // max (5 files); sd = the route's sct definition
  function sctLevelsOf(f, sd) {
    var n = sd ? sd.levels.length : 0, seen = {}, out = [];
    ((f && f.sctLevels) || []).forEach(function (x) {
      var k = parseInt(x, 10);
      if (k >= 1 && k <= n && !seen[k]) { seen[k] = 1; out.push(k); }
    });
    out.sort(function (a, b) { return a - b; });
    return out.slice(0, sd ? sd.max : 0);
  }
  function sctLevelLabels(levels, sd) {
    return (levels || []).map(function (k) { return sd && sd.levels[k - 1] ? sd.levels[k - 1] : ''; }).filter(Boolean);
  }

  // Pure: one field change plus its cleanup. cur = { form, previewLevelId }. rules (optional) = { noAisinTrans }:
  // the route offers no AISIN transmission tuning (SPEC 15c, 2007-2012 6.7L).
  function applyField(cur, field, value, rules) {
    var noAisin = !!(rules && rules.noAisinTrans);
    var cc = !!(rules && rules.cabChassis);             // SPEC 23e: a cab & chassis form has no 68RFE add-on
    var noSotf = !!(rules && rules.noSotf);             // SPEC 23e: a 2013-2018 cab & chassis has no SOTF
    var sd = rules && rules.sct ? rules.sct : null;      // SPEC 22: the route's SCT definition (level list, max, kind)
    var f = cloneForm(cur.form);
    var preview = cur.previewLevelId == null ? null : cur.previewLevelId;
    var notice = null;
    switch (field) {
      case 'tuneType':
        if (value !== 'single' && value !== 'sotf') value = null;
        if (value === 'sotf' && noSotf) value = null;    // SPEC 23e: never a SOTF on a 2013-2018 cab & chassis
        if (value !== 'single') { f.tuneLevel = null; f.sctLevels = []; }   // Single -> SOTF: clear the single purchase level(s)
        // the preview level survives only while the tune stays SOTF (SOTF -> Single clears it; so does a 6.4 SCT
        // Single Files preview when the type changes)
        if (!(value === 'sotf' && f.tuneType === 'sotf')) preview = null;
        f.tuneType = value;
        break;
      case 'sctLevels':
        // SPEC 22: one level checkbox {id, on}. At most sd.max picked (the "5 Files" variant); the 6.4 picks single
        // files only. A preview level that is no longer picked (or the last but one) is dropped.
        if (sd && value && (sd.kind !== '64' || f.tuneType === 'single')) {
          var lk = parseInt(value.id, 10), picked = sctLevelsOf(f, sd);
          if (lk >= 1 && lk <= sd.levels.length) {
            if (value.on && picked.indexOf(lk) < 0 && picked.length < sd.max) picked.push(lk);
            if (!value.on) picked = picked.filter(function (x) { return x !== lk; });
          }
          f.sctLevels = sctLevelsOf({ sctLevels: picked }, sd);
          if (f.tuneType !== 'sotf' && preview != null && (f.sctLevels.length < 2 || f.sctLevels.indexOf(Number(preview)) < 0)) preview = null;
        }
        break;
      case 'sctSerial': case 'ecmStrategy': case 'hptSerial':        // SPEC 26d: hptSerial stored as typed
        f[field] = value == null ? '' : String(value);
        break;
      case 'sctTurbo':
        f.sctTurbo = findBy(SCT_TURBOS, value) ? value : null;
        // SPEC 23c1: Non-VGT turbo files exist with Rumble idle only: Non-VGT sets Rumble (and says so when it was Hiss)
        if (sd && sd.kind === '60' && f.sctTurbo === 'non_vgt' && f.idleSound !== 'rumble') {
          if (f.idleSound === 'hiss') notice = { section: 'vehdetails', text: T.idleForcedRumble };
          f.idleSound = 'rumble';
        }
        break;
      case 'sctInjectors':
        f.sctInjectors = findBy(SCT_INJECTORS, value) ? value : null;
        break;
      case 'sctLimiter':
        f.sctLimiter = findBy(SCT_LIMITERS, value) ? value : null;
        break;
      case 'sctSensors':                                            // SPEC 23c3
        f.sctSensors = findBy(SCT_SENSORS, value) ? value : null;
        break;
      case 'tcuStrategy':
        f.tcuStrategy = findBy(TCU_STRATEGIES, value) ? value : null;
        break;
      case 'tuneLevel':
        var n = parseInt(value, 10);
        f.tuneLevel = (f.tuneType === 'single' && n >= 1 && n <= 5) ? n : null;
        break;
      case 'ecmFileType':
        if (!findBy(rules && rules.fileTypes || FILE_TYPES, value)) value = null;
        if (value !== f.ecmFileType) {
          var had = f.transTuning || f.transPressure || f.shiftPoints;
          f.transTuning = false; f.transPressure = null; f.shiftPoints = null;   // engine options are independent: kept
          // the notice names what actually happened: Manual drops the offer, a new automatic branch needs new
          // choices, and the empty placeholder leaves no file type at all
          if (had) {
            notice = { section: 'vehdetails', text: value === 'manual' ? T.transClearedManual
              : (value === 'aisin' && noAisin ? T.transClearedAisin : (value ? T.transClearedBranch : T.transClearedNone)) };
          }
        }
        f.ecmFileType = value;
        break;
      case 'transTuning':
        f.transTuning = !!value && !(rules && rules.noTrans) && ((f.ecmFileType === '68rfe' && !cc) || (f.ecmFileType === 'aisin' && !noAisin));
        if (!f.transTuning) { f.transPressure = null; f.shiftPoints = null; }
        break;
      case 'transPressure':
        f.transPressure = (f.transTuning && f.ecmFileType === '68rfe' && findBy(PRESSURES, value)) ? value : null;
        break;
      case 'shiftPoints':
        f.shiftPoints = (f.transTuning && SHIFT_POINTS[f.ecmFileType] && findBy(SHIFT_POINTS[f.ecmFileType], value)) ? value : null;
        break;
      case 'engineOption':
        if (value && findBy(rules && rules.engineOptions || ENGINE_OPTIONS, value.id)) f.engineOptions[value.id] = !!value.on;
        break;
      case 'linkCodesRequested':
        f.linkCodesRequested = !!value;
        break;
      case 'idleSound':
        f.idleSound = findBy(rules && rules.idleSounds || IDLE_SOUNDS, value) ? value : null;
        if (sd && sd.kind === '60' && f.sctTurbo === 'non_vgt') f.idleSound = 'rumble';   // SPEC 23c1: Hiss is disabled
        break;
      case 'deviceSerial': case 'ecmSerial': case 'ecmEc': case 'tireDiameter': case 'poNumber':
        f[field] = value == null ? '' : String(value);
        break;
      case 'truckTransmission':
        f.truckTransmission = findBy(GM_TRANS, value) ? value : null;
        break;
      case 'injectors':
        f.injectors = findBy(INJECTORS, value) ? value : null;
        break;
      case 'supportPackage':
        f.supportPackage = findBy(SUPPORT, value) ? value : null;
        break;
      case 'ecmUnlocked':
        // a locked 2017-2018 ECM cannot be tuned with EZ-Lynk: the package and add-on are hidden and cleared, so a
        // later Yes never silently restores them
        f.ecmUnlocked = findBy(YES_NO, value) ? value : null;
        if (f.ecmUnlocked === 'no') {
          f.supportPackage = null; f.ezTransTuning = false;
          f.driveType = null; f.tcase = 'auto';   // SPEC 19: the hidden drive answers start over too (Auto is the default)
          f.poNumber = '';                        // SPEC 21a: the hidden PO Number too
          notice = { section: null, text: T.gateNoTitle };   // announced only; the gate section shows the message
        }
        break;
      case 'ezTransTuning':
        f.ezTransTuning = !!value;
        break;
      case 'driveType':
        // SPEC 19a / 19b: asked only when the VIN gave no drive. A 4x4 starts on Auto (the default); 4x2 clears the
        // transfer case, so a later 4x4 starts on Auto again (never a silently restored Manual)
        value = findBy(DRIVES, value) ? value : null;
        if (value === '4x4' && f.driveType !== '4x4') f.tcase = 'auto';
        if (value !== '4x4') f.tcase = null;
        f.driveType = value;
        break;
      case 'tcase':
        f.tcase = findBy(TCASES, value) ? value : null;   // counts only on a 4x4 (activeConfig)
        break;
      case 'previewLevelId':
        // never touches the package or quote. SOTF previews any listed level; SPEC 22 SCT single files preview one of
        // the levels picked, when more than one is picked
        if (f.tuneType === 'sotf' && value) preview = String(value);
        else if (sd && value && f.tuneType !== 'sotf' && sctLevelsOf(f, sd).length > 1 && sctLevelsOf(f, sd).indexOf(parseInt(value, 10)) >= 0) preview = String(parseInt(value, 10));
        else preview = null;
        break;
      default:
        break;
    }
    return { form: f, previewLevelId: preview, notice: notice, priceAffecting: !!PRICE_FIELDS[field] };
  }

  // Pure: Cummins device change. Switching device drops every value of the other branch (no hidden draft). SPEC 21a:
  // the PO Number is not a branch value (both flows show the same Order Details field), so it is kept.
  // SPEC 22: the 6.4 chooser switches EZ-Lynk / SCT the same way (platform: the route's, default the Cummins one).
  // SPEC 26l: the L5P chooser switches EZ-Lynk / HP Tuners the same way; cur.files (the HP Tuners file metadata, optional)
  // only decides the notice: the caller clears the files themselves.
  function applyDevice(cur, device, platform) {
    if (!findBy(DEVICES, device)) device = null;
    if (device === cur.device) return { device: device, form: cur.form, previewLevelId: cur.previewLevelId, notice: null, changed: false };
    var notice = null;
    if (device === 'ez_lynk' && cur.device === 'efi_live' && efiHasInput(cur.form)) notice = { section: 'device', text: T.efiCleared };
    else if (device && device !== 'sct' && cur.device === 'sct' && sctHasInput(cur.form)) notice = { section: 'device', text: T.sctCleared };
    else if (device && device !== 'hp_tuners' && cur.device === 'hp_tuners' && hptHasInput(cur.form, cur.files)) notice = { section: 'device', text: T.hptCleared };
    var form = emptyForm(platform || 'cummins');
    form.poNumber = cur.form && cur.form.poNumber ? String(cur.form.poNumber) : '';
    return { device: device, form: form, previewLevelId: null, notice: notice, changed: true };
  }

  /* =========================================================================
     7. Active config, validation, quote, fingerprint, cart payload (SPEC 4-5)
     ctx = { routeId, flow, platform, device, vin, identity, manual, form, offer }
     ========================================================================= */
  // SPEC 13: the eligibility gate applies to the L5P EZ-Lynk route on ModelYear 2017 / 2018 only.
  function gateApplies(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    var y = ctx && ctx.identity ? ctx.identity.year : null;
    return !!(def && def.gateYears && ctx.flow === 'ez_lynk' && def.gateYears.indexOf(y) >= 0);
  }
  function hasAddon(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    return !!(def && def.addon && ctx.flow === 'ez_lynk');
  }
  // SPEC 15c / 15d: Cummins 6.7L EFI Live collects the ECM Serial and E/C Number from model year 2010 (always on
  // 2013-2021; 2010-2012 on cmns-07-12); 2007-2009 6.7L, the 5.9L, GM and EZ-Lynk never show or send them.
  function ecmIdsApply(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    if (!def || def.platform !== 'cummins' || ctx.flow !== 'efi_live') return false;
    if (def.ecmIdsFrom == null) return true;
    var y = ctx.identity ? ctx.identity.year : null;
    return y != null && y >= def.ecmIdsFrom;
  }
  // SPEC 23e (Brent 2026-10-18: "When a 13-21 Cab and Chassis vin is entered only show it Level 1-5 and OBD SOTF. No other
  // modifers for efi live"; "C&C can add AISIN tuning"): a 2013-2021 Cummins cab & chassis VIN (cabChassisVin: WMI 3C7 or
  // 4th character W) on EFI Live. Its form has no Idle Sound, Engine Options, Injectors (stock) or 68RFE transmission
  // tuning, and its SOTF is the OBD SOTF.
  function ccApplies(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    var y = ctx && ctx.identity ? ctx.identity.year : null;
    return !!(def && def.ccForm && ctx.flow === 'efi_live' && y != null && y >= 2013 && y <= 2021 && cabChassisVin(ctx.vin));
  }
  // Idle Sound and Engine Options: Cummins 6.7L EFI Live, never on a cab & chassis (SPEC 23e)
  function idleApplies(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    return !!(def && def.platform === 'cummins' && ctx.flow === 'efi_live' && !ccApplies(ctx));
  }
  function eoApplies(ctx) { return idleApplies(ctx); }
  function earlyApplies(ctx) { return !!(ctx && ctx.routeId === 'cmns-07-12' && ctx.flow === 'efi_live'); }
  function cmcApplies(ctx) { return earlyApplies(ctx) && ctx.identity && ctx.identity.year >= 2007 && ctx.identity.year <= 2009; }
  // The supplied CMC cab-and-chassis library is AISIN, confirmed by Brent.
  var CMC_CC_TRANS = 'aisin';
  function cmcCcApplies(ctx) { return cmcApplies(ctx) && cabChassisVin(ctx.vin); }
  function cmdFamily(ec) {
    var m = /^CM(?:900)?(\d{2})(?:\.[A-Z0-9]+)?$/.exec(str(ec).toUpperCase().replace(/\s/g, ''));
    var family = m ? 'CM' + m[1] : null;
    return family && CMD_FAMILIES[family] ? family : null;
  }
  function earlyFamily(ctx, c) {
    if (!earlyApplies(ctx)) return null;
    c = c || ctx.form || {};
    if (cmcCcApplies(ctx)) return CMC_CC_TRANS && c.ecmFileType === CMC_CC_TRANS ? 'CMC_CC' : null;
    if (cmcApplies(ctx)) return { '68rfe': 'CMC_AUTO', manual: 'CMC_MAN' }[c.ecmFileType] || null;
    return cmdFamily(c.ecmEc);
  }
  function idleSoundsFor(ctx) {
    return cmcApplies(ctx) ? IDLE_SOUNDS.concat([{ id: 'non_vgt', label: 'Non VGT' }]) : IDLE_SOUNDS;
  }
  function fileTypesFor(ctx) {
    if (cmcCcApplies(ctx)) return FILE_TYPES.filter(function (t) { return t.id === CMC_CC_TRANS; });
    return cmcApplies(ctx) ? [{ id: '68rfe', label: 'Automatic' }, FILE_TYPES[2]] : FILE_TYPES;
  }
  function engineOptionsFor(ctx) {
    if (!earlyApplies(ctx)) return ENGINE_OPTIONS;
    return EARLY_ENGINE_OPTIONS.map(function (o) {
      return o.id === 'hardcut4000' && !cmcApplies(ctx) ? { id: o.id, label: 'HC4 / LBF', help: 'Add the 4000 RPM hardcut and LBF calibration.' } : o;
    });
  }
  function earlyProblem(ctx, c) {
    if (!earlyApplies(ctx)) return '';
    if (cmcApplies(ctx)) {
      if (cmcCcApplies(ctx)) {
        if (!CMC_CC_TRANS) return 'This cab-and-chassis calibration needs a manual order. Contact us before ordering.';
        return c.ecmFileType === CMC_CC_TRANS ? '' : 'The transmission does not match the available cab-and-chassis calibration. Contact us before ordering.';
      }
      return findBy(fileTypesFor(ctx), c.ecmFileType) ? '' : 'Select Automatic or Manual.';
    }
    var family = cmdFamily(c.ecmEc), profile = family && CMD_FAMILIES[family];
    if (!profile) return 'This E/C number is not in the current 2010–2012 library. Contact us for a matching file.';
    if (profile.cc !== cabChassisVin(ctx.vin)) return 'The E/C number and VIN do not match the same pickup or cab-and-chassis application.';
    if (profile.trans !== c.ecmFileType) return 'The transmission does not match this E/C number. Check both selections.';
    return '';
  }
  function earlyPatcher(ctx, c) {
    var eo = c.engineOptions || {};
    var p = { kind: 'cummins_early', family: earlyFamily(ctx, c), base: c.tuneType === 'sotf' ? 'OBD-SOTF' : 'Level ' + c.tuneLevel,
      sound: labelOf(idleSoundsFor(ctx), c.idleSound), intake: !!eo.fiveInchIntake, map10bar: !!eo.map10bar, hardcut: !!eo.hardcut4000,
      shift: c.transTuning ? c.shiftPoints : null,
      line: c.transTuning ? ({ '180psi': '180', '200psi': '200', '225psi': '225', randys: 'randys', revmax: 'revmax' })[c.transPressure] || null : null,
      vin: ctx.vin };
    if (!cmcApplies(ctx)) p.serial = str(c.ecmSerial).replace(/\s/g, '');
    return p;
  }
  // SPEC 23e (Brent 2026-10-18: "Remove SOTF option for cab and chassis for 13-18"): a 2013-2018 cab & chassis has no SOTF
  function ccSotfOff(ctx) { return ccApplies(ctx) && ctx.identity.year <= 2018; }
  // SPEC 24b: the EFI Live card on the device chooser follows the cab & chassis rule (2013-2018 levels only, 2019-2021 OBD
  // SOTF). The chooser shows before the EFI Live flow is chosen, so this reads the route, year and VIN, not ccApplies.
  function efiDeviceDesc(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    var y = ctx && ctx.identity ? ctx.identity.year : null;
    if (def && def.ccForm && y != null && y >= 2013 && y <= 2021 && cabChassisVin(ctx.vin)) return y <= 2018 ? T.deviceEfiDescCc1318 : T.deviceEfiDescCc1921;
    return T.deviceEfiDesc;
  }
  // the Tune Type choices: Single Tune only on a 2013-2018 cab & chassis, Single Tune / "OBD SOTF" on a 2019-2021 one (SPEC
  // 23e), else Single Tune / Switch On The Fly
  function tuneTypesFor(ctx) {
    if (ccSotfOff(ctx)) return [TUNE_TYPES[0]];
    return ccApplies(ctx) || earlyApplies(ctx) ? [TUNE_TYPES[0], { id: 'sotf', label: T.ccSotf }] : TUNE_TYPES;
  }
  // SPEC 15b / 18c: Injectors (Stock / Modified) on the 5.9L and on Cummins 6.7L EFI Live model years 2013-2018 only
  // (SPEC 23e: never on a cab & chassis, which is stock).
  function injectorsApply(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    if (!def || ctx.flow !== 'efi_live') return false;
    if (def.platform === 'cummins59') return true;
    if (ccApplies(ctx)) return false;
    var y = ctx.identity ? ctx.identity.year : null;
    return !!(def.injectors && def.platform === 'cummins' && y != null && y >= def.injectors.from && y <= def.injectors.to);
  }
  // Transmission tuning offered for this Cummins transmission type: 68RFE always, AISIN unless the route has no
  // AISIN add-on (SPEC 15c, 2007-2012), never Manual.
  function transOffered(ctx, fileType) {
    var def = ctx && ROUTES[ctx.routeId];
    if (earlyApplies(ctx)) return !cmcApplies(ctx) && fileType === '68rfe';
    if (ccApplies(ctx)) return fileType === 'aisin';   // SPEC 23e: "C&C can add AISIN tuning", no 68RFE add-on
    if (fileType === '68rfe') return true;
    return fileType === 'aisin' && !(def && def.noAisinTrans);
  }
  // ctx (optional): the active context, so the reducers know a cab & chassis form (SPEC 23e: no 68RFE add-on)
  function routeRules(routeId, ctx) {
    var def = ROUTES[routeId];
    return { noAisinTrans: !!(def && def.noAisinTrans), sct: def && def.sct ? def.sct : null, cabChassis: !!(ctx && ccApplies(ctx)),
             noSotf: !!(ctx && ccSotfOff(ctx)), noTrans: !!(ctx && cmcApplies(ctx)),
             fileTypes: ctx ? fileTypesFor(ctx) : FILE_TYPES, idleSounds: ctx ? idleSoundsFor(ctx) : IDLE_SOUNDS,
             engineOptions: ctx ? engineOptionsFor(ctx) : ENGINE_OPTIONS };
  }
  // SPEC 22: the active route's SCT definition (ford-60-sct; ford-64 with the SCT device), or null
  function sctDef(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    return def && def.sct && ctx.flow === 'sct' ? def.sct : null;
  }
  // SPEC 23f (Brent 2026-10-18: "03/04 trucks and excursions of any year are FSM8 strategy. 05-07 superduty trucks are
  // TTP1."): the 6.0 SCT file family, or null
  function sct60Family(ident) {
    ident = ident || {};
    if (/^excursion$/i.test(str(ident.model))) return 'FSM8';
    if (ident.year === 2003 || ident.year === 2004) return 'FSM8';
    return ident.year >= 2005 && ident.year <= 2007 ? 'TTP1' : null;
  }
  // SPEC 23c2 (Brent: "When a customer has an 03/04 truck or an excursion of any year with the 6.0 and they select rumble.
  // Add a little note that some trucks do not react to the rumble idle."): the 6.0 SCT, model year 2003-2004 or any Excursion
  function rumbleNoteApplies(ctx) {
    var sd = sctDef(ctx), ident = (ctx && ctx.identity) || {};
    if (!sd || sd.kind !== '60') return false;
    return (ident.year === 2003 || ident.year === 2004) || /^excursion$/i.test(str(ident.model));
  }
  // the devices a device_choice route offers, in chooser order
  function routeDevices(def, flags) {
    return (def && def.devices ? def.devices.slice() : DEFAULT_DEVICES.slice()).filter(function (device) {
      return device !== 'hp_tuners' || !def.hpt || !def.hpt.flag || flagOn(flags, def.hpt.flag);
    });
  }
  function cumminsHpt(ctx) { return !!(ctx && ctx.flow === 'hp_tuners' && ctx.routeId === 'cmns-22-24'); }
  function deviceOk(off, d) {
    off = off || {};
    if (d === 'efi_live') return !!(off.efi && off.efi.ok);
    if (d === 'ez_lynk') return !!(off.ez && off.ez.ok);
    if (d === 'sct') return !!(off.sct && off.sct.ok);
    if (d === 'hp_tuners') return !!(off.hpt && off.hpt.ok);   // SPEC 26a
    return false;
  }
  // SPEC 22b / 22c: the SCT serial (spaces removed, exactly 13 characters: assets/pk-product-fields.js) and the 6.0's ECM
  // strategy (spaces removed, uppercased, exactly 7 letters / digits). '' when fine.
  var SCT_SERIAL_LENGTH = 13, STRATEGY_LENGTH = 7;
  // SPEC 23f: spaces removed and uppercased (never padded or cut), then exactly 13 letters / digits starting with XP, X4, LT,
  // LX or BD (the CEF builder refuses any other serial); 6.0 and 6.4 alike
  function sctSerialNorm(s) { return str(s).replace(/\s+/g, '').toUpperCase(); }
  function sctSerialProblem(s) {
    var v = sctSerialNorm(s);
    if (!v) return T.errSctSerial;
    if (!/^[A-Z0-9]+$/.test(v)) return T.errSctSerialChars;
    if (v.length !== SCT_SERIAL_LENGTH) return 'SCT Device Serial Numbers Are Exactly ' + SCT_SERIAL_LENGTH + ' Characters. This One Has ' + v.length + '.';
    return SCT_SERIAL_PREFIXES.indexOf(v.slice(0, 2)) >= 0 ? '' : T.errSctSerialPrefix;
  }
  function strategyNorm(s) { return str(s).replace(/\s+/g, '').toUpperCase(); }
  function strategyProblem(s) {
    var v = strategyNorm(s);
    if (!v) return T.errStrategy;
    if (!/^[A-Z0-9]+$/.test(v)) return T.errStrategyChars;
    return v.length === STRATEGY_LENGTH ? '' : 'ECM Strategy Is Exactly ' + STRATEGY_LENGTH + ' Characters. This One Has ' + v.length + '.';
  }
  /* ---------- SPEC 26: HP Tuners L5P (pure) ---------- */
  // 26d: spaces and dashes removed, then trimmed; the result is what is sent everywhere (Device S/N, hpt.serial, patcher.slave)
  function hptSerialNorm(s) { return str(s).replace(/[\s-]+/g, '').trim(); }
  // 26d: exactly 10 digits starting with 2 (Studio's --slave range is 1-4294967295; every 10-digit value starting with 2 is in
  // it). The AutoCal and VIN cases get their own message, because those are the usual mix-ups. '' when fine.
  function hptSerialProblem(s) {
    var v = hptSerialNorm(s);
    if (!v) return T.errHptSerial;
    if (/^\d{12}$/.test(v) && LINK_SERIAL_PREFIXES.indexOf(v.slice(0, 3)) >= 0) return T.errHptSerialAutocal;
    if (v.length === 17 && !vinProblem(v.toUpperCase())) return T.errHptSerialVin;
    if (!/^\d+$/.test(v)) return T.errHptSerialDigits;
    if (v.length !== 10) return 'HP Tuners Device Serial Numbers Are 10 Digits. This One Has ' + v.length + '.';
    return v.charAt(0) === '2' ? '' : T.errHptSerialStart;
  }
  // 26e: a file name as stored and sent: every character outside printable ASCII becomes _, then at most max characters
  function hptFileName(name, max) {
    var s = String(name == null ? '' : name).replace(/[^\x20-\x7E]/g, '_');
    // Keep the type visible in the compact order metadata even for long filenames.
    var ext = /\.(hpt|txt)$/i.exec(s);
    if (max && s.length > max && ext && max > ext[0].length) return s.slice(0, max - ext[0].length) + ext[0];
    return max ? s.slice(0, max) : s;
  }
  // "18.1 KB" / "1.75 MB" / "512 Bytes" (the selected-file line)
  function hptFileSize(bytes) {
    var n = Number(bytes) || 0;
    if (n < 1024) return n + ' Bytes';
    if (n < 1048576) return (n / 1024).toFixed(1) + ' KB';
    return (n / 1048576).toFixed(2) + ' MB';
  }
  // 26f: the connected ECM header ("ECM: 7E8, CAN, ECM -EngineControl - E41, GM, 2017-2023 6.6L Duramax") and any controller
  // header that ends its block ("None: 7EE, CAN, GPCM-GlowPlugCtrl"): a name, a colon, a 3-character CAN id and a comma
  var HPT_E41_RE = /^\s*ECM:\s*[0-9A-F]{3}\s*,.*\bE41\b/i;
  var HPT_CONTROLLER_RE = /^\s*[A-Za-z][^:]*:\s*[0-9A-F]{3}\s*,/i;
  // 26f: read ONLY the connected E41 block: from the first E41 ECM header to the next blank line or controller header, its
  // VIN line and its OS line (never "Boot OS:"). Nothing else in the file (the licensed-controller lists, which carry other
  // trucks' VINs, the credits and licence lines, the application key, the interface ID) is read, kept or shown.
  // -> {e41, vin, os}: vin uppercased or null, os 8 digits or null; e41 false (and both null) when there is no E41 block.
  function parseInfolog(text) {
    var lines = String(text == null ? '' : text).split(/\r?\n/);
    var start = -1, i, m;
    for (i = 0; i < lines.length && start < 0; i++) if (HPT_E41_RE.test(lines[i])) start = i;
    var out = { e41: start >= 0, vin: null, os: null };
    if (start < 0) return out;
    for (i = start + 1; i < lines.length; i++) {
      var l = lines[i];
      if (!/\S/.test(l) || HPT_CONTROLLER_RE.test(l)) break;
      if (!out.vin && (m = /^\s*VIN:\s*([A-HJ-NPR-Z0-9]{17})\b/i.exec(l))) out.vin = m[1].toUpperCase();
      else if (!out.os && (m = /^\s*OS:\s*(\d{8})\b/.exec(l))) out.os = m[1];
    }
    return out;
  }
  // 26e: the infolog checks that need no reading (missing, a tune file in the wrong slot, not .txt, empty, too large); only
  // a file that passes them is read. meta = {name, size, lastModified, check} or null. '' when fine.
  function infologPreProblem(meta) {
    if (!meta) return T.errInfologMissing;
    var n = String(meta.name || '').toLowerCase();
    if (/\.hpt$/.test(n)) return T.errInfologHpt;
    if (!/\.txt$/.test(n)) return T.errInfologExt;
    if (!(Number(meta.size) > 0)) return T.errFileEmpty;
    if (Number(meta.size) > HPT_INFOLOG_MAX) return T.errInfologBig;
    return '';
  }
  // 26e / 26f: every infolog problem, in order. meta.check = {status: pending | done | error, nul, e41, vin, os}. While the
  // read runs the answer is T.hptChecking (it blocks Review / Add To Cart; the form shows it as a status, never an error).
  function infologProblem(meta, vin) {
    if (!meta) return '';  // Optional; supplied logs must still pass every check.
    var pre = infologPreProblem(meta);
    if (pre) return pre;
    var ck = meta.check;
    if (!ck || ck.status === 'pending') return T.hptChecking;
    if (ck.status !== 'done') return T.errFileRead;
    if (ck.nul) return T.errInfologNul;
    if (!ck.e41) return HPT_INFOLOG_STRICT ? T.errInfologNoE41 : '';
    if (ck.vin && ck.vin !== String(vin || '').toUpperCase()) return 'This Infolog Is For VIN ' + ck.vin + ', Not ' + vin + '.';
    return '';
  }
  // 26e: the stock read is never read: name, size only. '' when fine.
  function stockProblem(meta, ctx) {
    if (!meta) return T.errStockMissing;
    if (!/\.hpt$/i.test(String(meta.name || ''))) return T.errStockExt;
    if (!(Number(meta.size) > 0)) return T.errFileEmpty;
    if (Number(meta.size) > (cumminsHpt(ctx) ? CUMMINS_HPT_STOCK_MAX : HPT_STOCK_MAX)) return cumminsHpt(ctx) ? T.errCumminsStockBig : T.errStockBig;
    return '';
  }
  // 26i: what goes into the active config (and so the fingerprint) for a file: name|size|lastModified, never the File
  function hptFileKey(meta) {
    return meta ? [hptFileName(meta.name), Number(meta.size) || 0, Number(meta.lastModified) || 0].join('|') : null;
  }
  function hptFiles(ctx) {
    var fl = (ctx && ctx.files) || {};
    return { infolog: cumminsHpt(ctx) ? null : fl.infolog || null, stock: fl.stock || null };
  }
  // the infolog check when it finished: {e41, vin, os}; null while pending / unread
  function hptCheckDone(meta) { return meta && meta.check && meta.check.status === 'done' && !meta.check.nul ? meta.check : null; }
  // 26f: "Infolog Matches This VIN." only when the read found a connected E41 block whose VIN line equals the confirmed VIN.
  // The visible note and the live-region announcement both use this: an E41 block without a VIN line, or (HPT_INFOLOG_STRICT
  // off) no E41 block at all, passes the field checks but is never announced as a match.
  function infologMatches(meta, vin) {
    var ck = hptCheckDone(meta);
    return !!(ck && ck.e41 && ck.vin && ck.vin === String(vin || '').toUpperCase());
  }
  // 3c: Studio's --levels value for the ordered tune: L1-L5 or SOTF (uppercase)
  function hptLevel(c) { return c.tuneType === 'sotf' ? (c.hptSotfMode || 'SOTF') : (c.tuneType === 'single' && c.tuneLevel ? 'L' + c.tuneLevel : null); }
  // 3b: the visible Tune property ("Single Tune - Level 3" / "Switch On The Fly")
  function hptTuneLabel(c) {
    if (c.tuneType === 'single') return 'Single Tune' + (c.tuneLevel ? ' - Level ' + c.tuneLevel : '');
    return c.tuneType === 'sotf' ? (labelOf(CUMMINS_HPT_MODES, c.hptSotfMode) || 'Switch On The Fly') : '';
  }
  // 26i: the reply line of a multipart add (or a cart line) carries both Shopify-hosted uploads
  function hptUploadsOk(props) {
    var p = props || {}, o;
    try { o = JSON.parse(p._247_order || '{}'); } catch (e) { return false; }
    var optional = o.hpt && o.hpt.input === 'stock_hpt' && o.hpt.infolog == null;
    var keys = optional ? [HPT_UPLOAD_KEYS.stock] : [HPT_UPLOAD_KEYS.infolog, HPT_UPLOAD_KEYS.stock];
    return keys.every(function (k) { return typeof p[k] === 'string' && p[k].indexOf('/uploads/') >= 0; });
  }

  // the transmission an SCT build is for: the 6.0's Transmission Type; on the 6.4 a Manual TCU Strategy means a manual
  // truck (the product page's TCU Strategy is for automatics), any other strategy an automatic
  function sctTransmission(c, sd) {
    if (!sd) return null;
    if (sd.kind === '60') return labelOf(GM_TRANS, c.truckTransmission) || null;
    return c.tcuStrategy ? (c.tcuStrategy === 'manual' ? 'Manual' : 'Automatic') : null;
  }
  // SPEC 19a: the drive type (and on a 4x4 the transfer case) applies to every GM route (gm-dmax-01-10, gm-dmax-lml
  // EFI Live, gm-l5p-17-23 EZ-Lynk); never to Ram / Dodge or Ford.
  function driveApplies(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    return !!(def && def.drive && (ctx.flow === 'efi_live' || ctx.flow === 'ez_lynk'));
  }
  // the drive the VIN decoded ('4x4' | '4x2'), or null when vPIC did not say (the customer is asked)
  function decodedDrive(ctx) {
    var d = ctx && ctx.identity ? ctx.identity.drive : null;
    return d === '4x4' || d === '4x2' ? d : null;
  }
  // the drive that counts: the VIN's, else the customer's answer, else null
  function driveOf(ctx) {
    if (!driveApplies(ctx)) return null;
    var d = decodedDrive(ctx);
    if (d) return d;
    var f = ctx.form || {};
    return findBy(DRIVES, f.driveType) ? f.driveType : null;
  }
  function driveSourceOf(ctx) {
    if (!driveApplies(ctx)) return null;
    return decodedDrive(ctx) ? 'vin' : (driveOf(ctx) ? 'customer' : null);
  }
  // SPEC 19c: the E/C Number on the 2022-2024 Cummins EZ-Lynk route (not 2013-2021 EZ-Lynk)
  function ezEcApplies(ctx) {
    var def = ctx && ROUTES[ctx.routeId];
    return !!(def && def.ezEc && ctx.flow === 'ez_lynk');
  }

  function activeConfig(ctx) {
    var f = ctx.form || emptyForm(ctx.platform);
    var c = { vin: ctx.vin };
    var def = ROUTES[ctx.routeId];
    // SPEC 26a: the L5P's EZ-Lynk side keeps its pre-SPEC 26 config (no device key: legacyEz), so its lines are unchanged
    if (def && def.type === 'device_choice' && !(def.legacyEz && ctx.flow === 'ez_lynk')) c.device = ctx.device || null;
    if (ctx.manual) c.manualEngine = ctx.manual;
    if (ctx.flow === 'hp_tuners') {
      // SPEC 26c / 26i: tune type (+ the level on a Single Tune), the normalised serial, the two files as name|size|lastModified
      // (re-picking a file changes the fingerprint, so a new upload is never answered "already in cart"), the PO
      c.tuneType = f.tuneType;
      if (f.tuneType === 'single') c.tuneLevel = f.tuneLevel;
      if (cumminsHpt(ctx) && f.tuneType === 'sotf') c.hptSotfMode = 'CRUISE_SOTF';
      c.hptSerial = hptSerialNorm(f.hptSerial);
      var fl = hptFiles(ctx);
      c.infolog = hptFileKey(fl.infolog);
      c.stock = hptFileKey(fl.stock);
      addPo(c, f);
      return c;
    }
    if (ctx.flow === 'ez_lynk') {
      // every other EZ-Lynk route stays VIN + support package only
      if (gateApplies(ctx)) c.ecmUnlocked = f.ecmUnlocked;
      c.supportPackage = f.supportPackage;
      if (ezEcApplies(ctx)) c.ecmEc = str(f.ecmEc);                 // SPEC 19c: 2022-2024 Cummins
      if (hasAddon(ctx)) c.transTuning = !!f.ezTransTuning;
      addDrive(c, ctx, f);                                         // SPEC 19: L5P
      addPo(c, f);                                                 // SPEC 21a
      return c;
    }
    if (ctx.flow === 'sct') {
      // SPEC 22: 6.0 = tune files + serial + ECM strategy + turbo + injectors + transmission; 6.4 = tune type (+ the
      // single files) + serial + TCU strategy + Non-VGT
      var sd = sctDef(ctx);
      if (!sd) return c;
      if (sd.kind === '64') {
        c.tuneType = f.tuneType;
        if (f.tuneType === 'single') c.sctLevels = sctLevelsOf(f, sd);
      } else {
        c.sctLevels = sctLevelsOf(f, sd);
      }
      c.sctSerial = sctSerialNorm(f.sctSerial);
      if (sd.kind === '60') {
        c.ecmStrategy = strategyNorm(f.ecmStrategy);
        c.sctTurbo = f.sctTurbo;
        c.sctInjectors = f.sctInjectors;
        c.truckTransmission = f.truckTransmission;
        c.idleSound = f.idleSound;                                 // SPEC 23c1
        c.sctLimiter = f.sctLimiter;
        c.sctSensors = f.sctSensors;                               // SPEC 23c3
      } else {
        c.tcuStrategy = f.tcuStrategy;                             // SPEC 23d: no Non-VGT on the 6.4
      }
      addPo(c, f);                                                 // SPEC 21a
      return c;
    }
    if (ctx.flow !== 'efi_live') return c;
    // SPEC 23e: a stale SOTF on a 2013-2018 cab & chassis counts as no tune type (never priced or sent)
    c.tuneType = f.tuneType === 'sotf' && ccSotfOff(ctx) ? null : f.tuneType;
    if (f.tuneType === 'single') c.tuneLevel = f.tuneLevel;
    c.deviceSerial = str(f.deviceSerial);
    c.linkCodesRequested = !!f.linkCodesRequested;
    if (ctx.platform === 'cummins') {
      if (idleApplies(ctx)) c.idleSound = f.idleSound;               // SPEC 23e: not on a cab & chassis
      if (ecmIdsApply(ctx)) {       // SPEC 15d: never for 2007-2009
        c.ecmEc = str(f.ecmEc);
        c.ecmSerial = str(f.ecmSerial);
      }
      if (injectorsApply(ctx)) c.injectors = f.injectors;   // SPEC 18c: 2013-2018 only
      c.ecmFileType = f.ecmFileType;
      if (eoApplies(ctx)) {                                          // SPEC 23e: not on a cab & chassis
        c.engineOptions = {};
        engineOptionsFor(ctx).forEach(function (o) { c.engineOptions[o.id] = !!f.engineOptions[o.id]; });
      }
      if (transOffered(ctx, f.ecmFileType)) {
        c.transTuning = !!f.transTuning;
        if (f.transTuning) {
          c.shiftPoints = f.shiftPoints;
          if (f.ecmFileType === '68rfe') c.transPressure = f.transPressure;
        }
      }
    }
    if (ctx.platform === 'cummins59') {   // SPEC 15b
      c.injectors = f.injectors;
      c.truckTransmission = f.truckTransmission;
    }
    if (ctx.platform === 'gm') {
      c.tireDiameter = str(f.tireDiameter);
      c.truckTransmission = f.truckTransmission;
      addDrive(c, ctx, f);                                         // SPEC 19
    }
    addPo(c, f);                                                   // SPEC 21a
    return c;
  }
  // SPEC 21a: the PO Number (trimmed, as typed) only when one is entered: an empty PO adds no key, so an empty-PO
  // configuration keeps its pre-SPEC 21 fingerprint (and its duplicate check against lines already in the cart)
  function addPo(c, f) {
    var po = str(f && f.poNumber);
    if (po) c.poNumber = po;
  }
  // SPEC 19: the drive that counts (VIN or customer) and, on a 4x4 only, the transfer case
  function addDrive(c, ctx, f) {
    if (!driveApplies(ctx)) return;
    c.driveType = driveOf(ctx);
    if (c.driveType === '4x4') c.tcase = findBy(TCASES, f.tcase) ? f.tcase : null;
  }

  function serialValid(s) { return /^[A-Za-z0-9]{4,20}$/.test(str(s).replace(/[\s-]/g, '')); }
  // SPEC 24c: with link codes the serial must be an AutoCal serial: 12 digits starting 005 / 006 once spaces and dashes
  // are ignored (Order Flow holds any other link-code order)
  function linkSerialValid(s) {
    var d = str(s).replace(/[\s-]/g, '');
    return /^\d{12}$/.test(d) && LINK_SERIAL_PREFIXES.indexOf(d.slice(0, 3)) >= 0;
  }
  function ecmSerialValid(s) { return /^[A-Za-z0-9]{1,12}$/.test(str(s).replace(/\s/g, '')); }
  function ecValid(s) { return /^[A-Za-z0-9.\-]{3,20}$/.test(str(s).replace(/\s/g, '')); }   // SPEC 15d
  // SPEC 21c: the serial the GM AISIN Patcher locks the ECM file to: 1-12 letters / digits once spaces are removed,
  // never all zeros (it pads to 12 with 0; EFILive reads an all-zero serial as no serial)
  function ecmSerialZeros(s) { return /^0+$/.test(str(s).replace(/\s/g, '')); }
  function patcherSerialOk(s) { return ecmSerialValid(s) && !ecmSerialZeros(s); }
  // SPEC 21a: optional; at most 40 characters; letters, digits, space and - _ / # . only. '' when fine (or empty).
  function poProblem(s) {
    var po = str(s);
    if (!po) return '';
    if (po.length > TEXT_MAX) return T.errPoLength;
    return PO_CHARS.test(po) ? '' : T.errPoChars;
  }
  function tireValid(s) { var t = str(s); return /^(\d+(\.\d{1,2})?|\.\d{1,2})$/.test(t) && parseFloat(t) > 0; }

  function validate(ctx) {
    var e = {};
    var c = activeConfig(ctx);
    if (ctx.flow === 'hp_tuners') {                                 // SPEC 26c-26f
      if (!c.tuneType) e.tuneType = T.errTuneType;
      else if (c.tuneType === 'single' && !c.tuneLevel) e.tuneLevel = T.errLevel;
      if (cumminsHpt(ctx) && c.tuneType === 'sotf' && !findBy(CUMMINS_HPT_MODES, c.hptSotfMode)) e.hptSotfMode = T.errHptSotfMode;
      var hse = hptSerialProblem(c.hptSerial);
      if (hse) e.hptSerial = hse;
      var hfl = hptFiles(ctx);
      var ie = infologProblem(hfl.infolog, ctx.vin);
      if (ie) e.hptInfolog = ie;
      var ke = stockProblem(hfl.stock, ctx);
      if (ke) e.hptStock = ke;
      poErrors(e, c);
      return e;
    }
    if (ctx.flow === 'ez_lynk') {
      if (gateApplies(ctx) && c.ecmUnlocked !== 'yes') {
        // "No" is ineligible (the package and the action are not shown at all); unanswered is a field error
        if (c.ecmUnlocked === 'no') { e.ecmLocked = T.gateNoTitle; return e; }
        e.ecmUnlocked = T.errGate;
      }
      driveErrors(e, ctx, c);
      if (!c.supportPackage) e.supportPackage = T.errSupport;
      if (ezEcApplies(ctx)) {                                      // SPEC 19c: the SPEC 15d rules
        if (!c.ecmEc) e.ecmEc = T.errEc;
        else if (!ecValid(c.ecmEc)) e.ecmEc = T.errEcFormat;
      }
      poErrors(e, c);                                              // SPEC 21a
      return e;
    }
    if (ctx.flow === 'sct') {                                      // SPEC 22b / 22c
      var sd = sctDef(ctx);
      if (!sd) return e;
      if (sd.kind === '64') {
        if (!c.tuneType) e.tuneType = T.errTuneType;
        else if (c.tuneType === 'single' && !c.sctLevels.length) e.sctLevels = T.errSctPower;
      } else if (!c.sctLevels.length) e.sctLevels = T.errSctFiles;
      if (sd.kind === '60') {                                      // SPEC 23c1: Non-VGT files are Rumble only
        if (!c.idleSound) e.idleSound = T.errIdle;
        else if (c.sctTurbo === 'non_vgt' && c.idleSound !== 'rumble') e.idleSound = T.idleNonVgt;
      }
      var serr = sctSerialProblem(c.sctSerial);
      if (serr) e.sctSerial = serr;
      if (sd.kind === '60') {
        var terr = strategyProblem(c.ecmStrategy);
        if (terr) e.ecmStrategy = terr;
        if (!c.sctTurbo) e.sctTurbo = T.errTurbo;
        if (!c.sctInjectors) e.sctInjectors = T.errInjectors;
        if (!c.truckTransmission) e.truckTransmission = T.errFileType;   // "Select Your Transmission Type."
        if (!findBy(SCT_LIMITERS, c.sctLimiter)) e.sctLimiter = 'Select a rev limiter.';
        if (!c.sctSensors) e.sctSensors = T.errSensors;            // SPEC 23c3
      } else if (!c.tcuStrategy) e.tcuStrategy = T.errTcu;
      poErrors(e, c);
      return e;
    }
    if (ctx.flow !== 'efi_live') return e;
    if (!c.tuneType) e.tuneType = T.errTuneType;
    if (c.tuneType === 'single' && !c.tuneLevel) e.tuneLevel = T.errLevel;
    if (!c.deviceSerial) e.deviceSerial = T.errSerial;
    else if (!serialValid(c.deviceSerial)) e.deviceSerial = T.errSerialFormat;
    else if (c.linkCodesRequested && !linkSerialValid(c.deviceSerial)) e.deviceSerial = T.errSerialLink;   // SPEC 24c
    if (ctx.platform === 'cummins') {
      if (idleApplies(ctx) && !findBy(idleSoundsFor(ctx), c.idleSound)) e.idleSound = T.errIdle;   // SPEC 23e: not on a cab & chassis
      if (ecmIdsApply(ctx)) {
        if (!c.ecmEc) e.ecmEc = T.errEc;
        else if (!ecValid(c.ecmEc)) e.ecmEc = T.errEcFormat;
        if (!c.ecmSerial) e.ecmSerial = T.errEcm;
        else if (!ecmSerialValid(c.ecmSerial)) e.ecmSerial = T.errEcmFormat;
        else if (ecmSerialZeros(c.ecmSerial)) e.ecmSerial = T.errEcmZeros;   // SPEC 21c
      }
      if (injectorsApply(ctx) && !c.injectors) e.injectors = T.errInjectors;   // SPEC 18c
      if (!c.ecmFileType) e.ecmFileType = T.errFileType;
      if (earlyApplies(ctx)) {
        var ep = earlyProblem(ctx, c);
        var epField = cmcApplies(ctx) ? 'ecmFileType' : 'ecmEc';
        if (ep && !e[epField]) e[epField] = ep;
      }
      if (c.transTuning) {
        if (!c.shiftPoints) e.shiftPoints = T.errShift;
        if (c.ecmFileType === '68rfe' && !c.transPressure) e.transPressure = T.errPressure;
      }
    }
    if (ctx.platform === 'cummins59') {
      if (!c.injectors) e.injectors = T.errInjectors;
      if (!c.truckTransmission) e.truckTransmission = T.errFileType;   // "Select Your Transmission Type."
    }
    if (ctx.platform === 'gm') {
      driveErrors(e, ctx, c);
      if (!c.tireDiameter) e.tireDiameter = T.errTire;
      else if (!tireValid(c.tireDiameter)) e.tireDiameter = T.errTireFormat;
      if (!c.truckTransmission) e.truckTransmission = T.errGmTrans;
    }
    poErrors(e, c);                                                // SPEC 21a
    return e;
  }
  function poErrors(e, c) {
    var m = poProblem(c.poNumber);
    if (m) e.poNumber = m;
  }
  // SPEC 19: an unknown drive must be answered; a 4x4 needs its transfer case (preselected Auto, so normally set)
  function driveErrors(e, ctx, c) {
    if (!driveApplies(ctx)) return;
    if (!c.driveType) e.driveType = T.errDrive;
    else if (c.driveType === '4x4' && !c.tcase) e.tcase = T.errTcase;
  }

  function fingerprint(routeId, device, variantIds, cfg) {
    var parts = [routeId || '-', device || '-', (variantIds || []).join('+')];
    var keys = Object.keys(cfg || {}).filter(function (k) { return k !== 'engineOptions'; }).sort();
    keys.forEach(function (k) { parts.push(k + '=' + (cfg[k] == null ? '' : String(cfg[k]))); });
    if (cfg && cfg.engineOptions) {
      var on = ENGINE_OPTIONS.concat(EARLY_ENGINE_OPTIONS).filter(function (o) { return cfg.engineOptions[o.id]; }).map(function (o) { return o.id; });
      parts.push('engineOptions=' + (on.join(',') || 'none'));
    }
    return parts.join('|');
  }

  function lineFrom(res, role) {
    return {
      role: role, handle: res.handle, variantId: res.variant.id, productTitle: res.product.title, variantTitle: res.variant.title,
      price: res.priceOk ? res.variant.price : null, priceFormatted: res.variant.price_formatted || null
    };
  }

  // Quote from the Liquid catalog. 'incomplete' until every price-determining selection is made; text fields
  // (serials, tire) never gate the price, they gate the purchase action through validate().
  function computeQuote(ctx, format) {
    var none = { status: 'none', lines: [], total: null, totalFormatted: null, fingerprint: null };
    if (!ctx || !ctx.flow || !ctx.offer) return none;
    var f = ctx.form, off = ctx.offer, lines = [], res;
    if (ctx.flow === 'ez_lynk') {
      if (!off.ez) return mk('unavailable');
      // a locked 2017-2018 L5P ECM: nothing can be priced or ordered (the gate answer itself never sets a price;
      // an unanswered gate blocks the action through validate())
      if (gateApplies(ctx) && f.ecmUnlocked === 'no') return mk('ineligible');
      if (!f.supportPackage) return mk('incomplete');
      res = off.ez[f.supportPackage];
      if (!res || !res.ok) return mk('unavailable');
      lines.push(lineFrom(res, 'tune'));
      if (hasAddon(ctx) && f.ezTransTuning) {
        if (!off.addon || !off.addon.ok) return mk('unavailable');
        lines.push(lineFrom(off.addon, 'trans'));
      }
    } else if (ctx.flow === 'efi_live') {
      if (!off.efi) return mk('unavailable');
      if (!f.tuneType || (f.tuneType === 'single' && !f.tuneLevel)) return mk('incomplete');
      if (f.tuneType === 'sotf' && ccSotfOff(ctx)) return mk('incomplete');   // SPEC 23e: no SOTF on a 2013-2018 cab & chassis
      var trOn = ctx.platform === 'cummins' && f.transTuning && transOffered(ctx, f.ecmFileType);
      if (ctx.platform === 'cummins') {
        if (!f.ecmFileType) return mk('incomplete');
        if (trOn && (!f.shiftPoints || (f.ecmFileType === '68rfe' && !f.transPressure))) return mk('incomplete');
      }
      if (ctx.platform === 'cummins59' && (!f.injectors || !f.truckTransmission)) return mk('incomplete');
      if (ctx.platform === 'gm') {
        // SPEC 19: the drive (and a 4x4's transfer case) picks the file, so it completes the configuration like the
        // truck transmission does; EZ-Lynk (L5P) gates the action through validate() instead, like the ECM gate
        var dr = driveOf(ctx);
        if (!f.truckTransmission || (driveApplies(ctx) && (!dr || (dr === '4x4' && !findBy(TCASES, f.tcase))))) return mk('incomplete');
      }
      res = off.efi[f.tuneType];
      if (!res || !res.ok) return mk('unavailable');
      lines.push(lineFrom(res, 'tune'));
      if (trOn) {
        var t = off.trans[f.ecmFileType];
        if (!t || !t.ok) return mk('unavailable');
        lines.push(lineFrom(t, 'trans'));
      }
    } else if (ctx.flow === 'sct') {
      // SPEC 22: the count of picked files selects the variant (6.4 SOTF: its own variant). Injectors larger than
      // 330CC are a manual build: 'manual' is never priced and never added (the product page instead).
      var sd = sctDef(ctx);
      if (!sd || !off.sct) return mk('unavailable');
      var lv = sctLevelsOf(f, sd);
      if (sd.kind === '60') {
        if (f.sctInjectors === 'over_330') return mk('manual');
        if (!lv.length || !f.sctTurbo || !f.sctInjectors || !f.truckTransmission) return mk('incomplete');
        res = off.sct.files[lv.length - 1];
      } else {
        if (!f.tuneType || (f.tuneType === 'single' && !lv.length) || !f.tcuStrategy) return mk('incomplete');
        res = f.tuneType === 'sotf' ? off.sct.sotf : off.sct.files[lv.length - 1];
      }
      if (!res || !res.ok) return mk('unavailable');
      lines.push(lineFrom(res, 'tune'));
    } else if (ctx.flow === 'hp_tuners') {
      // SPEC 26h: one line, Single Tune or SOTF ("No Credits"); no add-on. The serial and files gate the action, not the price.
      if (!off.hpt) return mk('unavailable');
      if (!f.tuneType || (f.tuneType === 'single' && !f.tuneLevel)) return mk('incomplete');
      res = off.hpt[f.tuneType];
      if (!res || !res.ok) return mk('unavailable');
      lines.push(lineFrom(res, 'tune'));
    } else {
      return none;
    }
    for (var i = 0; i < lines.length; i++) if (lines[i].price === null) return mk('unavailable');
    var total = lines.reduce(function (s, l) { return s + l.price; }, 0);
    var q = mk('ready');
    q.lines = lines;
    q.total = total;
    q.totalFormatted = format ? format(total) : null;
    if (!q.totalFormatted) { q.status = 'unavailable'; return q; }
    q.fingerprint = fingerprint(ctx.routeId, ctx.flow === 'ez_lynk' || ctx.flow === 'efi_live' || ctx.flow === 'sct' || ctx.flow === 'hp_tuners' ? ctx.flow : ctx.device,
      lines.map(function (l) { return l.variantId; }), activeConfig(ctx));
    return q;
    function mk(status) { return { status: status, lines: [], total: null, totalFormatted: null, fingerprint: null }; }
  }

  function tuneLabel(c, ctx) {
    if (c.tuneType === 'single') return 'Single Tune' + (c.tuneLevel ? ' / Level ' + c.tuneLevel : '');
    if (c.tuneType === 'sotf') return ctx && (ccApplies(ctx) || earlyApplies(ctx)) ? T.ccSotf : 'Switch On The Fly';   // SPEC 23e
    return '';
  }
  function engineOptionLabels(eo, ctx) {
    return engineOptionsFor(ctx).filter(function (o) { return eo && eo[o.id]; }).map(function (o) { return o.label; });
  }

  /* =========================================================================
     7b. Order labelling + auto-patcher data (SPEC 18; Brent 2026-10-18: "every order placed with this 24/7 menu is
         tagged so when we webhook the orders we can tell if it is a 24/7 order that will then trigger our
         auto-patcher"). Every tune and add-on line carries the hidden marker _247: "1"; every tune line carries
         _247_order, compact JSON version 1, built here from the active config only. The contract (shape, the GM AISIN
         Patcher (GM, Cummins one-pass, AISIN) / Link Code Patcher mapping, identification by note_attributes Order
         Source + the _247 line markers, the PO Number and the order email subject) is design/ORDER-CONTRACT.md.
     ========================================================================= */
  var ORDER_VERSION = 1;
  // Master Patcher --order values (ORDER MODE README.txt): "line" names and the DO66 / DO67 injector branch
  var PATCHER_LINE = { '180psi': '180 PSI', '200psi': '200 PSI', '225psi': '225 PSI', randys: 'Randy', revmax: 'RevMax' };
  var PATCHER_INJ = { stock: 'Stock', modified: 'Larger Injector' };
  var ORDER_INJ = { stock: 'Stock', modified: 'Modified' };

  // SPEC 19b: the GM engine the GM AISIN Patcher builds (LB7 / LLY / LBZ / LMM / LML, from the decoded RPO), or null
  // when the VIN named none: the 6.6L Duramax LML pick names one engine, the LB7 / LLY / LBZ / LMM pick does not.
  function gmEngine(ctx) {
    var ident = ctx.identity || {};
    if (ident.rpo) return GM_ENGINES[ident.rpo] ? ident.rpo : null;
    return ctx.manual === 'gm-lml' ? 'LML' : null;
  }

  // SPEC 21c: the GM AISIN Patcher's cab & chassis rule (WMI 3C7 or 4th character W): its 2013-2021 Cummins sets are
  // pickup files, so a cab & chassis is built by hand
  function cabChassisVin(vin) {
    var v = String(vin || '').toUpperCase();
    return v.length === 17 && (v.slice(0, 3) === '3C7' || v.charAt(3) === 'W');
  }
  // SPEC 24a: the VINs the installed patcher's cab & chassis set takes (its check_vin_cc): 4th character W (chassis cab body)
  // and 8th character L (6.7L Cummins). It refuses WMI 3C7 with a pickup 4th character and any other 8th character; 3C6 + W
  // builds with a warning that holds the files.
  function ccPatcherVin(vin) {
    var v = String(vin || '').toUpperCase();
    return v.length === 17 && v.charAt(3) === 'W' && v.charAt(7) === 'L';
  }

  // SPEC 18b / 19b / 21: why a tune line is NOT auto-patched, or '' when it is. autoPatch for EFI Live only, every line
  // on the GM AISIN Patcher (ORDER-CONTRACT.md 5): Cummins (platform cummins, model year 2013-2021, 68RFE / AISIN /
  // 2013-2018 Manual, its one-pass kind cummins) and GM (2001-2016, SPEC 19b), each with every patcher input present.
  // SPEC 21c: every Cummins combination that patcher refuses gets its reason here, so autoPatch true always plans
  // (SPEC 24a: the cab & chassis VIN rule and transmission of the installed patcher v1.5).
  function autoPatchReason(ctx, c) {
    var def = ROUTES[ctx.routeId] || {};
    var y = ctx.identity ? ctx.identity.year : null;
    // SPEC 22d / 23f: every SCT line is held for Brent while SCT_AUTOPATCH is off (it carries its patcher block anyway)
    if (ctx.flow === 'sct') return SCT_AUTOPATCH ? '' : 'SCT builds by hand';
    if (ctx.flow === 'ez_lynk') return 'EZ-Lynk package';
    if (ctx.flow === 'hp_tuners') return hptAutoPatchReason(ctx, c);   // SPEC 26g
    if (def.platform === 'gm') {
      if (ctx.flow !== 'efi_live') return 'not an auto-patch truck';
      var eng = gmEngine(ctx);
      if (!eng) return 'GM engine not confirmed';                 // a manual LB7 / LLY / LBZ / LMM pick
      if (y == null || y < GM_ENGINES[eng][0] || y > GM_ENGINES[eng][1]) return 'engine and model year do not match';
      if (!c.tuneType || (c.tuneType === 'single' && !c.tuneLevel) || !c.truckTransmission || !c.driveType ||
          (c.driveType === '4x4' && !c.tcase)) return 'incomplete configuration';
      if (c.truckTransmission === 'manual' && GM_AUTO_ONLY[eng]) return 'no manual ' + eng + ' file';   // Allison only
      return '';
    }
    if (def.platform === 'cummins59') {
      // SPEC 23a: Stock Injectors are auto-patched (kind cummins59: automatic / manual, CSP5 SOTF or Level 1-5 singles);
      // Modified Injectors are built by hand
      if (ctx.flow !== 'efi_live') return 'not an auto-patch truck';
      if (!c.tuneType || (c.tuneType === 'single' && !c.tuneLevel) || !findBy(GM_TRANS, c.truckTransmission) ||
          !findBy(INJECTORS, c.injectors)) return 'incomplete configuration';
      if (c.injectors === 'modified') return '5.9 modified injectors build by hand';
      return '';
    }
    if (earlyApplies(ctx)) {
      var ep = earlyProblem(ctx, c);
      if (ep) return ep;
      if (!findBy(idleSoundsFor(ctx), c.idleSound) || !findBy(tuneTypesFor(ctx), c.tuneType) ||
          (c.tuneType === 'single' && !(c.tuneLevel >= 1 && c.tuneLevel <= 5)) ||
          (!cmcApplies(ctx) && !patcherSerialOk(c.ecmSerial))) return 'incomplete configuration';
      return '';
    }
    if (ctx.flow !== 'efi_live' || def.platform !== 'cummins' || y == null || y < 2013 || y > 2021) return 'not an auto-patch truck';
    var ft = c.ecmFileType;
    if (ft !== '68rfe' && ft !== 'aisin' && ft !== 'manual') return 'incomplete configuration';
    // SPEC 23e: a cab & chassis is decided before the pickup inputs are checked (its form has no Idle Sound, Injectors or
    // Engine Options). 2013-2018 is the DO70 set (Brent: "Added the levels 1-5 for cab and chassis 13-18 6.7"): Level 1-5;
    // 2019-2021 the IA03 set ("I added 19-21 cab and chassis files into the 24/7 folder"): Level 1-5 or the OBD SOTF (CSP5).
    // The ECM serial, the AISIN add-on as usual. ("cab & chassis builds by hand" is retired.) SPEC 24a: only what the installed
    // patcher plans: its VIN rule (4th W + 8th L) and the AISIN set (DO70 is Aisin; IA03 is expected to match); 68RFE /
    // Manual cab & chassis trucks and the VINs it refuses are held for a person.
    if (cabChassisVin(ctx.vin)) {
      if (!c.tuneType || (c.tuneType === 'single' && !c.tuneLevel) || (c.tuneType === 'sotf' && y <= 2018) ||
          !patcherSerialOk(c.ecmSerial)) return 'incomplete configuration';
      if (!ccPatcherVin(ctx.vin)) return 'cab & chassis VIN check by hand';
      if (ft !== 'aisin') return 'cab & chassis 68RFE / manual builds by hand';
      return '';
    }
    if (!c.tuneType || (c.tuneType === 'single' && !c.tuneLevel) || !c.idleSound || !patcherSerialOk(c.ecmSerial) ||
        (injectorsApply(ctx) && !c.injectors)) return 'incomplete configuration';
    if (ft === 'manual') {
      // SPEC 21b: DO68 (2013-2018 manual) has Stock injector bases only; there is no 2019-2021 manual set
      if (y >= 2019) return 'no 2019-2021 manual file';
      if (c.injectors === 'modified') return 'no modified injector manual file';
    }
    // the patcher's HOLD FOR A PERSON: no Cruise SOTF ModINJ base yet (it would build the older CCV-SOTF ModINJ base)
    if (y <= 2018 && c.injectors === 'modified' && c.tuneType === 'sotf') return 'modified injectors + SOTF builds by hand';
    return '';
  }

  // SPEC 26g: an HP Tuners line is auto-built by Peakside L5P Studio only with the switch on, a complete configuration, an
  // infolog whose connected E41 block names the confirmed VIN, and an OS among Studio's nine profiles. Anything else goes out
  // autoPatch false with its reason, and Order Flow holds it for Brent (he wants anything unmatched held).
  function hptAutoPatchReason(ctx, c) {
    if (!HPT_AUTOPATCH) return 'HP Tuners builds by hand';
    var fl = hptFiles(ctx);
    if (!hptLevel(c) || hptSerialProblem(c.hptSerial) || stockProblem(fl.stock, ctx) || (fl.infolog && infologPreProblem(fl.infolog))) return 'incomplete configuration';
    if (cumminsHpt(ctx)) return Object.keys(validate(ctx)).length ? 'incomplete configuration' : '';
    if (!fl.infolog) return '';  // Studio validates identity, OS and segments from the required HPT read.
    var ck = hptCheckDone(fl.infolog);
    if (!ck) return 'incomplete configuration';                      // unread, unreadable or not text: the form refuses those
    if (!ck.e41) return 'L5P infolog not recognised';                // reachable only while HPT_INFOLOG_STRICT is off
    if (!ck.vin) return 'L5P infolog VIN not found';
    if (ck.vin !== String(ctx.vin || '').toUpperCase()) return 'incomplete configuration';   // a field error on the page
    if (!ck.os) return 'L5P infolog OS not found';
    if (/^69/.test(ck.os)) return 'L5P on a SOTF OS builds by hand';   // already on a Studio SOTF OS (69 + the last 6 digits)
    if (HPT_OS_PROFILES.indexOf(ck.os) < 0) return 'L5P OS not in Studio profiles';
    return '';
  }

  // The _247_order object for a tune line (pure). Keys that do not apply are omitted; null only where SPEC 18b / 19
  // shows it: drive / driveSource / tcase on GM routes only (tcase null on a 4x2); patcher only when autoPatch (the
  // Master Patcher fields on Cummins, the GM AISIN Patcher's native GM order on GM), autoPatchReason only when not;
  // efi only on EFI Live; ecm on Cummins 6.7L EFI Live (null values for 2007-2009, which collect no ECM identifiers)
  // and on 2022-2024 Cummins EZ-Lynk (E/C only); trans and ez are always present (null when there is none / on EFI
  // Live); po (SPEC 21a) is always present (the PO Number, or null); the AISIN add-on's trans.autoPatch is the line's
  // own autoPatch (SPEC 21c: built in the same GM AISIN Patcher pass as the ECM file).
  function orderData(ctx, group) {
    var c = activeConfig(ctx);
    var def = ROUTES[ctx.routeId] || {};
    var ident = ctx.identity || {};
    var y = ident.year == null ? null : ident.year;
    var efi = ctx.flow === 'efi_live';
    var reason = autoPatchReason(ctx, c);
    var o = { v: ORDER_VERSION, source: '24-7-tuning', rules: RULES_VERSION };
    if (group || ctx.group) o.group = group || ctx.group;
    o.route = ctx.routeId;
    o.device = ctx.flow;
    // SPEC 26a: HP Tuners lines carry their own platform (gm_hpt); the route's (gm_ez) stays with its EZ-Lynk lines
    if (ctx.flow === 'hp_tuners' && def.hpt) o.platform = def.hpt.platform;
    else if (def.platform) o.platform = def.platform;
    o.vin = ctx.vin;
    if (y != null) o.year = y;
    if (ident.make) o.make = ident.make;
    if (ident.model) o.model = ident.model;
    var engine = engineLabel(ctx.identity, ctx.manual);
    if (engine) o.engine = engine;
    o.engineSelectedByCustomer = !!ctx.manual;
    if (driveApplies(ctx)) {
      // SPEC 19a / 19b: the drive that picks the GM file, where it came from, and a 4x4's transfer case
      o.drive = c.driveType || null;
      o.driveSource = driveSourceOf(ctx);
      o.tcase = c.driveType === '4x4' ? (c.tcase || null) : null;
    }
    o.po = c.poNumber || null;                                     // SPEC 21a: the trimmed PO Number, or null
    o.autoPatch = !reason;
    if (reason) o.autoPatchReason = reason;
    var eo = c.engineOptions || {};
    var tr68 = c.ecmFileType === '68rfe' && !!c.transTuning;
    if (ctx.flow === 'sct') {
      // SPEC 23f: the SCT back end's order (kind sct60 / sct64), on every SCT line whatever autoPatch says
      o.patcher = sctPatcher(ctx, c);
    } else if (ctx.flow === 'hp_tuners') {
      // SPEC 26 3c: Peakside L5P Studio's inputs, only when autoPatch: level (--levels L1-L5 / SOTF), slave (--slave, the
      // normalised device serial), the VIN and the infolog OS. No master: Order Flow passes 40993.
      if (!reason) {
        o.patcher = { kind: cumminsHpt(ctx) ? 'cummins_hpt' : 'l5p_hpt', level: hptLevel(c), slave: c.hptSerial, vin: ctx.vin, os: (hptCheckDone(hptFiles(ctx).infolog) || {}).os || null };
      }
    } else if (!reason && earlyApplies(ctx)) {
      o.patcher = earlyPatcher(ctx, c);
    } else if (!reason && def.platform === 'cummins59') {
      // SPEC 23a: the 24/7 patcher's 5.9 kind (added after Brent's v1.3 test with exactly these keys, in this order);
      // "out" is added by the webhook. trans = Transmission Type, tune = "SOTF" (the CSP5 file) or "Level N".
      o.patcher = { kind: 'cummins59', trans: c.truckTransmission, tune: c.tuneType === 'sotf' ? 'SOTF' : 'Level ' + c.tuneLevel, vin: ctx.vin };
    } else if (!reason && def.platform === 'gm') {
      // SPEC 19b: the GM AISIN Patcher's native GM order (README.txt "order.json - native GM", in its field order);
      // "out" is added by the webhook. tcase "auto" is its electronic (push button) transfer case.
      o.patcher = {
        kind: 'gm', engine: gmEngine(ctx), year: y, trans: c.truckTransmission,
        tune: c.tuneType === 'sotf' ? 'SOTF' : 'Level ' + c.tuneLevel,
        drive: c.driveType, tcase: c.driveType === '4x4' ? c.tcase : null, vin: ctx.vin
      };
    } else if (!reason) {
      // the Master Patcher --order fields, in its order.json order (ORDER MODE README.txt), which the GM AISIN
      // Patcher's one-pass kind cummins reads from here (SPEC 21c); "out" comes only from the webhook's wrapper.
      // SPEC 21b: DO68 = 2013-2018 manual (engine only, Stock injectors, no shift / line). SPEC 23e: a cab & chassis is DO70
      // (2013-2018, Level N) or IA03 (2019-2021, Level N or OBD-SOTF), AISIN only (SPEC 24a): truck, injectors Stock, base,
      // vin, serial, autocal; no sound (the files are Rumble), engine options, shift or line. The truck follows the VIN
      // rule: a pickup never gets DO70 / IA03, a cab & chassis never DO66 / DO67 / DO68 / IA01 / IA02.
      var cc = cabChassisVin(ctx.vin);
      var p = { truck: cc ? (y <= 2018 ? 'DO70' : 'IA03') : (y <= 2018 ? ({ '68rfe': 'DO66', aisin: 'DO67', manual: 'DO68' })[c.ecmFileType] : ({ '68rfe': 'IA01', aisin: 'IA02' })[c.ecmFileType]) };
      if (cc) p.injectors = 'Stock';
      else if (y <= 2018) p.injectors = PATCHER_INJ[c.injectors];
      // Brent: CCV-Cruise SOTF on every Cummins pickup; the cab & chassis SOTF is the OBD SOTF (CSP5, 2019-2021 only)
      p.base = c.tuneType === 'sotf' ? (cc ? 'OBD-SOTF' : 'CCV-SOTF') : 'Level ' + c.tuneLevel;
      if (!cc) {
        p.sound = labelOf(IDLE_SOUNDS, c.idleSound);
        p.modvgt = !!eo.modifiedVgtTurbo;
        p.intake = !!eo.fiveInchIntakeS400Swap;
        p.hclbf = !!eo.lbfHardcut;
        // shift / line: 68RFE with Transmission Tuning only (the AISIN TCM file is separate: see trans)
        p.shift = tr68 ? (labelOf(SHIFT_POINTS['68rfe'], c.shiftPoints) || null) : null;
        p.line = tr68 ? (PATCHER_LINE[c.transPressure] || null) : null;
      }
      p.vin = ctx.vin;
      p.serial = str(c.ecmSerial).replace(/\s/g, '');
      p.autocal = true;
      o.patcher = p;
    }
    if (efi && def.platform === 'cummins') {
      var ids = ecmIdsApply(ctx);
      o.ecm = { ec: ids && c.ecmEc ? c.ecmEc : null, serial: ids && c.ecmSerial ? c.ecmSerial : null };
    } else if (ezEcApplies(ctx)) {
      o.ecm = { ec: c.ecmEc || null, serial: null };              // SPEC 19c: 2022-2024 EZ-Lynk asks the E/C only
    }
    if (efi) {
      var trn = def.platform === 'cummins' ? labelOf(fileTypesFor(ctx), c.ecmFileType) : labelOf(GM_TRANS, c.truckTransmission);
      o.efi = {
        tuneType: c.tuneType || null,
        tuneLevel: c.tuneType === 'single' && c.tuneLevel ? c.tuneLevel : null,
        deviceSerial: c.deviceSerial || null,
        linkCodesRequested: !!c.linkCodesRequested,
        transmission: trn || null,
        injectors: c.injectors ? ORDER_INJ[c.injectors] || null : null,
        tireDiameter: def.platform === 'gm' && c.tireDiameter ? c.tireDiameter : null
      };
    }
    var sd = sctDef(ctx);
    if (sd) {
      // SPEC 22d: what Brent builds the SCT files from (labels as the product pages / the form show them). files = the
      // number of single files bought (null for the 6.4 SOTF file); levels = their names ([] for SOTF).
      var single = sd.kind === '60' || c.tuneType === 'single';
      var s = { serial: c.sctSerial || null };
      if (sd.kind === '60') s.strategy = c.ecmStrategy || null;
      else s.tcuStrategy = labelOf(TCU_STRATEGIES, c.tcuStrategy) || null;
      s.tuneType = sd.kind === '60' ? 'single' : (c.tuneType || null);
      s.files = single && c.sctLevels && c.sctLevels.length ? c.sctLevels.length : null;
      s.levels = single ? sctLevelLabels(c.sctLevels, sd) : [];
      if (sd.kind === '60') {
        s.turbo = labelOf(SCT_TURBOS, c.sctTurbo) || null;
        s.injectors = labelOf(SCT_INJECTORS, c.sctInjectors) || null;
      }
      s.transmission = sctTransmission(c, sd);
      if (sd.kind === '60') s.nonVgt = c.sctTurbo === 'non_vgt';   // SPEC 23d: the 6.4 has no Non-VGT choice (no key)
      if (sd.kind === '60') {
        // SPEC 23c6: what picks the file in the For SCT tree (6.0 Patcher --order): the idle and the sensor modifiers
        s.idle = labelOf(IDLE_SOUNDS, c.idleSound) || null;
        s.sensors = labelOf(SCT_SENSORS, c.sctSensors) || null;
        s.ebp64 = c.sctSensors ? sensorsEbp(c.sctSensors) : null;
        s.its100 = c.sctSensors ? sensorsIts(c.sctSensors) : null;
        s.hardcut = c.sctLimiter === 'hardcut4200';
      }
      o.sct = s;
    }
    if (ctx.flow === 'hp_tuners') {
      // SPEC 26 3c: what the customer ordered and uploaded. tuneLevel null for SOTF; the file names capped at TEXT_MAX; the sizes
      // are the exact byte counts the page uploads (Order Flow compares them with what it downloads); infolog.os null when the
      // connected block had no OS line. The upload URLs are never here: Shopify sets them on the line (_247_infolog /
      // _247_stock_hpt), and a consumer reads them from the line's properties.
      var hf = hptFiles(ctx), hck = hptCheckDone(hf.infolog);
      o.hpt = {
        input: 'stock_hpt',
        tuneType: c.tuneType || null,
        tuneLevel: c.tuneType === 'single' && c.tuneLevel ? c.tuneLevel : null,
        serial: c.hptSerial || null,
        infolog: hf.infolog ? { name: hptFileName(hf.infolog.name, TEXT_MAX), size: Number(hf.infolog.size) || 0, os: hck && hck.os ? hck.os : null } : null,
        stock: hf.stock ? { name: hptFileName(hf.stock.name, TEXT_MAX), size: Number(hf.stock.size) || 0 } : null
      };
      if (cumminsHpt(ctx) && c.tuneType === 'sotf') o.hpt.sotfMode = c.hptSotfMode;
    }
    var trans = null;
    if (efi && def.platform === 'cummins' && c.transTuning) {
      trans = {
        type: labelOf(FILE_TYPES, c.ecmFileType),
        shiftPoints: labelOf(SHIFT_POINTS[c.ecmFileType] || [], c.shiftPoints) || null,
        pressure: c.ecmFileType === '68rfe' ? (labelOf(PRESSURES, c.transPressure) || null) : null
      };
      // SPEC 21c: the AISIN TCM file is built in the same GM AISIN Patcher pass as the ECM file (one BBX), so it is
      // auto-built exactly when the line is; 68RFE transmission tuning is built into the ECM file (patcher.shift /
      // patcher.line) and has no flag of its own
      if (c.ecmFileType === 'aisin') trans.autoPatch = !reason;
    } else if (ctx.flow === 'ez_lynk' && hasAddon(ctx) && c.transTuning) {
      trans = { type: 'Allison' };   // SPEC 13: the L5P Allison add-on has no shift or pressure inputs
    }
    o.trans = trans;
    o.ez = ctx.flow === 'ez_lynk'
      ? { supportPackage: c.supportPackage || null, ecmUnlocked: c.ecmUnlocked === 'yes' ? 'yes' : null, transTuning: !!c.transTuning }
      : null;
    return o;
  }
  // SPEC 23f: the SCT patcher block. 6.0: {kind sct60, family, vehicle, levels (the page's names), injectors, turbo, idle, trans,
  // ebp64, its100, serial, strategy, vin}; 6.4: {kind sct64, tcu, tune, levels (single files only), serial, vin}. vehicle (Brent:
  // "Excursions must have the excursion modifier applied", an Excursion-only PATS modifier): "excursion" | "superduty", from the
  // decoded Model.
  function sctPatcher(ctx, c) {
    var sd = sctDef(ctx);
    if (!sd) return null;
    var names = sctLevelLabels(c.sctLevels, sd);
    if (sd.kind === '60') {
      return {
        kind: 'sct60', family: sct60Family(ctx.identity),
        vehicle: /^excursion$/i.test(str((ctx.identity || {}).model)) ? 'excursion' : 'superduty', levels: names, injectors: labelOf(SCT_INJECTORS, c.sctInjectors) || null,
        turbo: SCT60_PATCHER_TURBO[c.sctTurbo] || null, idle: labelOf(IDLE_SOUNDS, c.idleSound) || null, trans: c.truckTransmission || null,
        ebp64: sensorsEbp(c.sctSensors), its100: sensorsIts(c.sctSensors), hardcut: c.sctLimiter === 'hardcut4200', serial: c.sctSerial || null, strategy: c.ecmStrategy || null,
        vin: ctx.vin
      };
    }
    var p = { kind: 'sct64', tcu: labelOf(TCU_STRATEGIES, c.tcuStrategy) || null, tune: c.tuneType || null };
    if (c.tuneType === 'single') p.levels = names;
    p.serial = c.sctSerial || null;
    p.vin = ctx.vin;
    return p;
  }

  // _247_order as sent: compact JSON (no whitespace); SPEC 18b keeps it well under 1,000 characters (every text
  // field the page collects is capped at TEXT_MAX characters). SPEC 23f: an SCT line carries the sct and patcher blocks, so a
  // valid one runs to ~1,150 characters (five files, a 40-character PO); Shopify documents no property length limit.
  function orderJson(ctx, group) { return JSON.stringify(orderData(ctx, group)); }

  // One atomic /cart/add.js payload. Only active fields; underscore properties stay hidden at checkout.
  function buildCartPayload(ctx, quote, group) {
    if (!quote || quote.status !== 'ready' || !quote.lines.length) throw new Error('quote_not_ready');
    var c = activeConfig(ctx);
    if (gateApplies(ctx) && c.ecmUnlocked !== 'yes') throw new Error('ecm_not_eligible');
    var tune = quote.lines[0];
    var p = {};
    p.VIN = ctx.vin;
    p.Vehicle = vehicleProperty(ctx.identity, ctx.manual);
    p['Tuning Device'] = ctx.flow === 'ez_lynk' ? 'EZ-Lynk' : (ctx.flow === 'sct' ? 'SCT' : (ctx.flow === 'hp_tuners' ? 'HP Tuners' : 'EFI Live'));
    if (ctx.manual) p['Engine Selected By Customer'] = 'Yes';
    if (ctx.flow === 'hp_tuners') {
      // SPEC 26 3b: never a line the page would refuse (the files and serial are re-checked here); the file names only (the
      // files themselves go in the multipart add as _247_infolog / _247_stock_hpt, hptFormFields)
      var herr = validate(ctx);
      if (Object.keys(herr).length) throw new Error('hpt_invalid');
      var hfl = hptFiles(ctx);
      p.Tune = hptTuneLabel(c);
      p[T.hptSerialShort] = c.hptSerial;                           // "Device S/N", the HP Tuners product page's own label
      if (hfl.infolog) p['Infolog File'] = hptFileName(hfl.infolog.name, HPT_NAME_PROP_MAX);
      p['Stock Read File'] = hptFileName(hfl.stock.name, HPT_NAME_PROP_MAX);
    } else if (ctx.flow === 'sct') {
      // SPEC 22d: the product pages' own labels, so Brent's hand build reads what the product page orders show
      var sd = sctDef(ctx);
      if (!sd) throw new Error('sct_route');
      if (sd.kind === '60' && c.sctInjectors === 'over_330') throw new Error('sct_manual_build');   // the product page builds it
      // SPEC 23: never a 6.0 line without its idle / sensors, never a Non-VGT Hiss file (it does not exist)
      if (sd.kind === '60' && (!c.idleSound || !c.sctSensors || (c.sctTurbo === 'non_vgt' && c.idleSound !== 'rumble'))) throw new Error('sct_incomplete');
      var names = sctLevelLabels(c.sctLevels, sd);
      if (sd.kind === '60') {
        p['Device S/N'] = c.sctSerial;
        p['ECU Strategy'] = c.ecmStrategy;
        p['Tune Selection'] = names.join(', ');
        p['Idle Sound'] = labelOf(IDLE_SOUNDS, c.idleSound);      // SPEC 23c6
        p.Turbo = labelOf(SCT_TURBOS, c.sctTurbo);
        p.Injectors = labelOf(SCT_INJECTORS, c.sctInjectors);
        p['Transmission Type'] = labelOf(GM_TRANS, c.truckTransmission);
        p['Rev Limiter'] = labelOf(SCT_LIMITERS, c.sctLimiter);
        p.Sensors = labelOf(SCT_SENSORS, c.sctSensors);           // SPEC 23c6
      } else {
        p['Device S/N Number'] = c.sctSerial;
        p['TCU Strategy'] = labelOf(TCU_STRATEGIES, c.tcuStrategy);
        p.Tune = labelOf(SCT_TUNE_TYPES, c.tuneType);
        if (c.tuneType === 'single') p['Power Level'] = names.join(', ');
        p['Transmission Type'] = sctTransmission(c, sd);
      }
    } else if (ctx.flow === 'ez_lynk') {
      p['Support Package'] = labelOf(SUPPORT, c.supportPackage);
      if (c.ecmUnlocked === 'yes') p['ECM Previously Tuned Or Unlocked'] = 'Yes';   // SPEC 13, 2017-2018 L5P only
      if (ezEcApplies(ctx)) {                                      // SPEC 19c: 2022-2024 Cummins EZ-Lynk
        if (!c.ecmEc) throw new Error('ec_missing');
        p['E/C Number'] = c.ecmEc;
      }
    } else {
      p.Tune = tuneLabel(c, ctx);
      p['EFI Live Device Serial'] = c.deviceSerial;
      p['Link Codes'] = c.linkCodesRequested ? T.requested : T.notRequested;
      if (ctx.platform === 'cummins') {
        if (idleApplies(ctx)) p['Idle Sound'] = labelOf(idleSoundsFor(ctx), c.idleSound);   // SPEC 23e: not on a cab & chassis
        if (ecmIdsApply(ctx)) {             // SPEC 15d: E/C Number right before ECM Serial; neither for 2007-2009
          p['E/C Number'] = c.ecmEc;
          p['ECM Serial'] = c.ecmSerial;
        }
        if (injectorsApply(ctx)) p.Injectors = labelOf(INJECTORS, c.injectors);   // SPEC 18c: 2013-2018 only
        p['Transmission Type'] = labelOf(fileTypesFor(ctx), c.ecmFileType);   // Brent 2026-10-18: customer-facing name is Transmission Type
        if (eoApplies(ctx)) {                                        // SPEC 23e: not on a cab & chassis
          var eo = engineOptionLabels(c.engineOptions, ctx);
          p['Engine Options'] = eo.length ? eo.join(', ') : 'None';
        }
      }
      if (ctx.platform === 'cummins59') {   // SPEC 15b
        p.Injectors = labelOf(INJECTORS, c.injectors);
        p['Transmission Type'] = labelOf(GM_TRANS, c.truckTransmission);
      }
      if (ctx.platform === 'gm') {
        p['Truck Transmission'] = labelOf(GM_TRANS, c.truckTransmission);
        p['Tire Diameter'] = c.tireDiameter + ' in';
      }
    }
    if (driveApplies(ctx)) {               // SPEC 19a / 19b: every GM route, after its own visible properties
      if (!c.driveType || (c.driveType === '4x4' && !c.tcase)) throw new Error('drive_missing');
      p['Drive Type'] = labelOf(DRIVES, c.driveType);
      if (driveSourceOf(ctx) === 'customer') p['Drive Type Selected By Customer'] = 'Yes';
      if (c.driveType === '4x4') p['Transfer Case'] = findBy(TCASES, c.tcase).short;
    }
    if (poProblem(c.poNumber)) throw new Error('po_invalid');
    if (c.poNumber) p[PO_KEY] = c.poNumber;  // SPEC 21a: on every line of the build, only when entered
    p._247 = '1';                          // SPEC 18a: the line marker the order webhook looks for
    p._247_route = ctx.routeId;
    p._247_config = JSON.stringify(c);
    p._247_fingerprint = quote.fingerprint;
    p._247_group = group;
    p._247_rules = RULES_VERSION;
    p._247_order = orderJson(ctx, group);  // SPEC 18b: the auto-patcher data
    var items = [{ id: tune.variantId, quantity: 1, properties: p }];
    var def = ROUTES[ctx.routeId];
    for (var i = 1; i < quote.lines.length; i++) {
      var l = quote.lines[i];
      if (l.role !== 'trans') continue;
      var tp;
      if (ctx.flow === 'ez_lynk') {
        // SPEC 13: the L5P Allison add-on has no shift or pressure inputs
        if (!(def && def.addon && c.transTuning)) continue;
        tp = { VIN: ctx.vin, For: def.addon.forLabel };
      } else {
        tp = { VIN: ctx.vin, For: '24/7 Tuning EFI Live Tune', 'Shift Points': labelOf(SHIFT_POINTS[c.ecmFileType] || [], c.shiftPoints) };
        if (c.ecmFileType === '68rfe') tp['Transmission Pressure'] = labelOf(PRESSURES, c.transPressure);
      }
      if (c.poNumber) tp[PO_KEY] = c.poNumber;
      tp._247 = '1';
      tp._247_group = group;
      items.push({ id: l.variantId, quantity: 1, properties: tp });
    }
    return { items: items };
  }

  // SPEC 26i: the multipart /cart/add.js fields of an HP Tuners line item, in order, as [name, string value] pairs: id,
  // quantity, then properties[<name>] for every property (visible first, then the hidden ones). The caller appends the two
  // files (properties[_247_infolog], properties[_247_stock_hpt]) and sections / sections_url after these.
  function hptFormFields(item) {
    var out = [['id', String(item.id)], ['quantity', String(item.quantity == null ? 1 : item.quantity)]];
    var p = item.properties || {};
    Object.keys(p).forEach(function (k) { out.push(['properties[' + k + ']', String(p[k])]); });
    return out;
  }
  // SPEC 26i: the HP Tuners line of this configuration already in the cart (by fingerprint), or null: {line, index, ok}; ok =
  // marked (SPEC 18a) and carrying both upload URLs. A line that is not ok is replaced (quantity 0, then a new multipart add),
  // never upgraded in place: /cart/change.js replaces the whole properties object, so the file URLs would be lost.
  function hptCartLine(cart, fp) {
    var lines = cart && Array.isArray(cart.items) ? cart.items : [];
    for (var i = 0; i < lines.length; i++) {
      var pr = lines[i] && lines[i].properties;
      if (!pr || !fp || pr._247_fingerprint !== fp) continue;
      return { line: lines[i], index: i, group: pr._247_group || null, ok: lineMarked(pr, true) && hptUploadsOk(pr) && typeof pr._247_group === 'string' && !!pr._247_group };
    }
    return null;
  }
  // SPEC 26i: the line a multipart add answered with: a flat add returns the line item itself ({key, variant_id, properties});
  // an {items: [...]} answer is searched for this build's group. null when neither shape is there.
  function hptReplyLine(j, group) {
    if (!j || typeof j !== 'object') return null;
    if (Array.isArray(j.items)) {
      for (var i = 0; i < j.items.length; i++) if (j.items[i] && j.items[i].properties && j.items[i].properties._247_group === group) return j.items[i];
      return j.items.length === 1 ? j.items[0] : null;
    }
    return (j.key != null || j.variant_id != null) ? j : null;
  }

  function newGroupId() {
    return '247-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  // Cart reconciliation (theme-notes 5, SPEC 5). A configuration is in the cart only when its whole group is: the
  // tune line carrying its _247_fingerprint plus every other payload line (same variant, same _247_group).
  function cartLineVariant(line) {
    var v = line ? (line.variant_id != null ? line.variant_id : line.id) : null;
    return v == null ? null : Number(v);
  }
  // A payload item moved into an existing group: _247_group, and on the tune line the group inside _247_order too.
  function regroup(item, group) {
    var props = {}, src = item.properties || {};
    for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) props[k] = src[k];
    props._247_group = group;
    if (typeof props._247_order === 'string') {
      try {
        var o = JSON.parse(props._247_order);
        if (o && typeof o === 'object') { o.group = group; props._247_order = JSON.stringify(o); }
      } catch (e) { /* built by orderJson: always JSON */ }
    }
    return { id: item.id, quantity: item.quantity, properties: props };
  }
  // SPEC 18a: a cart line counts only when it carries the line marker _247 (and a tune line its _247_order). A line
  // added before SPEC 18 matches the fingerprint but has neither, so the order would carry no label and no build data.
  function lineMarked(props, tune) {
    return !!props && props._247 === '1' && (!tune || (typeof props._247_order === 'string' && props._247_order !== ''));
  }
  // The /cart/change.js body that upgrades such a line in place: the same line (its key; its quantity kept) with the
  // current payload properties in that line's group. Shopify replaces the line's properties (and gives it a new key).
  function upgradeOf(line, index, item, group) {
    var body = line && line.key ? { id: String(line.key) } : { line: index + 1 };
    body.quantity = line && line.quantity != null ? Number(line.quantity) : 1;
    body.properties = regroup(item, group).properties;
    return body;
  }
  // items: the payload items, tune line first. Returns { group, missing, upgrade }: group is the _247_group of a cart
  // tune line with this fingerprint (null when there is none: every item is missing); missing lists the payload items
  // that are not in the cart under that group, re-grouped to it so a re-added add-on links to the existing tune line;
  // upgrade lists the /cart/change.js bodies for lines of that group that lack the SPEC 18 markers. The configuration
  // is completely (and correctly) in the cart only when group is set and missing and upgrade are both empty.
  function cartGroupCheck(cart, items, fp) {
    var lines = cart && Array.isArray(cart.items) ? cart.items : [];
    items = items || [];
    var best = null;
    for (var i = 0; i < lines.length; i++) {
      var pr = lines[i] && lines[i].properties;
      if (!pr || !fp || pr._247_fingerprint !== fp) continue;
      var g = pr._247_group;
      if (typeof g !== 'string' || !g) continue;
      var miss = [], up = [];
      if (items.length && !lineMarked(pr, true)) up.push(upgradeOf(lines[i], i, items[0], g));
      for (var k = 1; k < items.length; k++) {
        var want = Number(items[k].id), at = -1;
        for (var j = 0; j < lines.length && at < 0; j++) {
          var lp = lines[j] && lines[j].properties;
          if (j !== i && cartLineVariant(lines[j]) === want && !!lp && lp._247_group === g) at = j;
        }
        if (at < 0) miss.push(regroup(items[k], g));
        else if (!lineMarked(lines[at].properties, false)) up.push(upgradeOf(lines[at], at, items[k], g));
      }
      if (!best || miss.length < best.missing.length || (miss.length === best.missing.length && up.length < best.upgrade.length)) {
        best = { group: g, missing: miss, upgrade: up };
      }
      if (!miss.length && !up.length) break;
    }
    return best || { group: null, missing: items.slice(), upgrade: [] };
  }
  // The cart's ISO currency (/cart.js gives a string; some themes pass { iso_code }), or null when unknown.
  function cartCurrency(cart) {
    if (!cart) return null;
    var c = typeof cart.currency === 'string' ? cart.currency : (cart.currency && cart.currency.iso_code);
    return c ? String(c).toUpperCase() : null;
  }
  // true only when both currencies are known and differ: an unreadable cart never blocks an add
  function currencyChanged(cart, iso) {
    var c = cartCurrency(cart);
    return !!(c && iso && c !== String(iso).toUpperCase());
  }

  /* =========================================================================
     8. Money: derive the store format from a Liquid-formatted sample of 1234567.89 (SPEC 12e)
     ========================================================================= */
  // The sample's digits must be exactly the known subunits (123456789 -> 2 decimals) or their whole-unit rounding
  // (1234568 -> 0 decimals); anything else (a malformed or foreign sample) falls back to Intl with the cart currency.
  function moneyFormatter(sample, iso) {
    var m = /^(\D*?)(\d[\d.,'\s  ’]*\d)(\D*)$/.exec(String(sample || ''));
    if (m) {
      var num = m[2];
      var digitStr = num.replace(/\D/g, '');
      var decimals = digitStr === MONEY_SAMPLE_SUBUNITS ? 2
        : (digitStr === String(Math.round(Number(MONEY_SAMPLE_SUBUNITS) / 100)) ? 0 : -1);
      if (decimals >= 0) {
        var decSep = decimals ? num.charAt(num.length - decimals - 1) : '';
        var intPart = decimals ? num.slice(0, num.length - decimals - 1) : num;
        var seps = intPart.replace(/\d/g, '');
        var thou = seps ? seps.charAt(0) : '';
        var sepsOk = seps.split(thou).join('') === '' && !(thou && thou === decSep);   // one grouping char, never the decimal mark
        if (sepsOk && (!decimals || !/\d/.test(decSep))) {
          return function (cents) {
            if (typeof cents !== 'number' || !isFinite(cents)) return null;
            var fixed = (cents / 100).toFixed(decimals).split('.');
            return m[1] + fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (decimals ? decSep + fixed[1] : '') + m[3];
          };
        }
      }
    }
    return function (cents) {
      if (typeof cents !== 'number' || !isFinite(cents) || !iso) return null;
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: iso }).format(cents / 100); } catch (e) { return null; }
    };
  }

  /* =========================================================================
     9. Performance data (SPEC 7): ships empty; approved values only
     ========================================================================= */
  function perfFor(perf, routeId, level, engineOptions) {
    if (!perf || !routeId || level == null) return null;
    if (engineOptions && (engineOptions.lbfHardcut || engineOptions.modifiedVgtTurbo || engineOptions.fiveInchIntakeS400Swap)) return null;
    var byRoute = perf[routeId];
    var d = byRoute && byRoute[String(level)];
    if (!d || typeof d.stockHp !== 'number' || typeof d.tunedHp !== 'number' || typeof d.gainHp !== 'number' || !d.basis) return null;
    return d;
  }
  function perfLevels(perf, routeId) {
    var byRoute = perf && perf[routeId];
    if (!byRoute) return [];
    return Object.keys(byRoute).filter(function (k) { return perfFor(perf, routeId, k, null); }).sort();
  }

  /* =========================================================================
     9b. Product-page power gains (Brent 2026-10-18: "show the HP estimates based off what the product pages say the
         power gain is"). Copied from each product's description on 2026-10-18. Gains only (the pages give no stock
         figure), in the order each page lists them; Level N = the Nth listed level. Products whose page lists no
         figures (2008-2010 6.4 EZ-Lynk, 2017-2023 L5P EZ-Lynk) are absent, so their block stays hidden.
     ========================================================================= */
  var PAGE_GAINS = {
    '2006-2021-cummins-efilive-custom-tune-files': { bands: [
      // SPEC 15c: the page's "2006-2009 Cummins" list (four levels) and its 2010-2012 list
      { from: 2007, to: 2009, levels: [[25, 'Tow'], [45, 'Economy'], [75, 'Street'], [90, 'Race']] },
      { from: 2010, to: 2012, levels: [[25, 'Tow'], [45, 'Economy'], [75, 'Daily'], [90, 'Street'], [120, 'Race']] },
      // SPEC 16 (Brent 2026-10-18): the page's 2013-2018 and 2019+ lists now match the EZ-Lynk packages
      // ("0HP Stock Power" is not a purchasable level, so it is not listed)
      { from: 2013, to: 2018, levels: [[50, 'Economy/Tow'], [75, 'Daily'], [90, 'Street'], [120, 'Race'], [150, 'Extreme']] },
      { from: 2019, to: 2024, levels: [[50, 'Economy/Tow'], [75, 'Daily'], [90, 'Street'], [120, 'Race'], [150, 'Extreme']] }
    ] },
    '2006-2007-5-9-cummins-efi-live-files': { levels: [[25], [50], [90], [140], [190]] },   // SPEC 15b: no level names
    '2001-2010-duramax-efi-live-tune-files': { levels: [[25, 'Tow'], [45, 'Economy'], [75, 'Street'], [90, 'Performance'], [120, 'Race']] },
    '2011-2016-lml-duramax-efi-live-tuning': { levels: [[25, 'Tow'], [45, 'Economy'], [75, 'Street'], [90, 'Performance'], [120, 'Race']] },
    '2013-2021-cummins-ezlynk-support-packages': { levels: [[50, 'Economy/Tow'], [75, 'Daily'], [90, 'Street'], [120, 'Race'], [150, 'Extreme']] },
    '22-24-6-7-cummins-ezlynk-support-packages': { levels: [[50], [75], [90], [120], [150]] },
    '2020-2022-6-7-powerstroke-ezlynk-tuning': { levels: [[25], [50], [75], [90], [120], [150]] },
    '2023-2026-6-7-powerstroke-ezlynk-tuning': { levels: [[25], [50], [75], [90], [120], [150]] },
    '2018-2020-3-0-powerstroke-ez-lynk-support-packages': { upTo: 120 },
    // SPEC 22d: the 6.0 SCT page's "Tune Selection" names and figures (named levels: shown by name, never "Level N"),
    // and the 6.4 SCT page's "Approx power levels below. 50HP 100HP 150HP 200HP 300HP" (Level N = the Nth figure)
    '2003-2007-6-0-powerstroke-custom-tuning': { named: true, levels: [[0, 'HD 12K Tow'], [50, 'Tow'], [75, 'Street'], [100, 'Hot Street'], [150, 'Performance']] },
    // SPEC 23h (Brent 2026-10-18: "Just make them all say 250+ for level 5 for 6.4"): Level 5 reads "250+" (drawn as +250)
    '2008-2010-powerstroke-sct-custom-tune-files': { levels: [[50], [100], [150], [200], [250, '', '250+']] },
    // SPEC 26h (Q6): the HP Tuners L5P product's "L5P Power Levels: Stock Delete +50HP +75HP +90HP +120HP +150HP" (read
    // 2026-10-21); "Stock Delete" is not one of the five purchasable levels, so Level N = the Nth gain, as in SPEC 14 / 16
    '2017-2023-duramax-mpvi2-mpvi3-tune-files': { levels: [[50], [75], [90], [120], [150]] }
  };
  // [{level, gain, name, named}] for a product (and model year for banded pages), or null
  function pageGains(handle, year) {
    var g = handle && PAGE_GAINS[handle];
    if (!g) return null;
    var list = g.levels;
    if (g.bands) {
      var b = null;
      for (var i = 0; i < g.bands.length; i++) if (year != null && year >= g.bands[i].from && year <= g.bands[i].to) b = g.bands[i];
      list = b ? b.levels : null;
    }
    if (!list) return g.upTo ? { upTo: g.upTo } : null;
    return list.map(function (x, i) {
      var o = { level: i + 1, gain: x[0], name: x[1] || '' };
      if (x[2]) o.label = x[2];        // SPEC 23h: the figure as shown when it is not the plain number (6.4 Level 5 "250+")
      if (g.named) o.named = true;
      return o;
    });
  }
  // SPEC 23h: a gain as shown (the label when the page gives one, e.g. "250+"; the number otherwise)
  function gainLabel(g) { return g && g.label ? g.label : String(g ? g.gain : ''); }
  function pageGainFor(handle, year, level, engineOptions) {
    if (engineOptions && (engineOptions.lbfHardcut || engineOptions.modifiedVgtTurbo || engineOptions.fiveInchIntakeS400Swap)) return null;
    var l = pageGains(handle, year);
    if (!l || !l.length || level == null) return null;
    return l[Number(level) - 1] || null;
  }

  /* =========================================================================
     9c. Dyno graph (SPEC 17 / 17b; Brent 2026-10-18: "I want a dyno graph visualizer" ... "Just like in the pdf
         reference"). Illustrative curve SHAPES carrying one real figure, the product-page gain at the peak.
         SPEC 17 torque model, RPM 1,000-3,400 every 50: stock HP = T(r) * r / 5252 with a torque hump
         T(r) = Tpk * max(0, 1 - ((r - Rpk) / span)^2), Tpk scaled so the stock peak is a nominal 350 units (a fixed
         scale, never shown); tune HP adds a torque bump Tg * exp(-((r - Rb) / width)^2), with Tg solved by bisection
         so the largest tuned-minus-stock gap over the samples equals the page's gain in the same units. One fixed
         y-domain [0, 560] for every truck, route and level, so +150 visibly beats +50.
         17b ("exactly like the board"): the hump and bump constants are least-squares fits to the two curves traced
         from board 5 (design/board05-dyno-crop.png), with a shorter span below the peak than above it (rise from the
         lower left, peak ~60% across, gentle ease down, gap widening toward the peak). SPEC 17's symmetric constants
         (1,900 / 1,700 and 2,300 / 900) drew a steep, nearly linear hump that did not look like the board. At +150 (the
         top level) the plot lands on the board's curves within a few pixels.
         Deliberate deviation from the dataviz default: NO hover tooltip, axes, ticks, gridlines, annotations or
         numbers inside the plot, because any value away from the peak would be invented (SPEC 17 / 17b).
     ========================================================================= */
  var DYNO = {
    rpmLo: 1000, rpmHi: 3400, rpmStep: 50,
    torquePeakRpm: 2050, torqueSpanLo: 1150, torqueSpanHi: 1650, bumpRpm: 1900, bumpWidthLo: 600, bumpWidthHi: 2300,
    stockPeak: 350, yMax: 560, gainMax: 300, w: 400, h: 112, inset: 8
  };
  // The fixed y-domain [0, 560] holds every gain up to +196 (stock peak 350 + gain + 14 of headroom), so every route
  // before SPEC 22 draws exactly as before. SPEC 22: only a larger gain (the 6.4 SCT's +300) widens the domain just
  // enough to fit, so the tune curve is never clipped and +300 still shows the biggest gap.
  function dynoYMax(gainHp) {
    var g = Math.min(DYNO.gainMax, Math.max(0, Number(gainHp) || 0));
    return Math.max(DYNO.yMax, DYNO.stockPeak + g + 14);
  }
  // {rpm: [...], stock: [...], tuned: [...], peakIdx} in the nominal units (gain clamped to 0..DYNO.gainMax)
  function dynoCurves(gainHp) {
    var rpm = [], shape = [], bump = [], r;
    for (r = DYNO.rpmLo; r <= DYNO.rpmHi; r += DYNO.rpmStep) {
      var q = (r - DYNO.torquePeakRpm) / (r < DYNO.torquePeakRpm ? DYNO.torqueSpanLo : DYNO.torqueSpanHi);
      var b = (r - DYNO.bumpRpm) / (r < DYNO.bumpRpm ? DYNO.bumpWidthLo : DYNO.bumpWidthHi);
      rpm.push(r);
      shape.push(Math.max(0, 1 - q * q) * r / 5252);
      bump.push(Math.exp(-b * b) * r / 5252);
    }
    var tpk = DYNO.stockPeak / Math.max.apply(null, shape);
    var stock = shape.map(function (s) { return tpk * s; });
    var gain = Math.min(DYNO.gainMax, Math.max(0, Number(gainHp) || 0));
    function maxGap(tg) {   // [largest tuned-minus-stock gap, its sample index] for a bump torque tg
      var m = -1, k = 0;
      for (var j = 0; j < bump.length; j++) if (tg * bump[j] > m) { m = tg * bump[j]; k = j; }
      return [m, k];
    }
    var lo = 0, hi = 1;
    while (maxGap(hi)[0] < gain) hi *= 2;
    for (var i = 0; i < 60; i++) {
      var mid = (lo + hi) / 2;
      if (maxGap(mid)[0] < gain) lo = mid; else hi = mid;
    }
    var tg = (lo + hi) / 2;
    return {
      rpm: rpm, stock: stock, tuned: stock.map(function (s, j) { return s + tg * bump[j]; }),
      peakIdx: maxGap(tg)[1]
    };
  }
  // a smooth path through the points (Catmull-Rom as cubic Beziers), 2 decimals
  function dynoPath(xs, ys) {
    function n(v) { return String(Math.round(v * 100) / 100); }
    var d = 'M' + n(xs[0]) + ' ' + n(ys[0]);
    for (var i = 0; i < xs.length - 1; i++) {
      var p = i ? i - 1 : 0, q = Math.min(xs.length - 1, i + 2);
      d += 'C' + n(xs[i] + (xs[i + 1] - xs[p]) / 6) + ' ' + n(ys[i] + (ys[i + 1] - ys[p]) / 6) + ' ' +
        n(xs[i + 1] - (xs[q] - xs[i]) / 6) + ' ' + n(ys[i + 1] - (ys[q] - ys[i]) / 6) + ' ' + n(xs[i + 1]) + ' ' + n(ys[i + 1]);
    }
    return d;
  }
  // opts: {gain, id, title, desc}. Board 5: stock (light dashed) + the tune (red), one hairline baseline, nothing else.
  function dynoSvg(opts) {
    var o = opts || {};
    var c = dynoCurves(o.gain);
    var x0 = DYNO.inset, x1 = DYNO.w - DYNO.inset, base = DYNO.h - 0.5;
    var xs = c.rpm.map(function (r) { return x0 + (r - DYNO.rpmLo) / (DYNO.rpmHi - DYNO.rpmLo) * (x1 - x0); });
    var yMax = dynoYMax(o.gain);
    function ys(list) { return list.map(function (v) { return base - v / yMax * (base - 0.5); }); }
    var id = String(o.id || 'pk247-dyno');
    var ve = ' vector-effect="non-scaling-stroke"';
    return '<svg class="pk247-dyno__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + DYNO.w + ' ' + DYNO.h + '"' +
        ' preserveAspectRatio="none" role="img" focusable="false" aria-labelledby="' + esc(id) + '-t" aria-describedby="' + esc(id) + '-d">' +
      '<title id="' + esc(id) + '-t">' + esc(o.title || '') + '</title>' +
      '<desc id="' + esc(id) + '-d">' + esc(o.desc || '') + '</desc>' +
      '<line class="pk247-dyno__base" x1="' + x0 + '" y1="' + base + '" x2="' + x1 + '" y2="' + base + '"' +
        ' stroke="#2B2B31" stroke-width="1" shape-rendering="crispEdges"' + ve + '/>' +
      '<path class="pk247-dyno__stock" d="' + dynoPath(xs, ys(c.stock)) + '" fill="none" stroke="#A7A7B2" stroke-width="1.5"' +
        ' stroke-dasharray="5 4" stroke-linecap="round" stroke-linejoin="round"' + ve + '/>' +
      '<path class="pk247-dyno__tune" d="' + dynoPath(xs, ys(c.tuned)) + '" fill="none" stroke="#D62438" stroke-width="2.5"' +
        ' stroke-linecap="round" stroke-linejoin="round"' + ve + '/>' +
      '</svg>';
  }

  /* =========================================================================
     10. The app (one per [data-pk247] root)
     ========================================================================= */
  var instances = [];

  function createApp(root) {
    var uid = String(root.getAttribute('data-pk247-section') || 'pk247').replace(/[^A-Za-z0-9_-]/g, '-');
    var dataEl = root.querySelector('script[data-pk247-data]') || document.getElementById('pk247-data');
    var data = null;
    try { data = JSON.parse(dataEl ? dataEl.textContent : ''); } catch (e) { data = null; }
    var app = root.querySelector('[data-pk247-app]') || root;
    var subtitleEl = root.querySelector('[data-pk247-subtitle]');
    var defaultSubtitle = subtitleEl ? subtitleEl.textContent : '';

    if (!data || !data.catalog || !data.routes) {
      app.innerHTML = '<p class="pk247-notice pk247-notice--error" role="alert">' + esc(T.dataError) + '</p>';
      return { destroy: function () {}, getState: function () { return null; } };
    }

    var fmtBase = moneyFormatter(data.moneySample, data.currency);
    // once the cart reports another market currency, no amount of this page's (old market) catalog is shown or
    // submitted again: every quote resolves to Price Unavailable until the page is reloaded
    function fmt(cents) { return S.marketChanged ? null : fmtBase(cents); }
    var flags = (data.flags && typeof data.flags === 'object') ? data.flags : {};   // SPEC 23b (section settings)
    var decoderUrl = (data.decoder && data.decoder.url) || DEFAULT_DECODER;
    var timeoutMs = (data.decoder && data.decoder.timeout_ms) || DEFAULT_TIMEOUT;
    var cartTimeoutMs = (data.cart && data.cart.timeout_ms) || DEFAULT_CART_TIMEOUT;
    var uploadTimeoutMs = (data.cart && data.cart.upload_timeout_ms) || DEFAULT_UPLOAD_TIMEOUT;   // SPEC 26i
    var perf = data.perf || {};
    var timers = { quote: null, redirect: null, live: null };
    var cartReq = { token: 0, ctrl: null };   // the one in-flight /cart/add.js request (token guards late answers)
    var fileSeq = 0;                          // SPEC 26e: each picked file's token (a late infolog read for a replaced file is ignored)
    var S = initialState();

    function initialState() {
      return {
        seq: 0, vin: '',
        decode: { status: 'idle' },
        manualPick: null, manualError: false,
        confirmId: 0, navigatedFor: 0,
        route: null, offer: null,
        device: null, deviceCommitted: false,
        form: emptyForm(null), previewLevelId: null,
        touched: {}, showAllErrors: false, reviewed: false, reviewedAt: 0,
        quote: { status: 'none', lines: [] }, lastAnnouncedTotal: null,
        // submit.status: idle | busy | success (verified 200 or verified already-in-cart, locked) | error | added (a
        // bfcache restore after success: unlocked; the notice stays while /cart.js still holds the configuration)
        submit: { status: 'idle', message: '', detail: '' },
        added: null,               // { fingerprint, group, items: [{id}], already } of the last verified add
        notice: null,
        marketChanged: false,      // the cart's currency differs from the page's (another market): reload needed
        // SPEC 26e: the HP Tuners files, kept outside the rendered DOM (a re-render rebuilds the region and empties every
        // <input type=file>): {file, name, size, lastModified, token, check} each, or null. A reload loses them by design.
        files: { infolog: null, stock: null },
        pendingCta: false          // SPEC 26f: Review / Add To Cart pressed while the infolog was still being read
      };
    }

    function id(name) { return 'pk247-' + name + '-' + uid; }
    function hid(key) { return id('h-' + key); }
    function fid(field) { return id('f-' + field); }

    /* ---------- static skeleton ---------- */
    app.innerHTML =
      '<div class="pk247__layout">' +
        '<div class="pk247__main">' +
          '<section class="pk247-sec pk247-vin" aria-labelledby="' + hid('vin') + '" data-pk247-r="vin">' +
            '<h2 class="pk247-vh" id="' + hid('vin') + '" tabindex="-1">' + esc(T.vinSection) + '</h2>' +
            '<form class="pk247-vin__form" novalidate data-pk247-vinform>' +
              '<label class="pk247-label" for="' + fid('vin') + '">' + esc(T.vinLabel) + '</label>' +
              '<div class="pk247-vin__row">' +
                '<div class="pk247-vin__field"><input class="pk247-input pk247-vin__input" id="' + fid('vin') + '" type="text" name="vin" ' +
                  'autocomplete="off" autocapitalize="characters" autocorrect="off" spellcheck="false" maxlength="40" aria-required="true" ' +
                  'placeholder="' + esc(T.vinPlaceholder) + '" aria-describedby="' + id('vin-help') + '" data-pk247-vin></div>' +
                '<button type="submit" class="pk247-btn pk247-vin__btn" data-pk247-decode>' + esc(T.vinAction) + '</button>' +
              '</div>' +
              '<p class="pk247-help" id="' + id('vin-help') + '">' + esc(T.vinHelper) + '</p>' +
              '<div class="pk247-fielderr" id="' + id('vin-err') + '" hidden></div>' +
            '</form>' +
            '<div class="pk247-vin__confirmed" hidden data-pk247-vinconfirmed>' +
              // a term / value pair (aria-labelledby is prohibited on a <p>, so it named nothing)
              '<dl class="pk247-vin__ro"><dt class="pk247-label" id="' + id('vin-ro-label') + '">' + esc(T.vinLabelShort) + '</dt>' +
              '<dd class="pk247-readonly" data-pk247-vinro></dd></dl>' +
              '<div class="pk247-vin__actions"><button type="button" class="pk247-link" id="' + id('edit-vin') + '" data-pk247-act="edit-vin">' + esc(T.editVin) + '</button></div>' +
            '</div>' +
          '</section>' +
          '<div class="pk247-region pk247-region--veh" data-pk247-r="veh"></div>' +
          '<div class="pk247-region pk247-region--flow" data-pk247-r="flow"></div>' +
        '</div>' +
        '<div class="pk247__side" data-pk247-side>' +
          '<div class="pk247-region pk247-region--perf" data-pk247-r="perf"></div>' +
          '<div class="pk247-region pk247-region--sum" data-pk247-r="sum"></div>' +
          '<div class="pk247-region pk247-region--perfez" data-pk247-r="perfez"></div>' +
        '</div>' +
      '</div>' +
      '<span class="pk247-live" role="status" aria-live="polite" aria-atomic="true" data-pk247-live></span>';

    var vinForm = app.querySelector('[data-pk247-vinform]');
    var vinInput = app.querySelector('[data-pk247-vin]');
    var vinBtn = app.querySelector('[data-pk247-decode]');
    var vinErr = document.getElementById(id('vin-err'));
    var vinConfirmed = app.querySelector('[data-pk247-vinconfirmed]');
    var vinRo = app.querySelector('[data-pk247-vinro]');
    var editVinBtn = document.getElementById(id('edit-vin'));
    var liveEl = app.querySelector('[data-pk247-live]');
    var sideEl = app.querySelector('[data-pk247-side]');
    if (window.PkVinScan && typeof window.PkVinScan.attach === 'function') {
      try { window.PkVinScan.attach(vinInput); } catch (e) { /* scanner is optional */ }
    }

    /* ---------- derived ---------- */
    function routeDef() { return S.route ? ROUTES[S.route.id] || null : null; }
    function flowOf() {
      if (!S.route) return null;
      var t = S.route.type;
      if (t === 'efi_live' || t === 'ez_lynk' || t === 'sct') return t;   // SPEC 22: the 6.0 is SCT, auto-assigned
      if (t === 'device_choice' && S.deviceCommitted) return S.device;
      return null;
    }
    function platformOf() { var d = routeDef(); return d ? d.platform || null : null; }
    function ctxOf() {
      var ident = S.decode.identity || null;
      return {
        routeId: S.route ? S.route.id : null, flow: flowOf(), platform: platformOf(), device: S.device,
        vin: S.vin, identity: ident, manual: S.route ? S.route.manual || null : null,
        form: S.form, offer: S.offer, files: filesMeta()
      };
    }
    // SPEC 26e: the files' metadata for the pure functions (never the File objects)
    function filesMeta() {
      var i = S.files.infolog, k = S.files.stock;
      return {
        infolog: i ? { name: i.name, size: i.size, lastModified: i.lastModified, check: i.check || null } : null,
        stock: k ? { name: k.name, size: k.size, lastModified: k.lastModified } : null
      };
    }
    function emptyFiles() { return { infolog: null, stock: null }; }
    // SPEC 13: a 2017-2018 L5P whose ECM was never tuned or unlocked cannot be sold EZ-Lynk at all: no package, no
    // order summary, no EZ-Lynk naming anywhere on the page, only the can't-tune message and the builder link
    function ineligibleNow() { return gateApplies(ctxOf()) && S.form.ecmUnlocked === 'no'; }
    function visibleErrors() {
      var all = validate(ctxOf()), out = {};
      for (var k in all) if (S.showAllErrors || S.touched[k]) out[k] = all[k];
      // SPEC 26f: "Checking Infolog..." blocks the action but is a status line under the field, never an error
      if (out.hptInfolog === T.hptChecking) delete out.hptInfolog;
      return out;
    }
    // SPEC 26f: the infolog is still being read
    function infologPending() {
      var i = S.files.infolog;
      return flowOf() === 'hp_tuners' && !!i && !!i.check && i.check.status === 'pending';
    }
    // While /cart/add.js is in flight, and after its real 200 (navigation under way), the purchase is locked: no
    // purchase input, device, Continue or Edit VIN may change what was sent (SPEC 5 / 6). Error and a bfcache
    // restore unlock it. The controls render disabled so the DOM always matches the state.
    function locked() { return S.submit.status === 'busy' || S.submit.status === 'success'; }
    function lockAttr() { return locked() ? ' disabled data-pk247-locked' : ''; }

    /* ---------- announcements ---------- */
    function announce(text) {
      if (!liveEl) return;
      clearTimeout(timers.live);
      liveEl.textContent = '';
      liveEl.setAttribute('data-last', text);
      timers.live = setTimeout(function () { liveEl.textContent = text; }, 40);
    }

    /* ---------- focus helpers ---------- */
    function focusEl(el) {
      if (!el) return;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
      var r = el.getBoundingClientRect();
      var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      if (r.top < top || r.bottom > window.innerHeight) {
        el.scrollIntoView({ block: 'start', behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    }
    function focusHeading(key) { focusEl(document.getElementById(hid(key))); }

    function setRegion(el, html) {
      if (!el) return;
      if (el.__pkHtml === html) return;
      var a = document.activeElement;
      var keepId = (a && a.id && el.contains(a)) ? a.id : null;
      var sel = null;
      if (keepId && a.tagName === 'INPUT' && /^(text|search|tel)$/i.test(a.type)) {
        try { sel = [a.selectionStart, a.selectionEnd]; } catch (e) { sel = null; }
      }
      el.innerHTML = html;
      el.__pkHtml = html;
      if (keepId) {
        var n = document.getElementById(keepId);
        if (n) {
          try { n.focus({ preventScroll: true }); } catch (e) { n.focus(); }
          if (sel) { try { n.setSelectionRange(sel[0], sel[1]); } catch (e) { /* not a text field */ } }
        }
      }
    }
    function region(name) { return app.querySelector('[data-pk247-r="' + name + '"]'); }

    /* =========================================================================
       Render
       ========================================================================= */
    function render(light) {
      renderSubtitle();
      renderVin();
      setRegion(region('veh'), vehicleHtml());
      if (!light) setRegion(region('flow'), flowHtml());
      else patchFlow();
      setRegion(region('review'), reviewHtml());
      setRegion(region('ready'), readyHtml());
      var perfHtmlStr = perfHtml();
      var sumHtmlStr = sumHtml();
      setRegion(region('perf'), perfHtmlStr);
      setRegion(region('sum'), sumHtmlStr);
      region('perf').hidden = !perfHtmlStr;
      region('sum').hidden = !sumHtmlStr;
      var perfEzStr = perfEzHtml();
      setRegion(region('perfez'), perfEzStr);
      region('perfez').hidden = !perfEzStr;
      region('sum').classList.toggle('pk247-region--path', sumHtmlStr.indexOf('pk247-sum--path') >= 0);
      sideEl.hidden = !perfHtmlStr && !sumHtmlStr && !perfEzStr;
      var flow = flowOf();
      root.setAttribute('data-pk247-state', S.route ? (flow || S.route.type) : S.decode.status);
      app.classList.toggle('pk247--ez', flow === 'ez_lynk');
      // SPEC 22f: below 990px the SCT power block follows the form, so its growth never moves the level list
      app.classList.toggle('pk247--sct', flow === 'sct');
      updateSticky();
    }

    function renderSubtitle() {
      if (!subtitleEl) return;
      // copy deck 3.1: page.supporting by default (device choice included), subtitle.ezlynk, subtitle.efi, and
      // subtitle.review once Review Configuration has opened the Configuration Summary
      var t = defaultSubtitle, flow = flowOf(), d = routeDef();
      if (flow === 'ez_lynk') t = ineligibleNow() ? defaultSubtitle : T.subtitleEz;
      else if (flow === 'efi_live') t = S.reviewed ? T.subtitleReview : (d && d.platform === 'gm' ? 'GM' : 'Cummins') + ' / EFI Live Configuration';
      else if (flow === 'sct') t = S.reviewed ? T.subtitleReview : 'Ford / SCT Configuration';   // SPEC 22
      else if (flow === 'hp_tuners') t = S.reviewed ? T.subtitleReview : (cumminsHpt(ctxOf()) ? 'Cummins' : 'GM') + ' / HP Tuners Configuration';   // SPEC 26h
      if (subtitleEl.textContent !== t) subtitleEl.textContent = t;
    }

    function renderVin() {
      var confirmed = !!S.route;
      vinForm.hidden = confirmed;
      vinConfirmed.hidden = !confirmed;
      if (confirmed) vinRo.textContent = S.vin;
      if (locked()) editVinBtn.setAttribute('aria-disabled', 'true'); else editVinBtn.removeAttribute('aria-disabled');
      var loading = S.decode.status === 'loading';
      vinBtn.textContent = loading ? T.vinBusy : T.vinAction;
      if (loading) vinBtn.setAttribute('aria-busy', 'true'); else vinBtn.removeAttribute('aria-busy');
      var msg = '';
      if (S.decode.status === 'invalid') msg = S.decode.problem.message;
      else if (S.decode.status === 'checkvin') msg = T.checkVpic;
      var desc = id('vin-help');
      if (msg) {
        // the hidden full stop keeps the description from running on ("Check Your VIN. A VIN Is 17 Characters ...")
        var html = '<p class="pk247-err"><span class="pk247-err__title">' + esc(T.checkHeading) + '<span class="pk247-vh">.</span></span> ' + esc(msg) + '</p>';
        if (vinErr.__pkHtml !== html) { vinErr.innerHTML = html; vinErr.__pkHtml = html; }
        vinErr.hidden = false;
        vinInput.setAttribute('aria-invalid', 'true');
        desc = id('vin-err') + ' ' + desc;
      } else {
        vinErr.hidden = true;
        vinInput.removeAttribute('aria-invalid');
      }
      vinInput.setAttribute('aria-describedby', desc);
    }

    /* ---------- section shell ---------- */
    function heading(key, num, text, tag) {
      tag = tag || 'h2';
      return '<' + tag + ' class="pk247-h" id="' + hid(key) + '" tabindex="-1">' +
        (num ? '<span class="pk247-h__num" aria-hidden="true">' + pad2(num) + '</span>' : '') +
        '<span class="pk247-h__text">' + esc(text) + '</span></' + tag + '>';
    }
    function section(key, num, title, body, extraClass) {
      return '<section class="pk247-sec' + (extraClass ? ' ' + extraClass : '') + '" id="' + id('sec-' + key) + '" aria-labelledby="' + hid(key) + '">' +
        heading(key, num, title) + body + noticeHtml(key) + '</section>';
    }
    function noticeHtml(key) {
      if (!S.notice || S.notice.section !== key) return '';
      return '<p class="pk247-notice">' + esc(S.notice.text) + '</p>';   // announced via announce(), not a pre-filled live region
    }
    function errHtml(field, errs) {
      var m = errs[field];
      return '<p class="pk247-err" id="' + fid(field) + '-err" data-pk247-err="' + field + '"' + (m ? '' : ' hidden') + '>' + esc(m || '') + '</p>';
    }
    function describedBy(field, errs, extra) {
      var ids = [];
      if (errs[field]) ids.push(fid(field) + '-err');
      if (extra) ids.push(extra);
      return ids.length ? ' aria-describedby="' + ids.join(' ') + '"' : '';
    }
    function invalidAttr(field, errs) { return errs[field] ? ' aria-invalid="true"' : ''; }

    /* ---------- vehicle region ---------- */
    function detailGrid(ident, pick) {
      var eng = engineLabel(ident, pick) || 'Not Confirmed';
      var mm = [displayMake(ident.make), ident.model].filter(Boolean).join(' ') || 'Not Confirmed';
      return '<dl class="pk247-details">' +
        '<div><dt>Make / Model</dt><dd>' + esc(mm) + '</dd></div>' +
        '<div><dt>Engine</dt><dd>' + esc(eng) + '</dd></div>' +
        '<div><dt>Model Year</dt><dd>' + esc(ident.year || 'Not Confirmed') + '</dd></div>' +
        '</dl>';
    }

    function vehicleHtml() {
      var st = S.decode.status, ident = S.decode.identity;
      if (S.route) {
        var flow = flowOf();
        var eng = engineLabel(ident, S.route.manual);
        var suffix = flow === 'ez_lynk' ? (ineligibleNow() ? '' : ' / EZ-Lynk') : (flow === 'efi_live' ? ' / EFI Live' : (flow === 'sct' ? ' / SCT' : (flow === 'hp_tuners' ? ' / HP Tuners' : '')));
        // SPEC 19a: a GM drive the VIN decoded is shown here and never asked
        var drv = driveApplies(ctxOf()) ? decodedDrive(ctxOf()) : null;
        return section('veh', 1, T.yourTruck,
          '<p class="pk247-truck">' + esc(vehicleTitle(ident)) + '</p>' +
          (eng ? '<p class="pk247-truck__engine">' + esc(eng + suffix) + '</p>' : '') +
          (drv ? '<p class="pk247-truck__drive">' + esc(T.driveLine + labelOf(DRIVES, drv) + T.driveFromVin) + '</p>' : '') +
          (S.route.manual ? '<p class="pk247-muted pk247-small">' + esc(T.selectedByYou) + '</p>' : ''), 'pk247-sec--veh');
      }
      if (st === 'loading') {
        return '<section class="pk247-sec pk247-sec--veh" aria-labelledby="' + hid('veh') + '">' +
          '<h2 class="pk247-h pk247-h--muted" id="' + hid('veh') + '" tabindex="-1"><span class="pk247-h__text">' + esc(T.vinBusy) + '</span></h2></section>';
      }
      if (st === 'error') {
        return section('veh', 0, T.errorHeading,
          '<p class="pk247-body">' + esc(T.errorBody) + '</p>' +
          '<div class="pk247-actions">' +
            '<button type="button" class="pk247-btn" data-pk247-act="retry">' + esc(T.retry) + '</button>' +
            '<button type="button" class="pk247-link" data-pk247-act="focus-vin">' + esc(T.editVin) + '</button>' +
          '</div>', 'pk247-sec--veh pk247-sec--alert');
      }
      if (st === 'found') {
        return section('veh', 1, T.found,
          detailGrid(ident, null) +
          '<p class="pk247-muted">' + esc(T.reviewPrompt) + '</p>' +
          '<div class="pk247-actions">' +
            '<button type="button" class="pk247-btn pk247-btn--wide" data-pk247-act="continue">' + esc(T.cont) + '</button>' +
            '<button type="button" class="pk247-link" data-pk247-act="focus-vin">' + esc(T.editVin) + '</button>' +
          '</div>', 'pk247-sec--veh');
      }
      if (st === 'incomplete') {
        var dec = S.decode;
        var body = '<p class="pk247-body">' + esc(incompleteMessage(ident)) + '</p>' + detailGrid(ident, null);
        if (dec.manualAllowed) {
          var opts = manualOptions(ident).concat([{ id: 'none', label: T.manualNone }]);
          var errId = id('manual-err');
          body += '<fieldset class="pk247-fs pk247-manual"' + (S.manualError ? ' aria-describedby="' + errId + '"' : '') + '>' +
            '<legend class="pk247-label">' + esc(T.manualLegend) + '</legend>' +
            '<p class="pk247-help">' + esc(T.manualHelper) + '</p>' +
            '<div class="pk247-radios">' + opts.map(function (o) {
              var rid = fid('manual-' + o.id);
              return '<label class="pk247-radio" for="' + rid + '"><input type="radio" id="' + rid + '" name="' + fid('manual') + '" value="' + esc(o.id) + '" data-pk247-manual required' +
                (S.manualPick === o.id ? ' checked' : '') + '><span>' + esc(o.label) + '</span></label>';
            }).join('') + '</div>' +
            '<p class="pk247-err" id="' + errId + '"' + (S.manualError ? '' : ' hidden') + '>' + esc(T.manualRequired) + '</p>' +
            '</fieldset>';
        }
        // Try Again belongs to the temporary lookup error only (SPEC 2a): vPIC returns the same incomplete answer
        // every time. Without manual resolution, Continue resolves to Configuration Not Available.
        body += '<div class="pk247-actions">' +
          '<button type="button" class="pk247-btn pk247-btn--wide" data-pk247-act="continue">' + esc(T.cont) + '</button>' +
          '<button type="button" class="pk247-link" data-pk247-act="focus-vin">' + esc(T.editVin) + '</button></div>';
        return section('veh', 1, T.incomplete, body, 'pk247-sec--veh');
      }
      if (st === 'idle') {
        // handoff state label for the entry state (vin.status.initial); a <p> with text, never :empty
        return '<p class="pk247-status pk247-muted">' + esc(T.statusEnter) + '</p>';
      }
      return '';
    }

    // Say what is actually missing: the make or model year (no manual resolution possible), the engine, or, when
    // the engine did decode (code 14 / blank model), a neutral line beside the decoded details.
    function incompleteMessage(ident) {
      if (!ident || !ident.make || !ident.year) return T.incompleteBasics;
      if (!engineLabel(ident, null)) return T.incompleteEngine;
      return T.incompleteSome;
    }

    /* ---------- flow region ---------- */
    function flowHtml() {
      if (!S.route) return '';
      var t = S.route.type, n = 2, html = '';
      if (t === 'unresolved') return naHtml(n);
      if (t === 'product_page') return ppHtml(n);        // SPEC 23b
      if (t === 'catalog_redirect') return '';           // the referral lives in the right column (board 4)
      if (t === 'device_choice') { html += deviceHtml(n); n++; }
      var flow = flowOf();
      if (flow === 'ez_lynk') html += ezHtml(n);
      else if (flow === 'efi_live') html += efiHtml(n);
      else if (flow === 'sct') html += sctHtml(n);
      else if (flow === 'hp_tuners') html += hptHtml(n);   // SPEC 26c
      return html;
    }

    function linkList(keys) {
      var links = data.links || {};
      var out = [];
      (keys || []).forEach(function (k) {
        var url = links[k];
        if (!url) return;
        out.push('<a class="pk247-btn pk247-btn--secondary" href="' + esc(url) + '">' + esc(k === 'build_your_tune' ? T.buildTune : T.shopNow) + '</a>');
      });
      return out.join('');
    }

    // SPEC 23b: 2007.5-2012 6.7L Cummins while the flag is off: links to the product pages (the Cummins EFI Live product
    // opened on the truck's Truck Year, the 68RFE TCM product). No fields, price or cart action; the URLs carry only the
    // variant id.
    function ppHtml(n) {
      var pages = (S.offer && S.offer.pages) || [];
      var d = routeDef();
      return section('pp', n, T.ppHeading,
        '<p class="pk247-body">' + esc((d && d.ppBody) || T.ppBody) + '</p>' +   // SPEC 23f: the E-Series copy
        '<ul class="pk247-pp" role="list">' + pages.map(function (pg) {
          return '<li class="pk247-pp__item"><a class="pk247-pp__link" href="' + esc(pg.url) + '" data-pk247-pp="' + esc(pg.role) + '">' +
            '<span class="pk247-pp__title">' + esc(pg.title) + '</span>' +
            (pg.detail ? '<span class="pk247-pp__detail">' + esc(pg.detail) + '</span>' : '') +
            '<span class="pk247-pp__arrow" aria-hidden="true">→</span></a></li>';
        }).join('') + '</ul>', 'pk247-sec--pp');
    }

    function naHtml(n) {
      var body = S.route.reason === 'unmapped' || S.route.reason === 'no_destination' ? T.naUnmapped : T.naBody;
      return section('na', n, T.naHeading,
        '<p class="pk247-body">' + esc(body) + '</p>' +
        '<div class="pk247-actions">' + linkList(S.route.links || ['build_your_tune', 'shop_now']) + '</div>', 'pk247-sec--alert');
    }

    // Collection referral (boards 4 / 12): the vehicle is already shown under Your Truck, so the panel carries only
    // the destination, the visible fallback link and the status. Navigation itself is automatic (scheduleRedirect).
    function refHtml() {
      var d = routeDef(), dest = S.offer && S.offer.dest;
      var heading = d.fallback ? T.ecoHeading : T.refHeading;
      // the collection title never breaks after its en dash ("11–" / "19")
      var body = d.fallback ? esc(T.ecoBody)
        : esc('Browse Tuning Options For Your Truck In The ') + '<span class="pk247-nowrap">' + esc(d.destTitle) + '</span>' + esc(' Collection.');
      return '<section class="pk247-sum pk247-ref" aria-labelledby="' + hid('ref') + '">' +
        '<h2 class="pk247-side__h" id="' + hid('ref') + '" tabindex="-1">' + esc(heading) + '</h2>' +
        '<p class="pk247-body pk247-ref__body">' + body + '</p>' +
        '<a class="pk247-btn pk247-btn--block" href="' + esc(dest) + '" data-pk247-dest>' + esc(d.fallback ? T.shopNow : T.refCta) + '</a>' +
        '<p class="pk247-muted pk247-small pk247-ref__status" role="status">' + esc(d.fallback ? T.ecoStatus : T.refStatus) + '</p>' +
        '</section>';
    }

    // The route's devices (Cummins: EFI Live, EZ-Lynk; SPEC 22 Ford 6.4: EZ-Lynk, SCT), each disabled when unmapped
    function deviceHtml(n) {
      var off = S.offer || {};
      var list = routeDevices(routeDef(), flags);
      var descs = { efi_live: efiDeviceDesc(ctxOf()), ez_lynk: T.deviceEzDesc, sct: T.deviceSctDesc, hp_tuners: routeDef() && routeDef().hpt && routeDef().hpt.platform === 'cummins_hpt' ? T.cumminsHptDesc : T.deviceHptDesc };   // SPEC 24b, 26b
      var cols = list.map(function (did) {
        var d = findBy(DEVICES, did);
        var ok = deviceOk(off, did);
        var reason = did === 'efi_live' ? (off.efiOffReason || (ok ? '' : T.deviceUnavailable)) : (ok ? '' : T.deviceUnavailable);
        var pressed = S.device === d.id;
        var descId = id('dev-desc-' + d.id);
        return '<div class="pk247-device__col">' +
          '<button type="button" class="pk247-opt pk247-opt--btn' + (pressed ? ' is-selected' : '') + (ok ? '' : ' is-disabled') + '" id="' + fid('device-' + d.id) + '" ' +
            'aria-pressed="' + (pressed ? 'true' : 'false') + '"' + (ok ? '' : ' aria-disabled="true"') + lockAttr() + ' aria-describedby="' + descId + '" data-pk247-act="device" data-value="' + d.id + '">' +
            '<span class="pk247-opt__label">' + esc(d.label) + '</span></button>' +
          '<p class="pk247-device__title" aria-hidden="true">' + esc(d.label) + '</p>' +
          '<p class="pk247-device__desc" id="' + descId + '">' + esc(reason || descs[d.id]) + '</p>' +
          '</div>';
      }).join('');
      var commit = '';
      if (S.device && !S.deviceCommitted) {
        // the Continue button sits under the chosen column (first column left, second right)
        commit = '<div class="pk247-device__commit pk247-device__commit--' + (list.indexOf(S.device) > 0 ? 'right' : 'left') + '">' +
          '<button type="button" class="pk247-btn pk247-btn--block" data-pk247-act="device-commit">Continue With ' + esc(labelOf(DEVICES, S.device)) + '</button></div>';
      }
      return section('device', n, T.deviceHeading,
        '<fieldset class="pk247-fs"><legend class="pk247-vh">' + esc(T.deviceHeading) + '</legend>' +
        '<div class="pk247-device">' + cols + commit + '</div></fieldset>', 'pk247-sec--device');
    }

    // Every radioSeg group is a required choice (Tune Type, Tune Level, Support Package, the L5P ECM gate): the
    // native required attribute exposes the group as required (no form owns these radios, so no browser bubble).
    function radioSeg(field, options, value, errs, cls, disabledMap) {
      return '<div class="pk247-seg ' + (cls || '') + '">' + options.map(function (o) {
        var rid = fid(field + '-' + o.id);
        var dis = disabledMap && disabledMap[o.id];
        return '<label class="pk247-opt' + (dis ? ' is-disabled' : '') + '" for="' + rid + '">' +
          '<input class="pk247-opt__input" type="radio" id="' + rid + '" name="' + fid(field) + '" value="' + esc(o.id) + '" data-pk247-field="' + field + '" required' +
          (String(value) === String(o.id) ? ' checked' : '') + (dis ? ' disabled' : lockAttr()) + invalidAttr(field, errs) + '>' +
          '<span class="pk247-opt__box"><span class="pk247-opt__label">' + esc(o.label) + '</span>' +
          (o.detail ? '<span class="pk247-opt__detail">' + esc(o.detail) + '</span>' : '') +
          (o.price ? '<span class="pk247-opt__price">' + esc(o.price) + '</span>' : '') +
          (dis ? '<span class="pk247-opt__detail">' + esc(T.deviceUnavailable) + '</span>' : '') +
          '</span></label>';
      }).join('') + '</div>';
    }

    function selectHtml(field, label, placeholder, options, value, errs, helperId) {
      var sid = fid(field);
      return '<div class="pk247-field">' +
        '<label class="pk247-label" for="' + sid + '">' + esc(label) + '</label>' +
        '<div class="pk247-select"><select class="pk247-input" id="' + sid + '" data-pk247-field="' + field + '" aria-required="true"' + lockAttr() + invalidAttr(field, errs) + describedBy(field, errs, helperId) + '>' +
          '<option value="">' + esc(placeholder) + '</option>' +
          options.map(function (o) { return '<option value="' + esc(o.id) + '"' + (String(value) === String(o.id) ? ' selected' : '') + '>' + esc(o.label) + '</option>'; }).join('') +
        '</select></div>' + errHtml(field, errs) + '</div>';
    }

    function textHtml(field, label, placeholder, value, errs, opts) {
      opts = opts || {};
      var tid = fid(field);
      var helpId = opts.help ? tid + '-help' : null;
      // every text field this page renders (device serial, ECM serial, E/C, tire diameter) is required while shown,
      // except the SPEC 21a PO Number (opts.optional; opts.autocapitalize 'off' keeps the customer's case)
      var input = '<input class="pk247-input" type="text" id="' + tid + '" data-pk247-field="' + field + '" value="' + esc(value) + '" ' +
        'autocomplete="off" autocapitalize="' + (opts.autocapitalize || 'characters') + '" autocorrect="off" spellcheck="false" maxlength="' + TEXT_MAX + '"' +
        (opts.optional ? '' : ' aria-required="true"') +
        (placeholder ? ' placeholder="' + esc(placeholder) + '"' : '') + (opts.inputmode ? ' inputmode="' + opts.inputmode + '"' : '') +
        lockAttr() + invalidAttr(field, errs) + describedBy(field, errs, helpId) + '>';
      return '<div class="pk247-field">' +
        '<label class="pk247-label" for="' + tid + '">' + esc(label) + (opts.srSuffix ? '<span class="pk247-vh"> ' + esc(opts.srSuffix) + '</span>' : '') + '</label>' +
        (opts.suffix ? '<div class="pk247-suffix">' + input + '<span class="pk247-suffix__unit" aria-hidden="true">' + esc(opts.suffix) + '</span></div>' : input) +
        (opts.help ? '<p class="pk247-help" id="' + helpId + '">' + esc(opts.help) + '</p>' : '') +
        errHtml(field, errs) + '</div>';
    }

    function checkHtml(field, label, checked, opts) {
      opts = opts || {};
      var cid = opts.id || fid(field);
      return '<div class="pk247-checkrow' + (opts.cls ? ' ' + opts.cls : '') + '">' +
        '<label class="pk247-check" for="' + cid + '"><input type="checkbox" id="' + cid + '" data-pk247-field="' + field + '"' +
        (opts.value ? ' value="' + esc(opts.value) + '"' : '') + (checked ? ' checked' : '') + (opts.disabled ? ' disabled' : lockAttr()) +
        (opts.help ? ' aria-describedby="' + cid + '-help"' : '') + '>' +
        '<span class="pk247-check__label">' + esc(label) + '</span>' + (opts.after || '') + '</label>' +
        (opts.help ? '<p class="pk247-check__help" id="' + cid + '-help">' + esc(opts.help) + '</p>' : '') + '</div>';
    }

    // SPEC 19a / 19b (GM routes): Drive Type (4x4 / 4x2, no default) only when the VIN gave no drive, and on a 4x4 the
    // Transfer Case (Auto (Push Button) preselected / Manual (Floor Lever)); '' when neither is asked.
    function driveHtml(errs) {
      var ctx = ctxOf(), f = S.form, out = '';
      if (!driveApplies(ctx)) return '';
      if (!decodedDrive(ctx)) {
        out += '<fieldset class="pk247-fs"' + (errs.driveType ? ' aria-describedby="' + fid('driveType') + '-err"' : '') + '>' +
          '<legend class="pk247-label">' + esc(T.driveLabel) + '</legend>' +
          radioSeg('driveType', DRIVES, f.driveType, errs, 'pk247-seg--2') + errHtml('driveType', errs) + '</fieldset>';
      }
      if (driveOf(ctx) === '4x4') {
        out += '<fieldset class="pk247-fs"' + (errs.tcase ? ' aria-describedby="' + fid('tcase') + '-err"' : '') + '>' +
          '<legend class="pk247-label">' + esc(T.tcaseLabel) + '</legend>' +
          radioSeg('tcase', TCASES, f.tcase, errs, 'pk247-seg--2 pk247-seg--wrap pk247-seg--tcase') + errHtml('tcase', errs) + '</fieldset>';
      }
      // Full-width groups, like Tune Type. On phones the bold "Manual (Floor Lever)" with its tick needs two lines in its
      // half-width box (and below 430px the bold "Auto (Push Button)" does too), so pk247-seg--tcase reserves two lines
      // for both segments up to 599px (CSS section 9): picking either one never moves the form.
      return out ? '<div class="pk247-drive">' + out + '</div>' : '';
    }

    // EZ-Lynk: the Support Package choice only. The L5P route (SPEC 13) adds the 2017-2018 eligibility gate before
    // it and the optional Allison transmission add-on after it; "No" on the gate hides the package and the action.
    // SPEC 19: the L5P's drive questions sit above the package; the 2022-2024 Cummins E/C Number sits with it.
    function ezHtml(n) {
      var f = S.form, errs = visibleErrors(), off = S.offer.ez, ctx = ctxOf();
      var html = '';
      var ready = '<div class="pk247-region pk247-ready" data-pk247-r="ready"></div>';
      if (gateApplies(ctx)) {
        var helpId = id('gate-help');
        var gate = '<fieldset class="pk247-fs" aria-describedby="' + (errs.ecmUnlocked ? fid('ecmUnlocked') + '-err ' : '') + helpId + '">' +
            '<legend class="pk247-vh">' + esc(T.gateLegend) + '</legend>' +
            '<p class="pk247-help pk247-gate__help" id="' + helpId + '">' + esc(T.gateHelp) + '</p>' +
            radioSeg('ecmUnlocked', YES_NO, f.ecmUnlocked, errs, 'pk247-seg--2') +
            errHtml('ecmUnlocked', errs) +
          '</fieldset>';
        if (f.ecmUnlocked === 'no') {
          gate += '<div class="pk247-notice pk247-gate__no">' +
            '<h3 class="pk247-h3 pk247-gate__title">' + esc(T.gateNoTitle) + '</h3>' +
            '<div class="pk247-actions">' + linkList(['build_your_tune']) + '</div></div>';
        }
        html += section('gate', n++, T.gateLegend, gate, 'pk247-sec--gate');
        if (f.ecmUnlocked === 'no') return html;
      }
      var drive = driveHtml(errs);
      if (drive) html += section('vehdetails', n++, T.vehicleSection, drive, 'pk247-sec--ez');
      var opts = SUPPORT.map(function (s) {
        var r = off[s.id];
        var m = r && r.variant ? /\(([^)]+)\)/.exec(r.variant.title) : null;
        return { id: s.id, label: s.label, detail: m ? m[1] : '', price: r && r.variant ? (r.variant.price_formatted || T.qFailed) : '' };
      });
      var addon = hasAddon(ctx);
      html += section('support', n++,
        T.supportSection,
        '<fieldset class="pk247-fs"' + (errs.supportPackage ? ' aria-describedby="' + fid('supportPackage') + '-err"' : '') + '>' +
          '<legend class="pk247-vh">' + esc(T.supportSection) + '</legend>' +
          radioSeg('supportPackage', opts, f.supportPackage, errs, 'pk247-seg--2 pk247-seg--tall') +
          errHtml('supportPackage', errs) +
        '</fieldset>' +
        (ezEcApplies(ctx) ? '<div class="pk247-grid2 pk247-ez-ec">' +
          textHtml('ecmEc', T.ecLabel, T.ecPlaceholder, f.ecmEc, errs, { help: T.ecHelper }) + '</div>' : ''), 'pk247-sec--ez');
      if (addon) {
        var a = S.offer.addon, aOk = !!(a && a.ok);
        var meta = '<span class="pk247-check__meta">' + esc(T.allison) + ' · ' +
          (aOk ? esc(a.product.title) + (a.variant.price_formatted ? ' · ' + esc(a.variant.price_formatted) : '') : esc(T.deviceUnavailable)) + '</span>';
        html += section('trans', n++, T.transSection,
          checkHtml('ezTransTuning', T.transToggle, f.ezTransTuning, { disabled: !aOk, after: meta, cls: 'pk247-checkrow--toggle' }),
          'pk247-sec--ez');
      }
      // SPEC 21a: Order Details (the optional PO Number) is the last section; "Ready For Checkout" stays last in it
      html += orderHtml(n++, errs, ready, 'pk247-sec--ez');
      return html;
    }

    // SPEC 21a: Order Details, the last section of every flow that adds to the cart: the optional PO Number in the
    // page's text-field style (not required, the customer's case kept). extra: the EZ-Lynk "Ready For Checkout" block.
    function orderHtml(n, errs, extra, cls) {
      return section('order', n, T.orderSection,
        '<div class="pk247-grid2 pk247-po">' +
          textHtml('poNumber', T.poLabel, T.poPlaceholder, S.form.poNumber, errs, { help: T.poHelper, optional: true, autocapitalize: 'off' }) +
        '</div>' + (extra || ''), cls);
    }

    // "Ready For Checkout" only with a valid mapping and a current quote (board-notes #18); own region so the
    // quote timer can update it without rebuilding the form.
    function readyHtml() {
      if (flowOf() !== 'ez_lynk') return '';
      var ready = S.quote.status === 'ready' && !Object.keys(validate(ctxOf())).length;
      return (ready ? '<h3 class="pk247-h3">' + esc(T.readyHeading) + '</h3>' : '') +
        '<p class="pk247-body">' + esc(T.readyVin) + '</p>' +
        (ready ? '<p class="pk247-muted">' + esc(T.readyBody) + '</p>' : '');
    }

    // Level 1-5 for a Single Tune: buttons on wide screens, the native select below 750px (board 11). legend: EFI Live's
    // "Tune Level", SPEC 26c HP Tuners' "Power Level".
    function levelFieldset(legend, f, errs) {
      var lvlOpts = LEVELS.map(function (l) { return { id: String(l), label: 'Level ' + l }; });
      var legendId = id('level-legend');
      return '<fieldset class="pk247-fs"' + (errs.tuneLevel ? ' aria-describedby="' + fid('tuneLevel') + '-err"' : '') + '>' +
        '<legend class="pk247-label" id="' + legendId + '">' + esc(legend) + '</legend>' +
        '<div class="pk247-only-wide">' + radioSeg('tuneLevel', lvlOpts, f.tuneLevel, errs, 'pk247-seg--5') + '</div>' +
        '<div class="pk247-only-narrow"><div class="pk247-select"><select class="pk247-input" id="' + fid('tuneLevelSelect') + '" data-pk247-field="tuneLevel" aria-labelledby="' + legendId + '" aria-required="true"' +
          lockAttr() + invalidAttr('tuneLevel', errs) + describedBy('tuneLevel', errs) + '>' +
          '<option value="">' + esc(T.levelPlaceholder) + '</option>' +
          lvlOpts.map(function (o) { return '<option value="' + o.id + '"' + (String(f.tuneLevel) === o.id ? ' selected' : '') + '>' + esc(o.label) + '</option>'; }).join('') +
        '</select></div></div>' +
        errHtml('tuneLevel', errs) + '</fieldset>';
    }

    function efiHtml(n) {
      var f = S.form, errs = visibleErrors(), plat = platformOf(), off = S.offer || {};
      var html = '';
      // Tune Selection
      var dis = {};
      if (off.efi) { dis.single = !off.efi.single.ok; dis.sotf = !off.efi.sotf.ok; }
      var tune = '<fieldset class="pk247-fs"' + (errs.tuneType ? ' aria-describedby="' + fid('tuneType') + '-err"' : '') + '>' +
        '<legend class="pk247-label">' + esc(T.tuneType) + '</legend>' +
        radioSeg('tuneType', tuneTypesFor(ctxOf()), f.tuneType, errs, 'pk247-seg--2 pk247-seg--wrap', dis) + errHtml('tuneType', errs) +
        (ccApplies(ctxOf()) ? '<p class="pk247-help pk247-cc__help">' + esc(ccSotfOff(ctxOf()) ? T.ccHelp1318 : T.ccHelp) + '</p>' : '') + '</fieldset>';   // SPEC 23e
      if (f.tuneType === 'single') tune += levelFieldset(T.tuneLevel, f, errs);
      if (plat === 'cummins' && idleApplies(ctxOf())) {             // SPEC 23e: no Idle Sound on a cab & chassis
        tune += '<fieldset class="pk247-fs"' + (errs.idleSound ? ' aria-describedby="' + fid('idleSound') + '-err"' : '') + '>' +
          '<legend class="pk247-label">' + esc(T.idleLabel) + '</legend>' +
          radioSeg('idleSound', idleSoundsFor(ctxOf()), f.idleSound, errs, 'pk247-seg--2 pk247-seg--wrap') + errHtml('idleSound', errs) + '</fieldset>';
      }
      if (earlyApplies(ctxOf()) && !cmcApplies(ctxOf()) && cabChassisVin(S.vin)) tune += '<p class="pk247-help">OBD SOTF for cab-and-chassis includes Level 1 and Level 2. Fixed files are available in Levels 1–5.</p>';
      html += section('tune', n++, T.tuneSection, tune);

      // Device Details
      html += section('device-details', n++, T.deviceSection,
        '<div class="pk247-grid2">' +
          textHtml('deviceSerial', T.serialLabel, T.serialPlaceholder, f.deviceSerial, errs) +
          checkHtml('linkCodesRequested', T.linkCodes, f.linkCodesRequested, { cls: 'pk247-checkrow--inline' }) +
        '</div>');

      // Vehicle Details
      var veh, ctx = ctxOf();
      if (plat === 'cummins') {
        // SPEC 15d: E/C Number beside the ECM Serial (2010-2021); 2007-2009 show neither (SPEC 15c)
        var ids = ecmIdsApply(ctx);
        veh = '<div class="pk247-grid2">' +
          (ids ? textHtml('ecmEc', T.ecLabel, T.ecPlaceholder, f.ecmEc, errs, { help: T.ecHelper }) +
                 textHtml('ecmSerial', T.ecmSerialLabel, T.ecmSerialPlaceholder, f.ecmSerial, errs, { help: T.ecmSerialHelper }) : '') +
          // SPEC 18c: 2013-2018 Injectors (the 5.9L dropdown), before the Transmission Type
          (injectorsApply(ctx) ? selectHtml('injectors', T.injectorsLabel, T.injectorsPlaceholder, INJECTORS, f.injectors, errs) : '') +
          selectHtml('ecmFileType', T.fileTypeLabel, T.fileTypePlaceholder, fileTypesFor(ctx), f.ecmFileType, errs) +
          '</div>';
      } else if (plat === 'cummins59') {
        // SPEC 15b: Injectors and Transmission Type (Automatic / Manual) only
        veh = '<div class="pk247-grid2">' +
          selectHtml('injectors', T.injectorsLabel, T.injectorsPlaceholder, INJECTORS, f.injectors, errs) +
          selectHtml('truckTransmission', T.fileTypeLabel, T.fileTypePlaceholder, GM_TRANS, f.truckTransmission, errs) +
          '</div>';
      } else {
        // SPEC 19: Drive Type (when the VIN gave none) and Transfer Case (4x4) first, then the transmission and tires
        veh = driveHtml(errs) + '<div class="pk247-grid2">' +
          selectHtml('truckTransmission', T.gmTransLabel, T.gmTransPlaceholder, GM_TRANS, f.truckTransmission, errs) +
          textHtml('tireDiameter', T.tireLabel, '', f.tireDiameter, errs, { help: T.tireHelper, suffix: 'in', srSuffix: '(Inches)', inputmode: 'decimal' }) +
          '</div>';
      }
      html += section('vehdetails', n++, T.vehicleSection, veh);

      if (plat === 'cummins' && eoApplies(ctx)) {
        // Engine Options: Cummins EFI Live only (SPEC 23e: never on a cab & chassis); independent of file type and
        // transmission tuning
        html += section('engine', n++, T.engineSection,
          '<fieldset class="pk247-fs"><legend class="pk247-vh">' + esc(T.engineSection) + '</legend>' +
          '<p class="pk247-lead">' + esc(T.engineIntro) + '</p>' +
          '<div class="pk247-checks">' + engineOptionsFor(ctx).map(function (o) {
            return checkHtml('engineOption', o.label, f.engineOptions[o.id], { id: fid('eo-' + o.id), value: o.id, help: o.help, cls: 'pk247-checkrow--rule' });
          }).join('') + '</div></fieldset>');
      }
      if (plat === 'cummins') {
        if (f.ecmFileType === 'aisin' && !transOffered(ctx, 'aisin')) {
          // SPEC 15c: 2007-2012 AISIN: no toggle, no add-on, a neutral note only
          html += section('trans', n++, T.transSection, '<p class="pk247-lead pk247-trans__note">' + esc(T.aisinNote) + '</p>');
        } else if ((f.ecmFileType === '68rfe' || f.ecmFileType === 'aisin') && transOffered(ctx, f.ecmFileType)) {   // SPEC 23e: C&C AISIN only
          var tr = off.trans ? off.trans[f.ecmFileType] : null;
          var trOk = !!(tr && tr.ok);
          var after = trOk
            ? '<span class="pk247-check__meta">' + esc(tr.product.title) + (tr.variant.price_formatted ? ' · ' + esc(tr.variant.price_formatted) : '') + '</span>'
            : '<span class="pk247-check__meta">' + esc(T.deviceUnavailable) + '</span>';
          var trans = checkHtml('transTuning', T.transToggle, f.transTuning, { disabled: !trOk, after: after, cls: 'pk247-checkrow--toggle' });
          if (f.transTuning) {
            trans += '<div class="pk247-grid2">' + selectHtml('shiftPoints', T.shiftLabel, T.shiftPlaceholder, SHIFT_POINTS[f.ecmFileType], f.shiftPoints, errs) +
              (f.ecmFileType === '68rfe' ? selectHtml('transPressure', T.pressureLabel, T.pressurePlaceholder, PRESSURES, f.transPressure, errs) : '') +
              '</div>';
          }
          html += section('trans', n++, T.transSection, trans);
        }
      }
      // SPEC 21a: Order Details (the optional PO Number), the last form section before the review
      html += orderHtml(n++, errs);
      // The inline review appears only after "Review Configuration" validated the form (no third copy before it)
      if (S.reviewed) {
        html += section('review', n++, T.reviewSection, '<div class="pk247-region" data-pk247-r="review"></div><p class="pk247-muted pk247-review__note">' + esc(T.reviewNote) + '</p>', 'pk247-sec--review');
      }
      return html;
    }

    // SPEC 22: the product page link for an SCT build the page does not take (injectors larger than 330CC, a custom
    // request): the mapped product's own (market) URL
    function sctProductUrl() {
      var off = S.offer || {};
      return off.sct && off.sct.product && off.sct.product.url ? off.sct.product.url : null;
    }
    // SPEC 22b: injectors larger than 330CC are built by hand: the message and the product page link (form and summary)
    function sctManualHtml(cls) {
      var url = sctProductUrl();
      return '<div class="pk247-notice pk247-sct-manual' + (cls ? ' ' + cls : '') + '" data-pk247-sctmanual>' +
        '<p class="pk247-sct-manual__title">' + esc(T.sctManualTitle) + '</p>' +
        (url ? '<a class="pk247-btn pk247-btn--block pk247-sct-manual__link" href="' + esc(url) + '" data-pk247-sctproduct>' + esc(T.sctManualLink) + '</a>' : '') +
        '</div>';
    }
    function sctCountText(n, sd) { return n + T.sctCountOf + sd.max + T.sctCountSelected; }

    // SPEC 22b (6.0) / 22c (6.4, device SCT): Tune Selection, Device Details, Vehicle Details, Order Details, then the
    // review after Review Configuration (the EFI Live pattern). Level names are the product pages' own; no prices here.
    function sctHtml(n) {
      var f = S.form, errs = visibleErrors(), ctx = ctxOf(), sd = sctDef(ctx), html = '';
      if (!sd) return '';
      var picked = sctLevelsOf(f, sd), full = picked.length >= sd.max;
      var tune = '';
      if (sd.kind === '64') {
        tune += '<fieldset class="pk247-fs"' + (errs.tuneType ? ' aria-describedby="' + fid('tuneType') + '-err"' : '') + '>' +
          '<legend class="pk247-label">' + esc(T.tuneType) + '</legend>' +
          radioSeg('tuneType', SCT_TUNE_TYPES, f.tuneType, errs, 'pk247-seg--2 pk247-seg--wrap') + errHtml('tuneType', errs) +
          (f.tuneType === 'sotf' ? '<p class="pk247-help pk247-sct__sotf">' + esc(T.sctSotfHelp) + '</p>' : '') + '</fieldset>';
      }
      if (sd.kind === '60' || f.tuneType === 'single') {
        var countId = id('sct-count');
        var desc = [errs.sctLevels ? fid('sctLevels') + '-err' : '', countId].filter(Boolean).join(' ');
        var url = sd.kind === '60' ? sctProductUrl() : null;
        tune += '<fieldset class="pk247-fs pk247-sct__levels" aria-describedby="' + desc + '">' +
          '<legend class="pk247-label">' + esc(sd.kind === '60' ? T.sctFilesLabel : T.sctPowerLabel) + '</legend>' +
          '<p class="pk247-help pk247-sct__count" id="' + countId + '">' + esc(sctCountText(picked.length, sd)) + '</p>' +
          '<div class="pk247-checks pk247-sct__checks">' + sd.levels.map(function (label, i) {
            var k = i + 1, on = picked.indexOf(k) >= 0;
            // never more than sd.max files (the "5 Files" variant): unpicked boxes are disabled at the cap (SPEC 23i: the 6.0
            // lists exactly five levels, so all five can be picked and the cap never disables one)
            return checkHtml('sctLevels', label, on, { id: fid('sctLevel-' + k), value: String(k), disabled: !on && full, cls: 'pk247-checkrow--rule' });
          }).join('') + '</div>' + errHtml('sctLevels', errs) +
          (url ? '<p class="pk247-help pk247-sct__custom">' + esc(T.sctCustomQ) + ' <a class="pk247-link" href="' + esc(url) + '">' + esc(T.sctCustomLink) + '</a></p>' : '') +
          '</fieldset>';
      }
      if (sd.kind === '60') {
        // SPEC 23c1: the 6.0 Idle Sound (the product page's field, the Cummins one). While Turbo is Non-VGT, Rumble is set
        // and Hiss is disabled, with the short reason under the choice (hidden only if the same sentence shows as the
        // error, a guard the form no longer reaches). SPEC 23c2: the Rumble note for 2003-2004 and the Excursion.
        var nv = f.sctTurbo === 'non_vgt';
        var nvHelp = nv && errs.idleSound !== T.idleNonVgt, idleHelpId = fid('idleSound') + '-help';
        var rumbleNote = f.idleSound === 'rumble' && rumbleNoteApplies(ctx), noteId = fid('idleSound') + '-note';
        var idleDesc = [errs.idleSound ? fid('idleSound') + '-err' : '', nvHelp ? idleHelpId : '', rumbleNote ? noteId : ''].filter(Boolean).join(' ');
        tune += '<fieldset class="pk247-fs pk247-sct__idle"' + (idleDesc ? ' aria-describedby="' + idleDesc + '"' : '') + '>' +
          '<legend class="pk247-label">' + esc(T.idleLabel) + '</legend>' +
          radioSeg('idleSound', IDLE_SOUNDS, f.idleSound, errs, 'pk247-seg--2 pk247-seg--wrap', nv ? { hiss: true } : null) +
          (nvHelp ? '<p class="pk247-help" id="' + idleHelpId + '">' + esc(T.idleNonVgt) + '</p>' : '') +
          (rumbleNote ? '<p class="pk247-help pk247-sct__rumble" id="' + noteId + '">' + esc(T.idleRumbleNote) + '</p>' : '') +
          errHtml('idleSound', errs) + '</fieldset>';
      }
      html += section('tune', n++, T.tuneSection, tune);

      html += section('device-details', n++, T.deviceSection,
        '<div class="pk247-grid2">' +
          textHtml('sctSerial', T.sctSerialLabel, T.sctSerialPlaceholder, f.sctSerial, errs, { help: T.sctSerialHelp }) +
          (sd.kind === '60'
            ? textHtml('ecmStrategy', T.strategyLabel, T.strategyPlaceholder, f.ecmStrategy, errs, { help: T.strategyHelp })
            : selectHtml('tcuStrategy', T.tcuLabel, T.tcuPlaceholder, TCU_STRATEGIES, f.tcuStrategy, errs)) +
        '</div>');

      var veh;
      if (sd.kind === '60') {
        veh = '<div class="pk247-grid2">' +
          selectHtml('sctTurbo', T.turboLabel, T.turboPlaceholder, SCT_TURBOS, f.sctTurbo, errs) +
          selectHtml('sctInjectors', T.injectorsLabel, T.injectorsPlaceholder, SCT_INJECTORS, f.sctInjectors, errs) +
          selectHtml('truckTransmission', T.fileTypeLabel, T.fileTypePlaceholder, GM_TRANS, f.truckTransmission, errs) +
          selectHtml('sctLimiter', 'Rev Limiter', 'Select Rev Limiter', SCT_LIMITERS, f.sctLimiter, errs) +
          selectHtml('sctSensors', T.sensorsLabel, T.sensorsPlaceholder, SCT_SENSORS, f.sctSensors, errs) +   // SPEC 23c3
          '</div>' + (f.sctInjectors === 'over_330' ? sctManualHtml('pk247-sct-manual--form') : '');
        html += section('vehdetails', n++, T.vehicleSection, veh);
      }
      // SPEC 23d: the 6.4 had only the Non-VGT box in Vehicle Details, so it has no Vehicle Details section now
      html += orderHtml(n++, errs);                                // SPEC 21a
      if (S.reviewed) {
        html += section('review', n++, T.reviewSection, '<div class="pk247-region" data-pk247-r="review"></div><p class="pk247-muted pk247-review__note">' + esc(T.reviewNote) + '</p>', 'pk247-sec--review');
      }
      return html;
    }

    // SPEC 26c: HP Tuners (2017-2023 L5P): Tune Selection (Tune Type; Power Level 1-5 for a Single Tune), Device Details (the
    // device serial), Vehicle Files (the infolog and the stock read), Order Details, then the review after Review Configuration
    // (the EFI Live pattern). No prices here, and no Drive Type / Transfer Case / Allison add-on / 2017-2018 gate.
    function hptHtml(n) {
      var f = S.form, errs = visibleErrors(), off = S.offer || {}, html = '';
      var dis = {};
      if (off.hpt) { dis.single = !off.hpt.single.ok; dis.sotf = !off.hpt.sotf.ok; }
      var tune = '<fieldset class="pk247-fs"' + (errs.tuneType ? ' aria-describedby="' + fid('tuneType') + '-err"' : '') + '>' +
        '<legend class="pk247-label">' + esc(T.tuneType) + '</legend>' +
        radioSeg('tuneType', TUNE_TYPES, f.tuneType, errs, 'pk247-seg--2 pk247-seg--wrap', dis) + errHtml('tuneType', errs) + '</fieldset>';
      if (f.tuneType === 'single') tune += levelFieldset(T.hptLevelLabel, f, errs);
      if (cumminsHpt(ctxOf()) && f.tuneType === 'sotf') tune += '<p class="pk247-muted">' + esc(labelOf(CUMMINS_HPT_MODES, 'CRUISE_SOTF')) + '</p>';
      if (cumminsHpt(ctxOf())) tune += '<p class="pk247-muted">' + esc(T.cumminsHptReview) + '</p>';
      html += section('tune', n++, T.tuneSection, tune);
      html += section('device-details', n++, T.deviceSection,
        '<div class="pk247-grid2">' +
          textHtml('hptSerial', T.hptSerialLabel, T.hptSerialPlaceholder, f.hptSerial, errs, { help: T.hptSerialHelp, inputmode: 'numeric', autocapitalize: 'off' }) +
        '</div>');
      html += section('files', n++, T.hptFilesSection,
        '<div class="pk247-grid2 pk247-files">' + fileHtml('stock', errs) + (cumminsHpt(ctxOf()) ? '' : fileHtml('infolog', errs)) + '</div>');
      html += orderHtml(n++, errs);                                // SPEC 21a
      if (S.reviewed) {
        html += section('review', n++, T.reviewSection, '<div class="pk247-region" data-pk247-r="review"></div><p class="pk247-muted pk247-review__note">' + esc(T.reviewNote) + '</p>', 'pk247-sec--review');
      }
      return html;
    }

    // SPEC 26e: one file field. Nothing picked: the real <input type=file> (visually hidden, keyboard-focusable, named by the
    // field label, errors linked through aria-describedby) with a "Choose File" label styled as a button. Picked: "Selected:
    // <name> (<size>)" with Change (opens the same input) and Remove; the input stays for Change, out of the tab order. The File
    // itself lives in S.files, so re-rendering the region never loses it.
    var HPT_FILE_FIELD = { infolog: 'hptInfolog', stock: 'hptStock' };
    function fileHtml(kind, errs) {
      var field = HPT_FILE_FIELD[kind], fi = S.files[kind], iid = fid(field);
      var labelId = iid + '-label', helpId = iid + '-help', noteId = iid + '-note', nameId = iid + '-name';
      var label = kind === 'infolog' ? T.hptInfologLabel : T.hptStockLabel;
      var short = kind === 'infolog' ? T.hptInfologShort : T.hptStockShort;
      var help = kind === 'infolog' ? T.hptInfologHelp : T.hptStockHelp;
      var err = errs[field] || '';
      var note = '', pending = false;
      if (kind === 'infolog' && fi && !infologPreProblem(fi)) {
        var ck = fi.check;
        if (ck && ck.status === 'pending') { note = T.hptChecking; pending = true; }
        else if (!err && infologMatches(fi, S.vin)) note = T.hptMatch;
      }
      var desc = [err ? iid + '-err' : '', helpId, note ? noteId : ''].filter(Boolean).join(' ');
      var input = '<input type="file" class="pk247-file__input" id="' + iid + '" data-pk247-field="' + field + '" data-pk247-file="' + kind + '"' +
        (kind === 'infolog' ? ' accept=".txt"' : ' accept=".hpt"') +
        ' aria-labelledby="' + labelId + '" aria-describedby="' + desc + '" aria-required="' + (kind === 'stock' ? 'true' : 'false') + '"' + (err ? ' aria-invalid="true"' : '') +
        (fi ? ' tabindex="-1" aria-hidden="true"' : '') + lockAttr() + '>';
      var body;
      if (fi) {
        var changeDesc = [nameId, err ? iid + '-err' : '', note ? noteId : ''].filter(Boolean).join(' ');
        body = input +
          '<div class="pk247-file__sel' + (err ? ' is-invalid' : '') + '">' +
            '<p class="pk247-file__name" id="' + nameId + '"><span class="pk247-file__k">' + esc(T.hptSelected) + '</span> ' +
              '<span class="pk247-file__v">' + esc(fi.name) + ' (' + esc(hptFileSize(fi.size)) + ')</span></p>' +
            '<div class="pk247-file__acts">' +
              '<button type="button" class="pk247-link pk247-link--sm" id="' + iid + '-change" data-pk247-act="file-change" data-kind="' + kind + '" ' +
                'aria-describedby="' + changeDesc + '"' + lockAttr() + '>' + esc(T.hptChange) + '<span class="pk247-vh"> ' + esc(short) + '</span></button>' +
              '<button type="button" class="pk247-link pk247-link--sm" id="' + iid + '-remove" data-pk247-act="file-remove" data-kind="' + kind + '" ' +
                'aria-describedby="' + nameId + '"' + lockAttr() + '>' + esc(T.hptRemove) + '<span class="pk247-vh"> ' + esc(short) + '</span></button>' +
            '</div></div>';
      } else {
        body = '<div class="pk247-file__pick">' + input +
          '<label class="pk247-btn pk247-btn--secondary pk247-file__btn" for="' + iid + '" aria-hidden="true">' + esc(T.hptChoose) + '</label></div>';
      }
      return '<div class="pk247-field pk247-file' + (fi ? ' is-selected' : '') + '" data-pk247-filefield="' + kind + '">' +
        '<label class="pk247-label" id="' + labelId + '" for="' + iid + '">' + esc(label) + '</label>' + body +
        '<p class="pk247-help" id="' + helpId + '">' + esc(help) + '</p>' +
        (note ? '<p class="pk247-help pk247-file__note' + (pending ? '' : ' pk247-file__note--ok') + '" id="' + noteId + '">' + esc(note) + '</p>' : '') +
        errHtml(field, errs) + '</div>';
    }

    // Patch errors in place while typing (the flow region is not rebuilt for text input).
    function patchFlow() {
      var flowEl = region('flow');
      if (!flowEl) return;
      var errs = visibleErrors();
      var nodes = flowEl.querySelectorAll('[data-pk247-err]');
      for (var i = 0; i < nodes.length; i++) {
        var fld = nodes[i].getAttribute('data-pk247-err');
        var m = errs[fld] || '';
        if (nodes[i].textContent !== m) nodes[i].textContent = m;
        nodes[i].hidden = !m;
        var ctl = document.getElementById(fid(fld));
        if (ctl && ctl.tagName !== 'FIELDSET') {
          if (m) ctl.setAttribute('aria-invalid', 'true'); else ctl.removeAttribute('aria-invalid');
          var help = document.getElementById(fid(fld) + '-help');
          var note = document.getElementById(fid(fld) + '-note');      // SPEC 26f: the infolog's status / match line
          var ids = [];
          if (m) ids.push(fid(fld) + '-err');
          if (help) ids.push(help.id);
          if (note) ids.push(note.id);
          if (ids.length) ctl.setAttribute('aria-describedby', ids.join(' ')); else ctl.removeAttribute('aria-describedby');
        }
      }
      // keep the cached html in sync so the next full render does not see a stale snapshot
      flowEl.__pkHtml = null;
    }

    /* ---------- review ---------- */
    // Grouped review: one group per form section, one Edit per group that returns focus to that section's heading.
    // Your Truck has no editable fields of its own: its Edit focuses the VIN block's Edit VIN (target 'vin').
    function reviewGroup(title, editKey, rows) {
      return '<div class="pk247-review__group"><div class="pk247-review__head"><h3 class="pk247-h4">' + esc(title) + '</h3>' +
        '<button type="button" class="pk247-link pk247-link--sm" data-pk247-act="edit-section" data-target="' + editKey + '" aria-label="' + esc(T.edit + ' ' + title) + '">' + esc(T.edit) + '</button></div>' +
        '<dl class="pk247-rows">' + rows.map(function (r) { return rowHtml(r[0], r[1], !!r[2]); }).join('') + '</dl></div>';
    }
    // SPEC 22: the SCT Configuration Summary (Your Truck, Tune Selection, Device Details, Vehicle Details, Order Details)
    function sctReviewHtml() {
      var ctx = ctxOf(), c = activeConfig(ctx), sd = sctDef(ctx), html = '';
      if (!sd) return '';
      var ident = ctx.identity;
      html += reviewGroup(T.yourTruck, 'vin', [
        [T.reviewVehicle, vehicleTitle(ident)],
        [T.reviewEngine, engineLabel(ident, ctx.manual) + (ctx.manual ? ' (' + T.selectedByYou + ')' : '')],
        [T.vinLabelShort, ctx.vin],
        [T.reviewDevice, labelOf(DEVICES, 'sct')]
      ]);
      var names = sctLevelLabels(c.sctLevels, sd).join(', ');
      var tuneRows = [];
      if (sd.kind === '64') {
        tuneRows.push([T.tuneType, labelOf(SCT_TUNE_TYPES, c.tuneType) || T.notSelected, !c.tuneType]);
        if (c.tuneType === 'single') tuneRows.push([T.sctPowerLabel, names || T.notSelected, !names]);
      } else {
        tuneRows.push([T.sctFilesLabel, names || T.notSelected, !names]);
        tuneRows.push([T.idleLabel, labelOf(IDLE_SOUNDS, c.idleSound) || T.notSelected, !c.idleSound]);   // SPEC 23c1
      }
      html += reviewGroup(T.tuneSection, 'tune', tuneRows);
      html += reviewGroup(T.deviceSection, 'device-details', [
        [T.sctSerialLabel, c.sctSerial || T.notEntered, !c.sctSerial],
        sd.kind === '60' ? [T.strategyLabel, c.ecmStrategy || T.notEntered, !c.ecmStrategy]
          : [T.tcuLabel, labelOf(TCU_STRATEGIES, c.tcuStrategy) || T.notSelected, !c.tcuStrategy]
      ]);
      if (sd.kind === '60') {                                        // SPEC 23d: the 6.4 has no Vehicle Details now
        html += reviewGroup(T.vehicleSection, 'vehdetails', [
          [T.turboLabel, labelOf(SCT_TURBOS, c.sctTurbo) || T.notSelected, !c.sctTurbo],
          [T.injectorsLabel, labelOf(SCT_INJECTORS, c.sctInjectors) || T.notSelected, !c.sctInjectors],
          [T.fileTypeLabel, labelOf(GM_TRANS, c.truckTransmission) || T.notSelected, !c.truckTransmission],
          ['Rev Limiter', labelOf(SCT_LIMITERS, c.sctLimiter) || T.notSelected, !c.sctLimiter],
          [T.sensorsLabel, labelOf(SCT_SENSORS, c.sctSensors) || T.notSelected, !c.sctSensors]   // SPEC 23c3
        ]);
      }
      html += reviewGroup(T.orderSection, 'order', [[T.poShort, c.poNumber || T.poNone]]);
      return '<div class="pk247-review">' + html + '</div>';
    }
    // SPEC 26h: the HP Tuners Configuration Summary (Your Truck, Tune Selection, Device Details, Vehicle Files, Order Details)
    function hptReviewHtml() {
      var ctx = ctxOf(), c = activeConfig(ctx), fl = hptFiles(ctx), ident = ctx.identity, html = '';
      html += reviewGroup(T.yourTruck, 'vin', [
        [T.reviewVehicle, vehicleTitle(ident)],
        [T.reviewEngine, engineLabel(ident, ctx.manual) + (ctx.manual ? ' (' + T.selectedByYou + ')' : '')],
        [T.vinLabelShort, ctx.vin],
        [T.reviewDevice, labelOf(DEVICES, 'hp_tuners')]
      ]);
      var tuneRows = [[T.tuneType, labelOf(TUNE_TYPES, c.tuneType) || T.notSelected, !c.tuneType]];
      if (c.tuneType === 'single') tuneRows.push([T.hptLevelLabel, c.tuneLevel ? 'Level ' + c.tuneLevel : T.notSelected, !c.tuneLevel]);
      if (cumminsHpt(ctx) && c.tuneType === 'sotf') tuneRows.push([T.hptSotfModeLabel, labelOf(CUMMINS_HPT_MODES, c.hptSotfMode) || T.notSelected, !c.hptSotfMode]);
      html += reviewGroup(T.tuneSection, 'tune', tuneRows);
      html += reviewGroup(T.deviceSection, 'device-details', [[T.hptSerialShort, c.hptSerial || T.notEntered, !c.hptSerial]]);
      var fileRows = [[T.hptStockShort, fl.stock ? fl.stock.name : T.notSelected, !fl.stock]];
      if (!cumminsHpt(ctx)) fileRows.unshift([T.hptInfologShort, fl.infolog ? fl.infolog.name : 'Not Provided (Optional)', false]);
      html += reviewGroup(T.hptFilesSection, 'files', fileRows);
      html += reviewGroup(T.orderSection, 'order', [[T.poShort, c.poNumber || T.poNone]]);
      return '<div class="pk247-review">' + html + '</div>';
    }
    function reviewHtml() {
      if (flowOf() === 'sct' && S.reviewed) return sctReviewHtml();
      if (flowOf() === 'hp_tuners' && S.reviewed) return hptReviewHtml();   // SPEC 26h
      if (flowOf() !== 'efi_live' || !S.reviewed) return '';
      var ctx = ctxOf(), c = activeConfig(ctx), plat = ctx.platform, html = '';
      var ident = ctx.identity;
      var truckRows = [
        [T.reviewVehicle, vehicleTitle(ident)],
        [T.reviewEngine, engineLabel(ident, ctx.manual) + (ctx.manual ? ' (' + T.selectedByYou + ')' : '')],
        [T.vinLabelShort, ctx.vin]
      ];
      // SPEC 19a: a decoded GM drive belongs to the truck (its Edit goes to Edit VIN); an asked one to Vehicle Details
      if (driveApplies(ctx) && decodedDrive(ctx)) truckRows.push([T.driveLabel, labelOf(DRIVES, decodedDrive(ctx)) + T.driveFromVin]);
      truckRows.push([T.reviewDevice, labelOf(DEVICES, 'efi_live')]);
      html += reviewGroup(T.yourTruck, 'vin', truckRows);
      var tuneRows = [[T.tuneType, labelOf(tuneTypesFor(ctx), c.tuneType) || T.notSelected, !c.tuneType]];   // SPEC 23e: OBD SOTF
      if (c.tuneType === 'single') tuneRows.push([T.tuneLevel, c.tuneLevel ? 'Level ' + c.tuneLevel : T.notSelected, !c.tuneLevel]);
      if (plat === 'cummins' && idleApplies(ctx)) tuneRows.push([T.idleLabel, labelOf(idleSoundsFor(ctx), c.idleSound) || T.notSelected, !c.idleSound]);
      html += reviewGroup(T.tuneSection, 'tune', tuneRows);
      html += reviewGroup(T.deviceSection, 'device-details', [
        [T.serialLabel, c.deviceSerial || T.notEntered, !c.deviceSerial],
        ['Link Codes', c.linkCodesRequested ? T.requested : T.notRequested]
      ]);
      if (plat === 'cummins') {
        var vrows = [];
        if (ecmIdsApply(ctx)) {
          vrows.push([T.ecLabel, c.ecmEc || T.notEntered, !c.ecmEc]);
          vrows.push([T.ecmSerialLabel, c.ecmSerial || T.notEntered, !c.ecmSerial]);
        }
        if (injectorsApply(ctx)) vrows.push([T.injectorsLabel, labelOf(INJECTORS, c.injectors) || T.notSelected, !c.injectors]);   // SPEC 18c
        vrows.push([T.fileTypeLabel, labelOf(fileTypesFor(ctx), c.ecmFileType) || T.notSelected, !c.ecmFileType]);
        html += reviewGroup(T.vehicleSection, 'vehdetails', vrows);
        if (eoApplies(ctx)) {                                        // SPEC 23e: not on a cab & chassis
          var eo = engineOptionLabels(c.engineOptions, ctx);
          html += reviewGroup(T.engineSection, 'engine', [[T.engineSection, eo.length ? eo.join(', ') : T.noneSelected]]);
        }
        if (transOffered(ctx, c.ecmFileType)) {
          var tr = [[T.reviewTrans, c.transTuning ? T.added : T.notAdded]];
          if (c.transTuning) {
            tr.push([T.shiftLabel, labelOf(SHIFT_POINTS[c.ecmFileType] || [], c.shiftPoints) || T.notSelected, !c.shiftPoints]);
            if (c.ecmFileType === '68rfe') tr.push([T.pressureLabel, labelOf(PRESSURES, c.transPressure) || T.notSelected, !c.transPressure]);
          }
          html += reviewGroup(T.transSection, 'trans', tr);
        }
      }
      if (plat === 'cummins59') {
        html += reviewGroup(T.vehicleSection, 'vehdetails', [
          [T.injectorsLabel, labelOf(INJECTORS, c.injectors) || T.notSelected, !c.injectors],
          [T.fileTypeLabel, labelOf(GM_TRANS, c.truckTransmission) || T.notSelected, !c.truckTransmission]
        ]);
      }
      if (plat === 'gm') {
        var grows = [];
        if (driveApplies(ctx) && !decodedDrive(ctx)) grows.push([T.driveLabel, labelOf(DRIVES, c.driveType) || T.notSelected, !c.driveType]);
        if (c.driveType === '4x4') grows.push([T.tcaseLabel, labelOf(TCASES, c.tcase) || T.notSelected, !c.tcase]);
        grows.push([T.gmTransLabel, labelOf(GM_TRANS, c.truckTransmission) || T.notSelected, !c.truckTransmission]);
        grows.push([T.tireLabel, c.tireDiameter ? c.tireDiameter + ' in' : T.notEntered, !c.tireDiameter]);
        html += reviewGroup(T.vehicleSection, 'vehdetails', grows);
      }
      // SPEC 21a: optional, so an empty PO reads "None" (no missing style, no "Not Entered")
      html += reviewGroup(T.orderSection, 'order', [[T.poShort, c.poNumber || T.poNone]]);
      return '<div class="pk247-review">' + html + '</div>';
    }
    // SPEC 21a summary row (Your Configuration / the EZ-Lynk Order Summary): only when a PO Number is entered
    function poRow(c) { return c.poNumber ? rowHtml(T.poShort, c.poNumber) : ''; }
    function transSummary(c) {
      if (!c.transTuning) return T.notAdded;
      var parts = [labelOf(SHIFT_POINTS[c.ecmFileType] || [], c.shiftPoints) || 'Shift Points ' + T.notSelected];
      if (c.ecmFileType === '68rfe') parts.push(labelOf(PRESSURES, c.transPressure) || 'Pressure ' + T.notSelected);
      return parts.join(' / ');
    }

    /* ---------- right column: performance ---------- */
    // SPEC 17 / 17b (board 5): the product-page gain over an illustrative dyno shape. g = {level, gain, name} is the
    // level drawn; o.top = the top listed level stands in for a package / SOTF file (legend "Top Level"); o.list =
    // every listed level (the SOTF / EZ-Lynk levels line); o.upTo = Ford 3.0's "Up To +120 HP". The pages give no
    // stock or tuned total, so the gain is the header's only figure, left-aligned (Brent 2026-10-18 removed the
    // board's "-- HP" Tuned Estimate: "If you are not going to use this remove it").
    function dynoHtml(key, g, o) {
      o = o || {};
      var tune = o.top ? T.dynoTop : T.dynoSelected;
      var gainText = (o.upTo ? T.perfUpTo + ' ' : '') + '+' + gainLabel(g) + ' HP';
      // SPEC 22: a named level (the 6.0 SCT page's tune names) is shown by its name, never "Level N"
      var levelLine = o.upTo ? gainText : (g.named ? g.name : (g.name ? 'Level ' + g.level + ' / ' + g.name : ''));
      var levels = o.list ? o.list.length + ' ' + T.perfLevels + ': ' + o.list.map(function (x) { return '+' + gainLabel(x); }).join(' / ') + ' HP' : '';
      var svg = dynoSvg({
        gain: g.gain, id: id('dyno-' + key),
        title: T.dynoTitle + (o.top || !g.level ? T.dynoTop : (g.named ? g.name : 'Level ' + g.level)),
        desc: T.dynoDesc + gainText + T.dynoDescEnd
      });
      return '<div class="pk247-perf__nums pk247-perf__nums--dyno">' +
          '<div class="pk247-perf__gain"><span class="pk247-perf__val" data-pk247-gain>+' + esc(gainLabel(g)) + ' HP</span>' +
            '<span class="pk247-perf__cap">' + esc(T.perfOver) + '</span></div>' +
        '</div>' +
        '<div class="pk247-dyno">' + svg + '</div>' +
        '<ul class="pk247-dyno__legend" role="list">' +
          '<li class="pk247-dyno__item"><span class="pk247-dyno__key" aria-hidden="true"></span>' + esc(T.dynoStock) + '</li>' +
          '<li class="pk247-dyno__item pk247-dyno__item--tune"><span class="pk247-dyno__key pk247-dyno__key--tune" aria-hidden="true"></span>' + esc(tune) + '</li>' +
        '</ul>' +
        '<p class="pk247-dyno__note">' + esc(T.dynoNote) + '</p>' +
        (levelLine ? '<p class="pk247-perf__level">' + esc(levelLine) + '</p>' : '') +
        (levels ? '<p class="pk247-perf__level pk247-perf__levels">' + esc(levels) + '</p>' : '') +
        '<p class="pk247-help pk247-perf__src">' + esc(T.perfSource) + '</p>';
    }
    // EZ-Lynk: the package's top listed level over stock (every level ships in the package), rendered after Continue
    // To Checkout so the summary stays aligned with the VIN block and the CTA stays above the fold (r3 layout rule)
    function perfEzHtml() {
      if (flowOf() !== 'ez_lynk' || ineligibleNow()) return '';
      var d = routeDef(), ident = S.decode.identity || {};
      var list = d && pageGains(d.ez, ident.year);
      if (!list || (!list.upTo && !list.length)) return '';
      var headId = hid('perfez');
      var body = list.upTo ? dynoHtml('perfez', { level: null, gain: list.upTo, name: '' }, { top: true, upTo: true })
        : dynoHtml('perfez', list[list.length - 1], { top: true, list: list });
      return '<section class="pk247-perf pk247-perf--ez pk247-perf--dyno" aria-labelledby="' + headId + '">' +
        '<h2 class="pk247-side__h" id="' + headId + '">' + esc(T.perfHeading) + '</h2>' +
        '<p class="pk247-perf__sub">' + esc(T.dynoTopSub) + '</p>' + body + '</section>';
    }
    // the drawn level of a list: the largest gain (the last one on a tie, so an ascending page list draws its top level)
    function topLevel(list) {
      var t = list[list.length - 1];
      for (var i = 0; i < list.length; i++) if (list[i].gain > t.gain) t = list[i];
      return t;
    }
    function findLevel(list, level) {
      for (var i = 0; i < list.length; i++) if (list[i].level === level) return list[i];
      return null;
    }
    // SPEC 22d: the Preview Level select over the given levels (preview only: never the package, price or cart)
    function previewSelectHtml(list) {
      var pid = fid('previewLevelId');
      return '<div class="pk247-field pk247-perf__preview"><label class="pk247-label" for="' + pid + '">' + esc(T.perfPreviewLabel) + '</label>' +
        '<div class="pk247-select"><select class="pk247-input" id="' + pid + '" data-pk247-field="previewLevelId" aria-describedby="' + pid + '-help">' +
        '<option value="">' + esc(T.perfPreviewPlaceholder) + '</option>' +
        list.map(function (x) {
          var l = String(x.level);
          return '<option value="' + esc(l) + '"' + (S.previewLevelId === l ? ' selected' : '') + '>' + esc(x.named ? x.name : 'Level ' + l) + ' / +' + esc(gainLabel(x)) + ' HP</option>';
        }).join('') +
        '</select></div><p class="pk247-help" id="' + pid + '-help">' + esc(T.perfPreviewHelper) + '</p></div>';
    }
    function perfHtml() {
      var flow = flowOf();
      var headId = hid('perf');
      if (S.route && (S.route.type === 'unresolved' || S.route.type === 'catalog_redirect' || S.route.type === 'product_page')) return '';
      if (S.route && S.route.type === 'device_choice' && !S.deviceCommitted) return '';
      // EZ-Lynk has no tune level, so the PERF table (route, then level) can never feed it: the optional block is
      // omitted (handoff, board 12), which also keeps Continue To Checkout beside the VIN block above the fold
      if (flow === 'ez_lynk') return '';
      // pre-route states (entry, Check Your VIN, decoding, lookup error, found, incomplete) keep the Vehicle Preview
      // block so the right column stays aligned beside the VIN block
      var sub = T.perfSubVehicle, body = T.perfBodyPre, d = null, title = T.perfHeading, preview = '';
      var cls = 'pk247-perf', g = null, range = null;
      var rd = routeDef(), efiHandle = rd && rd.efi ? rd.efi.handle : null, yr = (S.decode.identity || {}).year;
      if (flow === 'efi_live') {
        body = T.perfBody;
        var f = S.form;
        var anyEoSel = engineOptionsFor(ctxOf()).some(function (o) { return f.engineOptions[o.id]; });
        if (anyEoSel && pageGains(efiHandle, yr)) body = T.perfEoPending;
        // The supplied CMC library has five levels; the older product-page gains describe four.
        // Keep the estimate pending until matching five-level horsepower figures are supplied.
        if (cmcApplies(ctxOf())) {
          sub = '';
        } else if (f.tuneType === 'single') {
          sub = f.tuneLevel ? 'Level ' + f.tuneLevel + ' Preview' : '';
          d = perfFor(perf, S.route.id, f.tuneLevel, f.engineOptions);
          if (!d && !anyEoSel) g = pageGainFor(efiHandle, yr, f.tuneLevel, f.engineOptions);
        } else if (f.tuneType === 'sotf') {
          title = T.perfSotfHeading; sub = '';
          var levels = perfLevels(perf, S.route.id);
          var pg = levels.length ? null : pageGains(efiHandle, yr);
          if (earlyApplies(ctxOf()) && cabChassisVin(S.vin)) {
            levels = levels.filter(function (l) { return Number(l) <= 2; });
            if (pg) pg = pg.filter(function (g) { return g.level <= 2; });
          }
          if (pg && pg.length) levels = pg.map(function (x) { return String(x.level); });
          var anyEo = anyEoSel;
          if (levels.length && !anyEo) {
            var pid = fid('previewLevelId');
            preview = '<div class="pk247-field pk247-perf__preview"><label class="pk247-label" for="' + pid + '">' + esc(T.perfPreviewLabel) + '</label>' +
              '<div class="pk247-select"><select class="pk247-input" id="' + pid + '" data-pk247-field="previewLevelId" aria-describedby="' + pid + '-help">' +
              '<option value="">' + esc(T.perfPreviewPlaceholder) + '</option>' +
              levels.map(function (l) { var x = pg ? pg[Number(l) - 1] : null; return '<option value="' + esc(l) + '"' + (S.previewLevelId === l ? ' selected' : '') + '>Level ' + esc(l) + (x ? ' / +' + esc(x.gain) + ' HP' : '') + '</option>'; }).join('') +
              '</select></div><p class="pk247-help" id="' + pid + '-help">' + esc(T.perfPreviewHelper) + '</p></div>';
            d = S.previewLevelId && !pg ? perfFor(perf, S.route.id, S.previewLevelId, f.engineOptions) : null;
            if (pg && S.previewLevelId) { g = pageGainFor(efiHandle, yr, S.previewLevelId, f.engineOptions); if (g) sub = 'Level ' + g.level + ' Preview'; }
            else if (pg) { range = pg; sub = T.dynoTopSub; }
          }
        } else { sub = ''; }
      } else if (flow === 'hp_tuners') {
        // SPEC 26h: the HP Tuners L5P product page's figures (PAGE_GAINS): a Single Tune shows its level; SOTF the top level
        // with a preview select of the five, like the EFI Live SOTF (preview only: never the package, price or cart)
        body = T.perfBody; sub = '';
        var hh = rd && rd.hpt ? rd.hpt.handle : null, hf = S.form;
        if (hf.tuneType === 'single') {
          sub = hf.tuneLevel ? 'Level ' + hf.tuneLevel + ' Preview' : '';
          g = pageGainFor(hh, yr, hf.tuneLevel, null);
        } else if (hf.tuneType === 'sotf') {
          title = T.perfSotfHeading;
          var hpg = pageGains(hh, yr);
          if (hpg && hpg.length) {
            preview = previewSelectHtml(hpg);
            var hpv = S.previewLevelId ? findLevel(hpg, Number(S.previewLevelId)) : null;
            if (hpv) { g = hpv; sub = 'Level ' + hpv.level + ' Preview'; } else { range = hpg; sub = T.dynoTopSub; }
          }
        }
      } else if (flow === 'sct') {
        // SPEC 22d: the SCT product pages' figures. One level picked: that level. Several: the top picked level (and a
        // preview select of the picked ones). 6.4 SOTF: like every SOTF route (all five levels).
        body = T.perfBody; sub = '';
        var sd = sctDef(ctxOf()), gl = sd ? pageGains(sd.handle, yr) : null, sf = S.form;
        var pickSub = function (x) { return (x.named ? x.name : 'Level ' + x.level) + ' Preview'; };
        if (gl && gl.length) {
          var pool = null;
          if (sd.kind === '64' && sf.tuneType === 'sotf') { title = T.perfSotfHeading; pool = gl; }
          else if (sd.kind === '60' || sf.tuneType === 'single') {
            pool = sctLevelsOf(sf, sd).map(function (k) { return gl[k - 1]; }).filter(Boolean);
          }
          if (pool && pool.length === 1 && !(sd.kind === '64' && sf.tuneType === 'sotf')) {
            g = pool[0]; sub = pickSub(g);
          } else if (pool && pool.length) {
            preview = previewSelectHtml(pool);
            var pv = S.previewLevelId ? findLevel(pool, Number(S.previewLevelId)) : null;
            if (pv) { g = pv; sub = pickSub(pv); }
            else { range = pool; sub = T.dynoTopSub; }
          }
        }
      }
      var nums;
      if (!d && g) {
        nums = dynoHtml('perf', g);
        cls += ' pk247-perf--dyno';
      } else if (!d && range) {
        nums = dynoHtml('perf', topLevel(range), { top: true, list: range });
        cls += ' pk247-perf--dyno';
      } else if (d) {
        nums = '<dl class="pk247-perf__data">' +
          '<div><dt>' + esc(T.perfStock) + '</dt><dd>' + esc(d.stockHp) + ' HP</dd></div>' +
          '<div><dt>' + esc(T.perfTunedPower) + '</dt><dd>' + esc(d.tunedHp) + ' HP</dd></div>' +
          '<div><dt>' + esc(T.perfGain) + '</dt><dd>+' + esc(d.gainHp) + ' HP</dd></div>' +
          '</dl><p class="pk247-help">' + esc(d.basis) + '</p>';
      } else {
        // the gain placeholder is the only figure (no "-- HP" Tuned Estimate, Brent 2026-10-18); "Estimate Pending"
        // below says it in words, so the placeholder stays hidden from screen readers
        nums = '<div class="pk247-perf__nums">' +
          '<div class="pk247-perf__gain"><span class="pk247-perf__val" aria-hidden="true">' + esc(T.perfEmptyGain) + '</span>' +
            '<span class="pk247-perf__cap" aria-hidden="true">' + esc(T.perfOver) + '</span></div>' +
          '</div>' +
          '<div class="pk247-perf__empty"><p class="pk247-perf__body">' + esc(body) + '</p><p class="pk247-perf__pending">' + esc(T.perfPending) + '</p></div>';
      }
      return '<section class="' + cls + '" aria-labelledby="' + headId + '">' +
        '<h2 class="pk247-side__h" id="' + headId + '">' + esc(title) + '</h2>' +
        preview + (sub ? '<p class="pk247-perf__sub">' + esc(sub) + '</p>' : '') + nums + '</section>';
    }

    /* ---------- right column: summary + commerce ---------- */
    function rowHtml(label, value, missing) {
      return '<div class="pk247-row"><dt>' + esc(label) + '</dt><dd' + (missing ? ' class="is-missing"' : '') + '>' + esc(value) + '</dd></div>';
    }
    function quoteText(q) {
      if (q.status === 'ready') return q.totalFormatted;
      if (q.status === 'updating') return T.qUpdating;
      if (q.status === 'unavailable') return T.qFailed;
      return T.qIncomplete;
    }
    function subtotalHtml(text, state) {
      var ccy = data.currency && text && text.indexOf(data.currency) < 0 && state === 'ready' ? data.currency + ' / ' : '';
      // tabindex=-1: a click on an action disabled by Price Unavailable moves focus here (explainDisabledCta)
      return '<div class="pk247-subtotal" id="' + id('subtotal') + '" tabindex="-1" data-pk247-quote="' + esc(state) + '">' +
        '<span class="pk247-subtotal__label">' + esc(T.subtotal) + '</span>' +
        '<span class="pk247-subtotal__value' + (state === 'ready' ? '' : ' is-pending') + '" data-pk247-total>' + esc(text) + '</span></div>' +
        '<p class="pk247-caption">' + esc(ccy + (data.taxLine || T.taxLine)) + '</p>';   // market tax caption from the theme locale
    }
    // A disabled action explains itself: the hint is shown (and linked) only when completing fields would enable it,
    // never while busy, repricing or on Price Unavailable.
    function ctaHtml(label, enabled, busy, q) {
      var describe = [];
      var idle = S.submit.status === 'idle' || S.submit.status === 'error';
      var hint = !enabled && idle && q && (q.status === 'incomplete' || q.status === 'ready');
      if (S.submit.status === 'error') describe.push(id('submit-err'));
      if (hint) describe.push(id('cta-hint'));
      // disabled by Price Unavailable: the subtotal (after a market change, the reload notice) says why
      if (!enabled && idle && q && q.status === 'unavailable') describe.push(S.marketChanged ? id('market') : id('subtotal'));
      return '<button type="button" class="pk247-btn pk247-btn--block pk247-btn--lg pk247-cta" id="' + id('cta') + '" data-pk247-act="cta"' +
        (enabled ? '' : ' aria-disabled="true"') + (busy ? ' aria-busy="true"' : '') +
        (describe.length ? ' aria-describedby="' + describe.join(' ') + '"' : '') + '>' + esc(label) + '</button>' +
        (hint ? '<p class="pk247-help pk247-cta-hint" id="' + id('cta-hint') + '">' + esc(T.ctaHint) + '</p>' : '') +
        marketHtml() + submitStatusHtml();
    }
    // The cart now uses another market currency (the customer switched country elsewhere): this page's prices belong
    // to the old market, so nothing is submitted until a reload renders the new market's catalog. Announced once by
    // onMarketChanged(); a plain block here, so later re-renders never announce it again.
    function marketHtml() {
      if (!S.marketChanged) return '';
      return '<div class="pk247-notice pk247-notice--error pk247-market" id="' + id('market') + '">' +
        '<p class="pk247-err"><span class="pk247-err__title">' + esc(T.marketChanged) + '</span></p>' +
        '<button type="button" class="pk247-link" data-pk247-act="reload">' + esc(T.reloadPage) + '</button></div>';
    }
    // The error always carries a fixed error title with the '!' glyph (never colour alone); Shopify's own
    // description or message, when there is one, follows as the detail (SPEC 12d). role=alert announces it once.
    function submitStatusHtml() {
      if (S.submit.status === 'error') {
        var title = S.submit.message || (flowOf() === 'ez_lynk' ? T.ctaCheckoutError : T.cartError);
        return '<div class="pk247-notice pk247-notice--error" role="alert" id="' + id('submit-err') + '">' +
          '<p class="pk247-err pk247-submit-err__title"><span class="pk247-err__title">' + esc(title) + '</span></p>' +
          (S.submit.detail ? '<p class="pk247-submit-err__detail">' + esc(S.submit.detail) + '</p>' : '') + '</div>';
      }
      if (S.submit.status === 'success' || S.submit.status === 'added') {
        // fallback if the navigation that follows a real 200 is interrupted: two separate 44px targets. "Item Added"
        // only after a real 200; when /cart.js showed the whole configuration already there, nothing was posted
        var root_ = data.routes.root_url || '/';
        var msg = S.added && S.added.already ? T.cartAlready : T.cartAdded;
        return '<div class="pk247-notice pk247-notice--success pk247-success" role="status">' +
          '<p class="pk247-success__msg">' + esc(msg) + '</p>' +
          '<p class="pk247-success__links">' +
            '<a class="pk247-link" href="' + esc(data.routes.cart_url || joinRoot(root_, 'cart')) + '">' + esc(T.viewCart) + '</a>' +
            '<a class="pk247-link" href="' + esc(joinRoot(root_, 'checkout')) + '">' + esc(T.checkout) + '</a>' +
          '</p></div>';
      }
      return '';
    }
    function orderLinesHtml(q) {
      if (q.status !== 'ready') return '';
      return '<ul class="pk247-lines" role="list">' + q.lines.map(function (l) {
        return '<li class="pk247-line"><span class="pk247-line__name">' + esc(l.productTitle) +
          (l.variantTitle && l.variantTitle !== 'Default Title' ? '<span class="pk247-line__variant">' + esc(l.variantTitle) + '</span>' : '') +
          '</span><span class="pk247-line__price">' + esc(l.priceFormatted || '') + '</span></li>';
      }).join('') + '</ul>';
    }

    // SPEC 19 summary rows (GM routes): Drive Type, and Transfer Case on a 4x4
    function driveRows(ctx) {
      if (!driveApplies(ctx)) return '';
      var c = activeConfig(ctx);
      var out = rowHtml(T.driveLabel, c.driveType ? labelOf(DRIVES, c.driveType) : T.notSelected, !c.driveType);
      if (c.driveType === '4x4') out += rowHtml(T.tcaseLabel, labelOf(TCASES, c.tcase) || T.notSelected, !c.tcase);
      return out;
    }

    function sumHtml() {
      var flow = flowOf();
      var st = S.decode.status;
      if (!S.route) {
        // a decoded vehicle that will route to EZ-Lynk: the price slot waits for Continue
        if (st === 'found' && S.decode.prospectPriced) {
          return '<section class="pk247-sum" aria-labelledby="' + hid('sum') + '"><h2 class="pk247-side__h" id="' + hid('sum') + '">' + esc(T.sumOrder) + '</h2>' +
            subtotalHtml(T.qAwait, 'await') + '</section>';
        }
        return '';
      }
      if (S.route.type === 'catalog_redirect') return refHtml();
      if (S.route.type === 'device_choice' && !S.deviceCommitted) {
        var ident = S.decode.identity;
        var dev = S.device ? labelOf(DEVICES, S.device) : T.notSelected;
        var details = S.device === 'ez_lynk' ? 'VIN Only' : (S.device === 'efi_live' ? 'Tune, Device And ECM Details' : (S.device === 'sct' ? T.sctTuningDetails :
          (S.device === 'hp_tuners' ? T.hptTuningDetails : T.notSelected)));   // SPEC 26b
        return '<section class="pk247-sum pk247-sum--path" aria-labelledby="' + hid('sum') + '">' +
          '<h2 class="pk247-side__h" id="' + hid('sum') + '">' + esc(T.pathHeading) + '</h2>' +
          '<dl class="pk247-rows">' + rowHtml('Vehicle', vehicleTitle(ident) + ' / ' + engineLabel(ident, S.route.manual)) + rowHtml('Device', dev, !S.device) + rowHtml('Tuning Details', details, !S.device) + '</dl>' +
          (S.device ? '<div class="pk247-next"><h3 class="pk247-h3">' + esc(S.device === 'ez_lynk' ? T.pathNextEz : T.pathNextEfi) + '</h3><p class="pk247-muted">' + esc(T.pathVinNote) + '</p></div>' : '') +
          '</section>';
      }
      // In-progress labels only while the POST is in flight; after the real 200 the action stays disabled with its
      // normal label next to the success notice (never "Adding To Cart" beside "Item Added To Your Cart").
      var q = S.quote, busy = S.submit.status === 'busy', lock = locked();
      if (flow === 'ez_lynk') {
        // L5P 2017-2018 with a locked ECM: no order summary at all (from the answer itself, so nothing shows during
        // the brief Updating Price step either); the gate section carries the message and the builder link
        if (ineligibleNow()) return '';
        var off = S.offer.ez, ctx = ctxOf();
        var pkg = S.form.supportPackage;
        var enabled = q.status === 'ready' && !Object.keys(validate(ctx)).length && !lock;
        var rows = rowHtml('Tuning', off && off.product ? off.product.title : 'EZ-Lynk') + rowHtml('Vehicle Details', T.vinIncluded);
        rows += driveRows(ctx);                                    // SPEC 19: L5P
        rows += rowHtml(T.supportSection, pkg ? labelOf(SUPPORT, pkg) : T.notSelected, !pkg);
        if (ezEcApplies(ctx)) {                                    // SPEC 19c: 2022-2024 Cummins
          var ec = str(S.form.ecmEc);
          rows += rowHtml(T.ecLabel, ec || T.notEntered, !ec);
        }
        if (hasAddon(ctx)) {
          var a = S.offer.addon;
          var aPrice = a && a.ok && a.variant.price_formatted ? ' · ' + a.variant.price_formatted : '';
          rows += rowHtml(T.transSection, S.form.ezTransTuning ? T.added + aPrice : T.notAdded);
        }
        rows += poRow(activeConfig(ctx));                          // SPEC 21a
        return '<section class="pk247-sum" aria-labelledby="' + hid('sum') + '">' +
          '<h2 class="pk247-side__h" id="' + hid('sum') + '">' + esc(T.sumOrder) + '</h2>' +
          '<dl class="pk247-rows">' + rows + '</dl>' +
          subtotalHtml(quoteText(q), q.status) +
          ctaHtml(busy ? T.ctaCheckoutBusy : T.ctaCheckout, enabled, S.submit.status === 'busy', q) +
          '</section>';
      }
      if (flow === 'efi_live') {
        var sctx = ctxOf(), c = activeConfig(sctx), plat = platformOf(), rows = '';
        rows += rowHtml('Tune', tuneLabel(c, sctx) || T.notSelected, !c.tuneType);
        if (plat === 'cummins') {
          var cc = ccApplies(sctx);                                // SPEC 23e: the cab & chassis rows
          if (!cc) rows += rowHtml(T.idleLabel, labelOf(idleSoundsFor(sctx), c.idleSound) || T.notSelected, !c.idleSound);
          if (injectorsApply(sctx)) rows += rowHtml(T.injectorsLabel, labelOf(INJECTORS, c.injectors) || T.notSelected, !c.injectors);   // SPEC 18c
          rows += rowHtml(T.fileTypeLabel, labelOf(fileTypesFor(sctx), c.ecmFileType) || T.notSelected, !c.ecmFileType);
          if (!cc) {
            var eo = engineOptionLabels(c.engineOptions, sctx);
            rows += rowHtml(T.engineSection, eo.length ? eo.join(', ') : T.noneSelected);
          }
          // no row where the transmission type offers no tuning (Manual; AISIN on 2007-2012; a cab & chassis 68RFE)
          if (transOffered(sctx, c.ecmFileType)) {
            rows += rowHtml(T.transSection, c.transTuning ? transSummary(c) : T.notAdded);
          }
        } else if (plat === 'cummins59') {
          rows += rowHtml(T.injectorsLabel, labelOf(INJECTORS, c.injectors) || T.notSelected, !c.injectors);
          rows += rowHtml(T.fileTypeLabel, labelOf(GM_TRANS, c.truckTransmission) || T.notSelected, !c.truckTransmission);
        } else {
          rows += driveRows(sctx);                                 // SPEC 19
          rows += rowHtml(T.gmTransLabel, labelOf(GM_TRANS, c.truckTransmission) || T.notSelected, !c.truckTransmission);
          rows += rowHtml(T.tireLabel, c.tireDiameter ? c.tireDiameter + ' in' : T.notEntered, !c.tireDiameter);
        }
        rows += rowHtml('Link Codes', c.linkCodesRequested ? T.requested : T.notRequested);
        rows += poRow(c);                                          // SPEC 21a
        return reviewCartHtml(rows, q, busy, lock);
      }
      if (flow === 'sct') return sctSumHtml(q, busy, lock);         // SPEC 22
      if (flow === 'hp_tuners') {
        // SPEC 26h: Tuning Device, Tune, Device S/N, the two file names, the PO; then the Order Summary (the only prices)
        var hctx = ctxOf(), hc = activeConfig(hctx), hfl = hptFiles(hctx), hrows = '';
        hrows += rowHtml(T.reviewDevice, labelOf(DEVICES, 'hp_tuners'));
        hrows += rowHtml('Tune', hptTuneLabel(hc) || T.notSelected, !hc.tuneType);
        hrows += rowHtml(T.hptSerialShort, hc.hptSerial || T.notEntered, !hc.hptSerial);
        if (!cumminsHpt(hctx)) hrows += rowHtml(T.hptInfologShort, hfl.infolog ? hfl.infolog.name : 'Not Provided (Optional)', false);
        hrows += rowHtml(T.hptStockShort, hfl.stock ? hfl.stock.name : T.notSelected, !hfl.stock);
        hrows += poRow(hc);                                        // SPEC 21a
        return reviewCartHtml(hrows, q, busy, lock);
      }
      return '';
    }

    // SPEC 22: Your Configuration for an SCT build, then the Order Summary and its action (EFI Live's review pattern).
    // Injectors larger than 330CC (6.0): the subtotal and the action give way to the product page link (manual build).
    function sctSumHtml(q, busy, lock) {
      var ctx = ctxOf(), c = activeConfig(ctx), sd = sctDef(ctx), rows = '';
      if (!sd) return '';
      var names = sctLevelLabels(c.sctLevels, sd).join(', ');
      if (sd.kind === '64') {
        rows += rowHtml(T.tuneType, labelOf(SCT_TUNE_TYPES, c.tuneType) || T.notSelected, !c.tuneType);
        if (c.tuneType === 'single') rows += rowHtml(T.sctPowerLabel, names || T.notSelected, !names);
        rows += rowHtml(T.tcuLabel, labelOf(TCU_STRATEGIES, c.tcuStrategy) || T.notSelected, !c.tcuStrategy);
      } else {
        rows += rowHtml(T.sctFilesLabel, names || T.notSelected, !names);
        rows += rowHtml(T.idleLabel, labelOf(IDLE_SOUNDS, c.idleSound) || T.notSelected, !c.idleSound);   // SPEC 23c1
        rows += rowHtml(T.turboLabel, labelOf(SCT_TURBOS, c.sctTurbo) || T.notSelected, !c.sctTurbo);
        rows += rowHtml(T.injectorsLabel, labelOf(SCT_INJECTORS, c.sctInjectors) || T.notSelected, !c.sctInjectors);
        rows += rowHtml(T.fileTypeLabel, labelOf(GM_TRANS, c.truckTransmission) || T.notSelected, !c.truckTransmission);
        rows += rowHtml('Rev Limiter', labelOf(SCT_LIMITERS, c.sctLimiter) || T.notSelected, !c.sctLimiter);
        rows += rowHtml(T.sensorsLabel, labelOf(SCT_SENSORS, c.sctSensors) || T.notSelected, !c.sctSensors);   // SPEC 23c3
      }
      rows += poRow(c);                                            // SPEC 21a
      if (q.status === 'manual') {
        return '<section class="pk247-sum" aria-labelledby="' + hid('sum') + '">' +
          '<div class="pk247-sum__config"><h2 class="pk247-side__h" id="' + hid('sum-config') + '">' + esc(T.sumConfig) + '</h2>' +
          '<dl class="pk247-rows">' + rows + '</dl></div>' +
          '<h2 class="pk247-h3 pk247-h3--sum pk247-h3--nolines" id="' + hid('sum') + '">' + esc(T.sumOrder) + '</h2>' +
          sctManualHtml('pk247-sct-manual--sum') + '</section>';
      }
      return reviewCartHtml(rows, q, busy, lock);
    }

    // Your Configuration rows + Order Summary + the Review Configuration / Add To Cart action (EFI Live and SCT)
    function reviewCartHtml(rows, q, busy, lock) {
      // Before review: "Review Configuration" (enabled unless the price failed to resolve: SPEC 3 "Price Unavailable"
      // with the action disabled; otherwise it validates). After review: "Add To Cart", enabled only with a valid
      // form and a current quote.
      var valid = !Object.keys(validate(ctxOf())).length;
      // after a bfcache restore of a finished add, the same configuration is already in the cart: View Cart
      // SPEC 26i: an HP Tuners add uploads both files: "Uploading Your Files..." while it runs
      var label = S.reviewed ? (busy ? (flowOf() === 'hp_tuners' ? T.hptUploading : T.ctaAddBusy) : (S.submit.status === 'added' ? T.viewCart : T.ctaAdd)) : T.ctaReview;
      var ctaEnabled = S.reviewed ? (valid && q.status === 'ready' && !lock) : (!lock && q.status !== 'unavailable');
      // Order Summary is a peer of Your Configuration (both h2): below 990px Your Configuration is hidden, and the
      // Order Summary must not sit as an h3 under the performance heading
      return '<section class="pk247-sum" aria-labelledby="' + hid('sum') + '">' +
        '<div class="pk247-sum__config"><h2 class="pk247-side__h" id="' + hid('sum-config') + '">' + esc(T.sumConfig) + '</h2>' +
        '<dl class="pk247-rows">' + rows + '</dl></div>' +
        '<h2 class="pk247-h3 pk247-h3--sum' + (q.status === 'ready' ? '' : ' pk247-h3--nolines') + '" id="' + hid('sum') + '">' + esc(T.sumOrder) + '</h2>' + orderLinesHtml(q) +
        subtotalHtml(quoteText(q), q.status) +
        ctaHtml(label, ctaEnabled, S.submit.status === 'busy', q) +
        '</section>';
    }

    /* ---------- sticky summary block only when it fits ---------- */
    // Only the summary (subtotal + action) is sticky inside the full-height right column; the performance block
    // above it scrolls away, so a tall EFI Live summary never drops the action off-screen after Review.
    // Never sticky while the EZ-Lynk power block (perfez) follows it in the same column: the transparent sticky
    // summary would slide down over the dyno block (SPEC 8: sticky "without covering content"). render() sets
    // perfez.hidden before it calls this.
    function updateSticky() {
      var sumEl = region('sum');
      if (!sumEl) return;
      var wide = window.matchMedia ? window.matchMedia('(min-width: 990px)').matches : true;
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var fits = sumEl.offsetHeight + headerH + 48 < window.innerHeight;
      var ez = region('perfez');
      sumEl.classList.toggle('is-sticky', wide && fits && (!ez || ez.hidden));
    }

    /* =========================================================================
       State transitions
       ========================================================================= */
    function resetDownstream() {
      clearTimeout(timers.quote);
      cancelRedirect();
      releaseCart();               // a late /cart/add.js answer for an abandoned configuration never succeeds or navigates
      S.decode = { status: 'idle' };
      S.manualPick = null; S.manualError = false;
      S.route = null; S.offer = null;
      S.device = null; S.deviceCommitted = false;
      S.form = emptyForm(null); S.previewLevelId = null;
      S.touched = {}; S.showAllErrors = false; S.reviewed = false;
      S.quote = { status: 'none', lines: [] }; S.lastAnnouncedTotal = null;
      S.submit = { status: 'idle', message: '', detail: '' }; S.added = null;
      S.notice = null;
      S.files = emptyFiles(); S.pendingCta = false;   // SPEC 26l: a new VIN clears the HP Tuners files
    }

    function decode() {
      if (locked()) return;
      var vin = normVin(vinInput.value);
      if (vinInput.value !== vin) vinInput.value = vin;
      resetDownstream();
      S.seq++;
      S.vin = vin;
      var problem = vinProblem(vin);
      if (problem) {
        S.decode = { status: 'invalid', problem: problem };
        render();
        announce(T.checkHeading + '. ' + problem.message);
        vinInput.focus();
        return;
      }
      var seq = S.seq;
      S.decode = { status: 'loading' };
      render();
      // Try Again (lookup error) is replaced by the Decoding VIN heading: keep keyboard focus in place, never on <body>
      var a = document.activeElement;
      if (!a || a === document.body || !document.documentElement.contains(a)) focusHeading('veh');
      announce(T.vinBusy);
      fetchDecode(vin).then(function (json) {
        if (seq !== S.seq) return;                      // stale: the VIN changed while this was in flight
        var r = json && json.Results && json.Results[0];
        var res = identify(r);
        if (res.status === 'error') return decodeFailed();
        if (res.status === 'check_vin') {
          S.decode = { status: 'checkvin', identity: res.identity };
          render();
          announce(T.checkHeading + '. ' + T.checkVpic);
          vinInput.focus();
          return;
        }
        if (res.status === 'incomplete') {
          S.decode = { status: 'incomplete', identity: res.identity, reason: res.reason, manualAllowed: res.manualAllowed };
          render();
          announce(T.incomplete);
          focusHeading('veh');
          return;
        }
        // "Continue To See Price" is promised only when the prospect's EZ-Lynk mapping really resolves in the catalog
        var prospect = resolveRoute(res.identity, null, flags);
        var pOff = prospect.type === 'ez_lynk' && ROUTES[prospect.id] ? routeOffer(prospect.id, res.identity, data) : null;
        S.decode = { status: 'found', identity: res.identity, prospect: prospect, prospectPriced: !!(pOff && pOff.ez && pOff.ez.ok) };
        render();
        announce(T.found + ': ' + vehicleTitle(res.identity) + ' ' + engineLabel(res.identity, null));
        focusHeading('veh');
      }, function () {
        if (seq !== S.seq) return;
        decodeFailed();
      });
    }

    function decodeFailed() {
      S.decode = { status: 'error' };
      render();
      announce(T.errorHeading);
      focusHeading('veh');
    }

    function fetchDecode(vin) {
      var url = decoderUrl + encodeURIComponent(vin) + '?format=json';
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      return new Promise(function (resolve, reject) {
        var done = false;
        var t = setTimeout(function () {
          if (done) return;
          done = true;
          if (ctrl) ctrl.abort();
          reject(new Error('timeout'));
        }, timeoutMs);
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        }).then(function (j) {
          if (done) return;
          done = true; clearTimeout(t); resolve(j);
        }, function (err) {
          if (done) return;
          done = true; clearTimeout(t); reject(err);
        });
      });
    }

    function continueVehicle() {
      if (locked()) return;
      var st = S.decode.status;
      if (st !== 'found' && st !== 'incomplete') return;
      var ident = S.decode.identity;
      var res;
      if (st === 'found') {
        res = resolveRoute(ident, null, flags);
      } else if (S.decode.manualAllowed) {
        if (!S.manualPick) {
          S.manualError = true;
          render();
          announce(T.manualRequired);
          var first = region('veh').querySelector('[data-pk247-manual]');
          if (first) first.focus();
          return;
        }
        res = resolveRoute(ident, S.manualPick, flags);
      } else {
        res = notAvailable('incomplete');
      }
      applyRoute(res);
    }

    function applyRoute(res) {
      var def = ROUTES[res.id] || null;
      S.route = { id: res.id, type: res.type, reason: res.reason || null, manual: res.manual || null, links: res.links || null };
      S.confirmId++;
      S.device = null; S.deviceCommitted = false;
      S.form = emptyForm(def ? def.platform : null);
      S.previewLevelId = null; S.touched = {}; S.showAllErrors = false; S.reviewed = false;
      S.submit = { status: 'idle', message: '', detail: '' }; S.added = null; S.notice = null;
      S.files = emptyFiles(); S.pendingCta = false;   // SPEC 26l: a new route clears the HP Tuners files
      S.offer = def ? routeOffer(res.id, S.decode.identity, data) : null;
      var off = S.offer;
      if (S.route.type === 'ez_lynk') {
        if (!off.ez || !off.ez.ok) unmapped();
        else { S.device = 'ez_lynk'; S.deviceCommitted = true; }
      } else if (S.route.type === 'efi_live') {
        if (!off.efi || !off.efi.ok) unmapped();
        else { S.device = 'efi_live'; S.deviceCommitted = true; }
      } else if (S.route.type === 'sct') {
        // SPEC 22: the 6.0 has SCT only (auto-assigned); a missing / unavailable files variant is not orderable online
        if (!off.sct || !off.sct.ok) unmapped();
        else { S.device = 'sct'; S.deviceCommitted = true; }
      } else if (S.route.type === 'device_choice') {
        if (!routeDevices(def, flags).some(function (d) { return deviceOk(off, d); })) unmapped();
      } else if (S.route.type === 'catalog_redirect') {
        if (!off.dest) { S.route = { id: S.route.id, type: 'unresolved', reason: 'no_destination', manual: S.route.manual, links: ['build_your_tune', 'shop_now'] }; }
      } else if (S.route.type === 'product_page') {
        if (!off.pages || !off.pages.length) unmapped();          // SPEC 23b: neither product in the catalog
      }
      recomputeQuote();
      render();
      var t = S.route.type;
      if (t === 'unresolved') { announce(T.naHeading); focusHeading('na'); return; }
      if (t === 'product_page') { announce(T.ppHeading); focusHeading('pp'); return; }   // SPEC 23b
      if (t === 'catalog_redirect') {
        var d = ROUTES[S.route.id];
        announce(d.fallback ? T.ecoStatus : T.refStatus);
        focusHeading('ref');
        scheduleRedirect(S.offer.dest);
        return;
      }
      if (t === 'device_choice') { announce(T.deviceHeading); focusHeading('device'); return; }
      if (t === 'ez_lynk' && gateApplies(ctxOf())) { announce(T.gateLegend); focusHeading('gate'); return; }   // SPEC 13
      // SPEC 19: an L5P asked for its drive or transfer case reveals Vehicle Details first, above the package
      if (t === 'ez_lynk' && document.getElementById(hid('vehdetails'))) { announce(T.vehicleSection); focusHeading('vehdetails'); return; }
      announce(t === 'ez_lynk' ? T.supportSection : T.tuneSection);
      focusHeading(t === 'ez_lynk' ? 'support' : 'tune');
    }
    function unmapped() {
      S.route = { id: S.route.id, type: 'unresolved', reason: 'unmapped', manual: S.route.manual, links: ['build_your_tune', 'shop_now'] };
    }

    // Navigate once per confirmed route; no VIN in the URL; Back never re-triggers it (navigatedFor). The pending
    // timer is cancelled when the customer leaves first (pagehide, the fallback link): a page frozen in the bfcache
    // with the timer queued would otherwise bounce forward again on Back (SPEC 6).
    function cancelRedirect() { clearTimeout(timers.redirect); timers.redirect = null; }
    function scheduleRedirect(url) {
      if (!url) return;
      var key = S.confirmId;
      if (S.navigatedFor === key) return;
      S.navigatedFor = key;
      clearTimeout(timers.redirect);
      timers.redirect = setTimeout(function () {
        timers.redirect = null;
        if (!S.route || S.route.type !== 'catalog_redirect' || S.confirmId !== key) return;
        window.location.assign(url);
      }, REDIRECT_DELAY_MS);
    }

    function editVin() {
      if (locked()) return;          // Edit VIN is aria-disabled while the add is in flight / after its 200
      var keep = S.vin || vinInput.value;
      S.seq++;
      resetDownstream();
      S.vin = '';
      vinInput.value = keep;
      render();
      announce(T.statusEnter);
      vinInput.focus();
      try { vinInput.select(); } catch (e) { /* no selection support */ }
    }

    // Recompute and return the settled quote state as one announcement: "Price Updated: {amount}", or the state
    // the customer now sees ("Select Options To See Price", "Price Unavailable").
    function recomputeQuote() {
      clearTimeout(timers.quote);
      S.quote = computeQuote(ctxOf(), fmt);
      if (S.quote.status === 'ready') {
        S.lastAnnouncedTotal = S.quote.totalFormatted;
        return T.priceUpdated + S.quote.totalFormatted;
      }
      if (S.quote.status === 'unavailable') return T.qFailed;
      if (S.quote.status === 'incomplete') return T.qIncomplete;
      return '';
    }

    // Price-affecting change: mark stale, show "Updating Price" briefly, then recompute and announce the result
    // once (rapid changes restart the timer, so only the final state is announced). silent: the caller announces.
    // prefix: a cleanup notice ("Transmission Selections Cleared ...") announced together with the settled quote.
    function flashQuote(silent, prefix) {
      clearTimeout(timers.quote);
      if (!flowOf()) { S.quote = { status: 'none', lines: [] }; if (prefix && !silent) announce(prefix); return; }
      S.quote = { status: 'updating', lines: [], fingerprint: null };
      timers.quote = setTimeout(function () {
        var msg = recomputeQuote();
        render(true);
        var text = [prefix || '', msg || ''].filter(Boolean).join(' ');
        if (text && !silent) announce(text);
      }, QUOTE_FLASH_MS);
    }

    function setField(field, value, structural) {
      if (locked() && field !== 'previewLevelId') return;              // the sent configuration cannot change
      var before = S.form;
      var r = applyField({ form: S.form, previewLevelId: S.previewLevelId }, field, value, routeRules(S.route ? S.route.id : null, ctxOf()));
      S.form = r.form;
      S.previewLevelId = r.previewLevelId;
      S.notice = r.notice;
      // a field the cleanup cleared starts untouched: the new branch shows no error until the customer uses it
      // (or presses Review / Add, which reveals every error)
      if (before.ecmFileType !== r.form.ecmFileType || !r.form.transTuning) { delete S.touched.shiftPoints; delete S.touched.transPressure; }
      if (r.form.tuneType !== 'single') delete S.touched.tuneLevel;
      if (field === 'tuneType' && r.form.tuneType !== 'single') delete S.touched.sctLevels;   // SPEC 22: the cleared 6.4 single files
      if (r.form.ecmUnlocked === 'no') delete S.touched.supportPackage;   // the cleared package starts untouched
      if (field === 'previewLevelId') { render(); return; }            // preview never reprices
      // any purchase change leaves the error state, and a restored "added" state: the new configuration is not the
      // one in the cart (submit() still checks /cart.js before posting)
      if (S.submit.status === 'error' || S.submit.status === 'added') { S.submit = { status: 'idle', message: '', detail: '' }; S.added = null; }
      var noticeText = r.notice ? r.notice.text : '';
      if (r.priceAffecting) flashQuote(false, noticeText);
      else {
        S.quote = S.quote.status === 'updating' ? S.quote : computeQuote(ctxOf(), fmt);
        if (noticeText) announce(noticeText);
      }
      render(!structural);
    }

    /* ---------- SPEC 26e / 26f: the HP Tuners files ---------- */
    // A file picked (or changed) in a file field. The File is kept in S.files with its metadata; an infolog that passes the
    // checks that need no reading is then read as text (only its connected E41 block is parsed). The stock read is never read.
    function pickFile(kind, file) {
      if (locked() || flowOf() !== 'hp_tuners' || !file || !HPT_FILE_FIELD[kind]) return;
      if (kind === 'infolog' && cumminsHpt(ctxOf())) return;
      var field = HPT_FILE_FIELD[kind];
      var rec = { file: file, name: hptFileName(file.name), size: Number(file.size) || 0, lastModified: Number(file.lastModified) || 0, token: ++fileSeq, check: null };
      var reading = kind === 'infolog' && !infologPreProblem(rec);
      if (reading) rec.check = { status: 'pending' };
      S.files[kind] = rec;
      S.touched[field] = true;
      S.notice = null;
      if (S.submit.status === 'error' || S.submit.status === 'added') { S.submit = { status: 'idle', message: '', detail: '' }; S.added = null; }
      if (S.quote.status !== 'updating') S.quote = computeQuote(ctxOf(), fmt);   // the fingerprint carries the file's metadata
      render();
      var ch = document.getElementById(fid(field) + '-change');
      if (ch) focusEl(ch);
      if (reading) readInfolog(rec);
      else announce(fileAnnouncement(kind));
    }
    // what the live region says after a pick / a finished read: the same as the field shows. "Infolog Matches This VIN." only
    // with the visible note (infologMatches); otherwise "Selected: <name>", plus the field error when there is one.
    function fileAnnouncement(kind) {
      var fl = filesMeta(), meta = fl[kind];
      if (!meta) return '';
      var prob = kind === 'infolog' ? infologProblem(meta, S.vin) : stockProblem(meta, ctxOf());
      if (!prob && kind === 'infolog' && infologMatches(meta, S.vin)) return T.hptMatch;
      return T.hptSelected + ' ' + meta.name + (prob ? '. ' + prob : '');
    }
    function readInfolog(rec) {
      function done(check) {
        if (!alive || S.files.infolog !== rec) return;   // replaced, removed or reset meanwhile: a late read is ignored
        rec.check = check;
        render();
        announce(fileAnnouncement('infolog'));
        if (S.pendingCta) { S.pendingCta = false; onCta(false); }   // Review / Add To Cart pressed while it was read
      }
      var reader;
      try { reader = new FileReader(); } catch (e) { done({ status: 'error' }); return; }
      reader.onload = function () {
        var text = typeof reader.result === 'string' ? reader.result : '';
        var nul = text.slice(0, HPT_NUL_SCAN).indexOf('\u0000') >= 0;
        var p = nul ? { e41: false, vin: null, os: null } : parseInfolog(text);
        done({ status: 'done', nul: nul, e41: p.e41, vin: p.vin, os: p.os });
      };
      reader.onerror = function () { done({ status: 'error' }); };
      try { reader.readAsText(rec.file); } catch (e) { done({ status: 'error' }); }
    }
    function changeFile(kind) {
      if (locked() || !HPT_FILE_FIELD[kind]) return;
      var inp = document.getElementById(fid(HPT_FILE_FIELD[kind]));
      if (inp && !inp.disabled) inp.click();
    }
    // Remove: the file and (infolog) its check result go; the field starts untouched again (its error shows on Review)
    function removeFile(kind) {
      if (locked() || !HPT_FILE_FIELD[kind] || !S.files[kind]) return;
      var field = HPT_FILE_FIELD[kind];
      S.files[kind] = null;
      delete S.touched[field];
      if (kind === 'infolog') S.pendingCta = false;
      if (S.submit.status === 'error' || S.submit.status === 'added') { S.submit = { status: 'idle', message: '', detail: '' }; S.added = null; }
      if (S.quote.status !== 'updating') S.quote = computeQuote(ctxOf(), fmt);
      render();
      var inp = document.getElementById(fid(field));
      if (inp) focusEl(inp);
      announce((kind === 'infolog' ? T.hptInfologShort : T.hptStockShort) + ' Removed.');
    }

    function pickDevice(device) {
      var off = S.offer || {};
      if (routeDevices(routeDef(), flags).indexOf(device) < 0 || !deviceOk(off, device)) return;   // only this route's mapped devices
      if (S.submit.status === 'busy' || S.submit.status === 'success') return;
      var r = applyDevice({ device: S.device, form: S.form, previewLevelId: S.previewLevelId, files: filesMeta() }, device, platformOf());
      if (!r.changed) return;
      S.device = r.device; S.form = r.form; S.previewLevelId = r.previewLevelId; S.notice = r.notice;
      S.files = emptyFiles(); S.pendingCta = false;   // SPEC 26l: a device switch clears the HP Tuners files
      // SPEC 23e: on a 2013-2018 cab & chassis Single Tune is the only tune type, so EFI Live starts on it
      var nc = ctxOf(); nc.flow = device;
      if (device === 'efi_live' && ccSotfOff(nc)) S.form.tuneType = 'single';
      S.touched = {}; S.showAllErrors = false; S.reviewed = false;
      S.submit = { status: 'idle', message: '', detail: '' }; S.added = null;
      if (S.deviceCommitted) {
        flashQuote(true);   // the new branch always starts incomplete; the section announcement below says enough
        render();
        var k = flowStartKey(device);
        announce((r.notice ? r.notice.text + ' ' : '') + FLOW_START_TEXT[k]);
        focusHeading(k);
      } else {
        render();
      }
    }

    function commitDevice() {
      if (!S.device || S.deviceCommitted) return;
      S.deviceCommitted = true;
      recomputeQuote();
      render();
      var k = flowStartKey(S.device);
      announce(FLOW_START_TEXT[k]);
      focusHeading(k);
    }
    // The first section a committed device reveals: EZ-Lynk's support package, or (SPEC 26a: the L5P's EZ-Lynk side, as when it
    // was auto-assigned) the 2017-2018 ECM gate, else Vehicle Details when the drive or transfer case is asked; every other
    // flow (EFI Live, SCT, SPEC 26 HP Tuners) its Tune Selection
    var FLOW_START_TEXT = { gate: T.gateLegend, vehdetails: T.vehicleSection, support: T.supportSection, tune: T.tuneSection };
    function flowStartKey(device) {
      if (device !== 'ez_lynk') return 'tune';
      if (gateApplies(ctxOf())) return 'gate';
      return document.getElementById(hid('vehdetails')) ? 'vehdetails' : 'support';
    }

    // Required fields in on-screen order, per flow (SPEC 19: the L5P drive questions sit above the package, the
    // 2022-2024 E/C Number below it; on GM EFI Live they lead Vehicle Details)
    var ERR_ORDER = {
      ez_lynk: ['ecmUnlocked', 'driveType', 'tcase', 'supportPackage', 'ecmEc', 'poNumber'],
      // SPEC 22: Tune Selection, Device Details, Vehicle Details, Order Details
      sct: ['tuneType', 'sctLevels', 'idleSound', 'sctSerial', 'ecmStrategy', 'tcuStrategy', 'sctTurbo', 'sctInjectors', 'truckTransmission',
        'sctSensors', 'sctLimiter', 'poNumber'],                   // 6.0 SCT sensor and rev limiter choices
      efi_live: ['tuneType', 'tuneLevel', 'idleSound', 'deviceSerial', 'ecmEc', 'ecmSerial', 'injectors', 'ecmFileType', 'driveType', 'tcase',
        'truckTransmission', 'tireDiameter', 'shiftPoints', 'transPressure', 'poNumber'],
      // SPEC 26c: Tune Selection, Device Details, Vehicle Files, Order Details
      hp_tuners: ['tuneType', 'tuneLevel', 'hptSerial', 'hptInfolog', 'hptStock', 'poNumber']
    };
    function errOrder() { return ERR_ORDER[flowOf()] || ERR_ORDER.efi_live; }
    function focusFirstInvalid(errs) {
      var order = errOrder();
      for (var i = 0; i < order.length; i++) {
        var k = order[i];
        if (!errs[k]) continue;
        var el = region('flow').querySelector('[data-pk247-field="' + k + '"]:not([disabled])');
        // SPEC 26e: a picked file's own control is its Change button (the input is out of the tab order then)
        if (k === 'hptInfolog' || k === 'hptStock') el = document.getElementById(fid(k) + '-change') || el;
        if (k === 'tuneLevel') {
          var cands = region('flow').querySelectorAll('[data-pk247-field="tuneLevel"]');
          for (var j = 0; j < cands.length; j++) if (cands[j].offsetParent !== null) { el = cands[j]; break; }
        }
        if (el) { focusEl(el); return; }
      }
    }

    // Reveal every required-field error, announce it and move focus to the first invalid control.
    // Returns false when the form has no errors (the action is disabled for another reason).
    function showErrors(errs) {
      if (!Object.keys(errs).length) return false;
      S.showAllErrors = true;
      render();
      // EZ-Lynk names its first missing answer (the gate, a drive question, the package, the E/C Number)
      var first = null, order = errOrder();
      for (var i = 0; i < order.length && !first; i++) if (errs[order[i]]) first = errs[order[i]];
      announce(flowOf() === 'ez_lynk' && first ? first : T.fixFields);
      focusFirstInvalid(errs);
      return true;
    }

    // A click on the aria-disabled action explains it instead of doing nothing (never while busy or repricing).
    function explainDisabledCta() {
      if (!flowOf() || S.quote.status === 'updating') return;
      if (S.submit.status !== 'idle' && S.submit.status !== 'error') return;
      if (infologPending()) { S.pendingCta = true; announce(T.hptChecking); return; }   // SPEC 26f: continues when the read ends
      // Price Unavailable (SPEC 3): completing fields cannot enable a purchase without a price, so say that and move
      // focus to the subtotal that shows it (after a market change, to the reload action)
      if (S.quote.status === 'unavailable') {
        announce(S.marketChanged ? T.marketChanged : T.qFailed);
        var target = S.marketChanged ? app.querySelector('[data-pk247-act="reload"]') : document.getElementById(id('subtotal'));
        if (target) focusEl(target);
        return;
      }
      showErrors(validate(ctxOf()));
    }

    function destFor(flow) {
      return flow === 'ez_lynk' ? joinRoot(data.routes.root_url, 'checkout') : (data.routes.cart_url || joinRoot(data.routes.root_url, 'cart'));
    }

    // pointer: a mouse / touch activation (click detail >= 1); keyboard activation has detail 0
    function onCta(pointer) {
      var flow = flowOf();
      if (!flow || S.submit.status === 'busy' || S.submit.status === 'success') return;
      // A bfcache restore of a finished add ('added') goes through submit() like any add: it reads /cart.js first and
      // only continues to checkout / the cart without posting when the whole configuration is still there; a cart
      // emptied or edited elsewhere gets the missing lines added (never a claimed add over an empty cart).
      var ctx = ctxOf();
      if (S.quote.status === 'manual') return;     // SPEC 22b: a manual build (the product page link replaces the action)
      // SPEC 26f: Review / Add To Cart wait for the infolog read (milliseconds for a real log), then run as a keyboard activation
      if (infologPending()) { S.pendingCta = true; announce(T.hptChecking); return; }
      var errs = validate(ctx);
      if (showErrors(errs)) return;
      // SPEC 22: SCT reviews like EFI Live, then adds to the cart; SPEC 26: so does HP Tuners
      var reviews = flow === 'efi_live' || flow === 'sct' || flow === 'hp_tuners';
      if (reviews && !S.reviewed) {
        S.reviewed = true;
        S.reviewedAt = Date.now();
        render();
        announce(T.reviewSection);
        focusHeading('review');
        return;
      }
      // the same button now reads Add To Cart in place: a quick second click on Review Configuration never skips the
      // review (keyboard is unaffected: Review moved focus to the review heading)
      if (reviews && pointer && Date.now() - S.reviewedAt < REVIEW_GUARD_MS) return;
      submit();
    }

    function submit() {
      var ctx = ctxOf();
      if (S.quote.status !== 'ready') return;
      var fresh = computeQuote(ctx, fmt);
      if (fresh.status !== 'ready' || fresh.fingerprint !== S.quote.fingerprint) {   // never submit a stale quote
        S.quote = fresh;
        render(true);
        return;
      }
      var payload, group = newGroupId();
      try { payload = buildCartPayload(ctx, fresh, group); } catch (e) { return; }
      var flow = ctx.flow;
      var sentFp = fresh.fingerprint;
      var sentPo = activeConfig(ctx).poNumber || '';     // SPEC 21a: the order attribute carries this build's PO
      var sentItems = payload.items.map(function (it) { return { id: it.id }; });
      // SPEC 26i: the File objects this HP Tuners add uploads (the controls lock while it runs, so they cannot change)
      var sentFiles = flow === 'hp_tuners' ? { infolog: !cumminsHpt(ctxOf()) && S.files.infolog && S.files.infolog.file, stock: S.files.stock && S.files.stock.file } : null;
      if (sentFiles && !sentFiles.stock) return;
      S.submit = { status: 'busy', message: '', detail: '' };
      S.added = null;                                    // set again only by a verified result below
      render();                                          // full render: the purchase controls lock (disabled)
      announce(flow === 'ez_lynk' ? T.ctaCheckoutBusy : (flow === 'hp_tuners' ? T.hptUploading : T.ctaAddBusy));
      var addUrl = String(data.routes.cart_add_url || joinRoot(data.routes.root_url, 'cart/add')).replace(/\.js$/, '') + '.js';
      var token = ++cartReq.token;
      // theme-notes 5 / SPEC 5: read /cart.js first (a restored page, a second tab, a cart edited elsewhere).
      // - A cart in another market currency never receives this quote (handoff: never submit a stale quote).
      // - The whole configuration already there (tune line + every add-on line of its group): nothing is posted, and
      //   the page says so instead of claiming an add.
      // - The tune line there but an add-on line gone: only the missing line(s) are posted, linked to that group.
      // - SPEC 18a: lines of this configuration added before the SPEC 18 markers existed (no _247 / _247_order) are
      //   upgraded in place first (/cart/change.js, one line at a time), so the order still carries its label and
      //   build data and nothing is duplicated. A failed upgrade is a cart error, like a failed add.
      // A failed or slow read never blocks the add itself.
      getCart().then(function (cart) {
        if (token !== cartReq.token) return null;          // released by a bfcache restore or superseded
        if (currencyChanged(cart, data.currency)) { var ce = new Error('currency'); ce.currency = true; throw ce; }
        if (flow === 'hp_tuners') return hptAdd(cart);     // SPEC 26i: never the JSON add, upgradeLines or regroup
        var chk = cartGroupCheck(cart, payload.items, sentFp);
        if (chk.group && !chk.missing.length && !chk.upgrade.length) return { already: true, posted: false, group: chk.group };
        return upgradeLines(chk.upgrade, token).then(function (live) {
          if (!live) return null;                          // released by a bfcache restore or superseded
          if (chk.group && !chk.missing.length) return { already: true, posted: true, group: chk.group };
          return addLines(chk);
        });
      }).then(function (res) {
        if (!res || token !== cartReq.token) return null;
        if (res.response) paintCartBubble(res.response);   // the theme's header count, before the notice and navigation
        S.submit = { status: 'success', message: '', detail: '' };
        S.added = { fingerprint: sentFp, group: res.group, items: sentItems, already: res.already };
        render();
        announce(res.already ? T.cartAlready : T.cartAdded);
        // SPEC 18a / 18f: a verified 200 add (or in-place upgrade) also labels the order information (cart attributes
        // -> the order's note_attributes). It never blocks the purchase or the success state: the line markers (_247)
        // confirm every line, so a failed or slow label continues after one retry or ATTR_BUDGET_MS. Nothing was
        // posted when the cart already held it all, correctly marked.
        return (res.posted ? markOrder(sentPo) : Promise.resolve(null)).then(function () {
          if (token !== cartReq.token) return;               // released by a bfcache restore meanwhile
          // second guard: navigate only if what is on screen is still exactly what was sent (the lock makes this
          // the normal case); otherwise stay with the success notice and its View Cart / Checkout links
          var now = computeQuote(ctxOf(), fmt);
          if (now.status !== 'ready' || now.fingerprint !== sentFp) return;
          window.location.assign(destFor(flow));
        });
      }).catch(function (err) {
        if (token !== cartReq.token) return;
        if (err && err.currency) { onMarketChanged(); return; }
        // a fixed, flow-specific error title (copy deck 3.17 for EZ-Lynk, 3.19 for EFI Live); Shopify's text is the
        // detail. role=alert announces it, so the live region is not used a second time. SPEC 26i: an HP Tuners add has its
        // own timeout title and the "Your Files Did Not Upload" title (the line was removed again).
        var title = (err && err.timeout) ? (flow === 'hp_tuners' ? T.hptUploadTimeout : T.cartTimeout)
          : (err && err.uploads ? T.hptUploadFailed : (flow === 'ez_lynk' ? T.ctaCheckoutError : T.cartError));
        S.submit = { status: 'error', message: title, detail: (err && !err.timeout && !err.uploads && err.userMessage) || '' };
        if (liveEl) { clearTimeout(timers.live); liveEl.textContent = ''; }   // no stale "Opening Checkout"
        render();
        var cta = document.getElementById(id('cta'));
        if (cta) cta.focus();
      });

      // POST the whole payload, or only the lines missing from an existing group, to /cart/add.js
      function addLines(chk) {
        var send = chk.group ? { items: chk.missing } : payload;
        return postCart(addUrl, send).then(function (r) {
          if (token !== cartReq.token) return null;
          var j = null;
          try { j = r.text ? JSON.parse(r.text) : null; } catch (e) { j = null; }
          // Success only on a real 200 whose JSON body lists the added items. An HTML 200 (password page, login or
          // proxy reached through a redirect), an empty body or a {status: 422} body are failures.
          var ok = r.status === 200 && !!j && typeof j === 'object' && (j.status == null || String(j.status) === '200') && Array.isArray(j.items);
          if (!ok) {
            var err = new Error('cart');
            err.userMessage = j && typeof j === 'object' && (j.description || j.message) ? String(j.description || j.message) : '';
            throw err;
          }
          return { already: false, posted: true, group: chk.group || group, response: j };
        });
      }

      // SPEC 26i: the HP Tuners add. The same configuration (fingerprint, which carries each file's name|size|lastModified)
      // already in the cart with all selected uploads: nothing is posted. One there without them (or unmarked): removed (quantity 0)
      // and added again; never edited in place. Then ONE multipart POST carrying the required HPT and optional infolog, verified:
      // the requested variant has a /uploads/ URL for each selected file (the flat add answers with the line item);
      // else /cart.js, found by this build's group; else the line is removed again and "Your Files Did Not Upload" is shown.
      // The page never reports "Item Added" without every selected upload URL.
      function hptAdd(cart) {
        var item = payload.items[0];
        var found = hptCartLine(cart, sentFp);
        if (found && found.ok) return { already: true, posted: false, group: found.group };
        var pre = found && found.line && found.line.key != null ? removeLine(found.line.key) : Promise.resolve(true);
        return pre.then(function (live) {
          if (!live || token !== cartReq.token) return null;
          var fd = new FormData();
          hptFormFields(item).forEach(function (kv) { fd.append(kv[0], kv[1]); });
          if (sentFiles.infolog) fd.append('properties[' + HPT_UPLOAD_KEYS.infolog + ']', sentFiles.infolog, sentFiles.infolog.name);
          fd.append('properties[' + HPT_UPLOAD_KEYS.stock + ']', sentFiles.stock, sentFiles.stock.name);
          fd.append('sections', 'cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          return postForm(addUrl, fd, uploadTimeoutMs, function (ctrl) { cartReq.ctrl = ctrl; });
        }).then(function (r) {
          if (!r || token !== cartReq.token) return null;
          var j = null;
          try { j = r.text ? JSON.parse(r.text) : null; } catch (e) { j = null; }
          if (!(r.status === 200 && !!j && typeof j === 'object' && (j.status == null || String(j.status) === '200'))) {
            var err = new Error('cart');                     // a 422 carries Shopify's own description (the error detail)
            err.userMessage = j && typeof j === 'object' && (j.description || j.message) ? String(j.description || j.message) : '';
            throw err;
          }
          var line = hptReplyLine(j, group);
          if (line && cartLineVariant(line) === Number(item.id) && hptUploadsOk(line.properties)) {
            return { already: false, posted: true, group: group, response: j };
          }
          return getCart().then(function (c2) {
            if (token !== cartReq.token) return null;
            var lines = c2 && Array.isArray(c2.items) ? c2.items : [], l2 = null;
            for (var i = 0; i < lines.length && !l2; i++) if (lines[i] && lines[i].properties && lines[i].properties._247_group === group) l2 = lines[i];
            if (l2 && cartLineVariant(l2) === Number(item.id) && hptUploadsOk(l2.properties)) {
              return { already: false, posted: true, group: group, response: j };
            }
            var bad = l2 || line;
            var fail = function () {
              var e = new Error('uploads');
              if (!(bad && hptUploadsOk(bad.properties))) e.uploads = true;   // else: another variant came back (a cart error)
              throw e;
            };
            if (!bad || bad.key == null) return fail();
            return removeLine(bad.key).then(fail, fail);
          });
        });
      }
      // /cart/change.js {id: key, quantity: 0}: verified by a 200 cart JSON without that key; any other answer rejects
      function removeLine(key) {
        var url = String(data.routes.cart_change_url || joinRoot(data.routes.root_url, 'cart/change')).replace(/\.js$/, '') + '.js';
        return postJson(url, { id: String(key), quantity: 0 }, cartTimeoutMs, function (ctrl) { cartReq.ctrl = ctrl; }).then(function (r) {
          if (token !== cartReq.token) return false;
          var j = null;
          try { j = r.text ? JSON.parse(r.text) : null; } catch (e) { j = null; }
          var ok = r.status === 200 && !!j && typeof j === 'object' && Array.isArray(j.items) &&
            !j.items.some(function (it) { return it && String(it.key) === String(key); });
          if (!ok) {
            var err = new Error('cart_change');
            err.userMessage = j && typeof j === 'object' && (j.description || j.message) ? String(j.description || j.message) : '';
            throw err;
          }
          return true;
        });
      }
    }

    // The cart reports another currency than this page was rendered in: nothing was posted. Every quote now reads
    // Price Unavailable (fmt), the action is disabled, and the notice offers a reload; all input stays on the page.
    function onMarketChanged() {
      S.marketChanged = true;
      S.submit = { status: 'idle', message: '', detail: '' };
      S.added = null;
      clearTimeout(timers.quote);
      S.quote = computeQuote(ctxOf(), fmt);
      if (liveEl) { clearTimeout(timers.live); liveEl.textContent = ''; }
      render();
      announce(T.marketChanged);
      var b = app.querySelector('[data-pk247-act="reload"]');
      if (b) focusEl(b);
    }

    // theme-notes 5 (Dawn's getSectionInnerHTML pattern): repaint the header cart icon from the cart-icon-bubble
    // section the add response carries. Never cart-notification.renderContents (single-item only, SPEC 12d). The
    // pk-mobile-nav count is server-rendered inside the header group and refreshes on the next page.
    function paintCartBubble(j) {
      try {
        var html = j && j.sections && j.sections['cart-icon-bubble'];
        var bubble = document.getElementById('cart-icon-bubble');
        if (typeof html !== 'string' || !html || !bubble || typeof DOMParser !== 'function') return;
        var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (sec) bubble.innerHTML = sec.innerHTML;
      } catch (e) { /* the header count is cosmetic; the verified add stands */ }
    }

    // GET {root_url}cart.js. Resolves the cart JSON, or null on any failure or after CART_CHECK_MS; never rejects.
    function getCart() {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      return new Promise(function (resolve) {
        var done = false;
        var t = setTimeout(function () {
          if (done) return;
          done = true;
          if (ctrl) ctrl.abort();
          resolve(null);
        }, CART_CHECK_MS);
        var opts = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
        if (ctrl) opts.signal = ctrl.signal;
        fetch(joinRoot(data.routes.root_url, 'cart.js'), opts).then(function (res) {
          return res.ok ? res.json() : null;
        }).then(function (j) {
          if (done) return;
          done = true; clearTimeout(t); resolve(j && typeof j === 'object' ? j : null);
        }, function () {
          if (done) return;
          done = true; clearTimeout(t); resolve(null);
        });
      });
    }
    // One JSON POST within ms. Resolves {status, text}; rejects on a network error, or with err.timeout after ms.
    // track(ctrl) receives the request's AbortController (the cart add keeps it so a bfcache restore can abort it).
    function postJson(url, body, ms, track) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      if (track) track(ctrl);
      return new Promise(function (resolve, reject) {
        var done = false;
        var t = setTimeout(function () {
          if (done) return;
          done = true;
          if (ctrl) ctrl.abort();
          var err = new Error('timeout');
          err.timeout = true;
          reject(err);
        }, ms);
        var opts = {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        };
        if (ctrl) opts.signal = ctrl.signal;
        fetch(url, opts).then(function (res) {
          return res.text().then(function (txt) { return { status: res.status, text: txt }; });
        }).then(function (r) {
          if (done) return;
          done = true; clearTimeout(t); resolve(r);
        }, function (err) {
          if (done) return;
          done = true; clearTimeout(t); reject(err);
        });
      });
    }
    // SPEC 26i: one multipart POST (FormData; the browser sets Content-Type with its boundary) within ms (cart.upload_timeout_ms),
    // with an AbortController. Resolves {status, text}; rejects on a network error, or with err.timeout after ms.
    function postForm(url, fd, ms, track) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      if (track) track(ctrl);
      return new Promise(function (resolve, reject) {
        var done = false;
        var t = setTimeout(function () {
          if (done) return;
          done = true;
          if (ctrl) ctrl.abort();
          var err = new Error('timeout');
          err.timeout = true;
          reject(err);
        }, ms);
        var opts = { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd };
        if (ctrl) opts.signal = ctrl.signal;
        fetch(url, opts).then(function (res) {
          return res.text().then(function (txt) { return { status: res.status, text: txt }; });
        }).then(function (r) {
          if (done) return;
          done = true; clearTimeout(t); resolve(r);
        }, function (err) {
          if (done) return;
          done = true; clearTimeout(t); reject(err);
        });
      });
    }
    // One POST with the same ~10 s budget as the VIN lookup; a hung request ends in the recoverable error state.
    // The body asks for the cart-icon-bubble section (theme-notes 5), so a 200 also carries the header cart count.
    function postCart(url, payload) {
      return postJson(url, { items: payload.items, sections: 'cart-icon-bubble', sections_url: window.location.pathname }, cartTimeoutMs,
        function (ctrl) { cartReq.ctrl = ctrl; });
    }
    // SPEC 18a: upgrade cart lines added before the SPEC 18 markers, one POST {routes.cart_change_url}.js per line
    // (bodies from cartGroupCheck: the line key, its quantity, the current properties). Sequential, because each
    // answer is the whole cart. Verified only by a 200 cart JSON holding a line with exactly those properties; any
    // other answer, a timeout or a network error rejects (the cart error state; a retry re-reads /cart.js and only
    // upgrades what is still unmarked). Resolves true, or false when the request was released or superseded.
    function upgradeLines(bodies, token) {
      var url = String(data.routes.cart_change_url || joinRoot(data.routes.root_url, 'cart/change')).replace(/\.js$/, '') + '.js';
      function hasLine(j, props) {
        var list = j && Array.isArray(j.items) ? j.items : [];
        for (var i = 0; i < list.length; i++) {
          var lp = list[i] && list[i].properties, all = !!lp;
          for (var k in props) if (all && Object.prototype.hasOwnProperty.call(props, k)) all = lp[k] === props[k];
          if (all) return true;
        }
        return false;
      }
      function step(n) {
        if (token !== cartReq.token) return Promise.resolve(false);
        if (n >= bodies.length) return Promise.resolve(true);
        return postJson(url, bodies[n], cartTimeoutMs, function (ctrl) { cartReq.ctrl = ctrl; }).then(function (r) {
          if (token !== cartReq.token) return false;
          var j = null;
          try { j = r.text ? JSON.parse(r.text) : null; } catch (e) { j = null; }
          var ok = r.status === 200 && !!j && typeof j === 'object' && (j.status == null || String(j.status) === '200') && hasLine(j, bodies[n].properties);
          if (!ok) {
            var err = new Error('cart_change');
            err.userMessage = j && typeof j === 'object' && (j.description || j.message) ? String(j.description || j.message) : '';
            throw err;
          }
          return step(n + 1);
        });
      }
      return step(0);
    }
    // SPEC 18a / 18f order information: POST {routes.cart_update_url}.js {attributes: {"Order Source": "24/7 Builder",
    // _247_rules}} after a verified add; Shopify copies cart attributes to the order's note_attributes. SPEC 21a: with
    // a PO Number the same request also sets the "PO Number" attribute (never an empty one; without a PO the key is not
    // sent, so an earlier build's PO in the same cart stays). The body carries only these keys (update.js merges, so
    // other attributes stay) and never a note. Verified only by a 200 cart JSON that echoes Order Source; otherwise
    // one retry inside ATTR_BUDGET_MS in total. Resolves true / false, never rejects: the purchase continues either way
    // (the _247 line markers confirm every line).
    function markOrder(po) {
      var url = String(data.routes.cart_update_url || joinRoot(data.routes.root_url, 'cart/update')).replace(/\.js$/, '') + '.js';
      var attrs = {};
      attrs[ORDER_SOURCE_KEY] = ORDER_SOURCE_VALUE;
      attrs._247_rules = RULES_VERSION;
      if (po) attrs[PO_KEY] = po;
      var body = { attributes: attrs };
      var deadline = Date.now() + ATTR_BUDGET_MS;
      function attempt(n) {
        var left = deadline - Date.now();
        if (left <= 0) return Promise.resolve(false);
        return postJson(url, body, left, null).then(function (r) {
          var j = null;
          try { j = r.text ? JSON.parse(r.text) : null; } catch (e) { j = null; }
          if (r.status === 200 && j && typeof j === 'object' && j.attributes && j.attributes[ORDER_SOURCE_KEY] === ORDER_SOURCE_VALUE) return true;
          throw new Error('cart_attributes');
        }).then(null, function () { return n < 2 ? attempt(n + 1) : false; });
      }
      return attempt(1);
    }
    function releaseCart() {
      cartReq.token++;
      if (cartReq.ctrl) { try { cartReq.ctrl.abort(); } catch (e) { /* already settled */ } }
      cartReq.ctrl = null;
    }

    /* =========================================================================
       Events (delegated on the section root)
       ========================================================================= */
    function onSubmit(e) {
      if (e.target === vinForm) { e.preventDefault(); if (S.decode.status !== 'loading') decode(); }
    }
    function onInput(e) {
      var t = e.target;
      if (t === vinInput) {
        if (S.decode.status !== 'idle' && !S.route) {            // any edit invalidates the decode and in-flight lookups
          S.seq++;
          resetDownstream();
          if (liveEl) { clearTimeout(timers.live); liveEl.textContent = ''; }   // no stale "Vehicle Details Found: ..."
          render();
        }
        return;
      }
      var field = t.getAttribute && t.getAttribute('data-pk247-field');
      if (!field || t.type !== 'text' || locked()) return;
      setField(field, t.value, false);
    }
    function onChange(e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('data-pk247-manual')) {
        S.manualPick = t.value; S.manualError = false;
        render();
        return;
      }
      var field = t.getAttribute && t.getAttribute('data-pk247-field');
      if (!field) return;
      if (locked() && field !== 'previewLevelId') { region('flow').__pkHtml = null; render(); return; }   // re-sync to the locked state
      // SPEC 26e: a file input: the File from t.files[0] (never t.value, "C:\fakepath\..."); a cancelled picker changes nothing
      if (t.type === 'file') { if (t.files && t.files[0]) pickFile(t.getAttribute('data-pk247-file'), t.files[0]); return; }
      if (t.type === 'text') { S.touched[field] = true; touchedRender(); return; }
      var value;
      if (t.type === 'checkbox') value = (field === 'engineOption' || field === 'sctLevels') ? { id: t.value, on: t.checked } : t.checked;
      else value = t.value;
      S.touched[field === 'engineOption' ? 'engineOptions' : field] = true;
      setField(field, value, true);
    }
    function onFocusOut(e) {
      var t = e.target;
      var field = t.getAttribute && t.getAttribute('data-pk247-field');
      if (field && t.type === 'text' && !S.touched[field]) {
        S.touched[field] = true;
        touchedRender();
      }
    }

    // Blur validation never changes the layout during the pointer interaction that caused the blur: focus moves on
    // mousedown (after pointerup for a tap), so an error inserted then pushes the control under the pointer away
    // before mouseup / click and the tap misses it. While a pointer interaction is in progress the render waits
    // for its click (or pointercancel, or a fallback timer); keyboard blurs (Tab) render at once.
    var ptr = { active: false, deferred: false, timer: null };
    var alive = true;
    function armPointer(ms) { clearTimeout(ptr.timer); ptr.timer = setTimeout(endPointer, ms); }
    function onPointerDown() { ptr.active = true; armPointer(POINTER_HOLD_MS); }
    function onPointerUp() { if (ptr.active) armPointer(POINTER_CLICK_MS); }
    function endPointer() {
      clearTimeout(ptr.timer); ptr.timer = null; ptr.active = false;
      if (!ptr.deferred) return;
      ptr.deferred = false;
      setTimeout(function () { if (alive) render(true); }, 0);   // after the click has reached its target
    }
    function touchedRender() {
      if (ptr.active) ptr.deferred = true;
      else render(true);
    }

    function onClick(e) {
      // the visible fallback link: the customer's own navigation cancels the pending automatic one
      if (e.target.closest && e.target.closest('[data-pk247-dest]')) cancelRedirect();
      var b = e.target.closest ? e.target.closest('[data-pk247-act]') : null;
      if (!b || !root.contains(b)) return;
      var act = b.getAttribute('data-pk247-act');
      if (b.getAttribute('aria-disabled') === 'true' && act !== 'device') {
        e.preventDefault();
        if (act === 'cta') explainDisabledCta();
        return;
      }
      switch (act) {
        case 'continue': continueVehicle(); break;
        case 'edit-vin': editVin(); break;
        case 'focus-vin': vinInput.focus(); try { vinInput.select(); } catch (er) { /* noop */ } break;
        case 'retry': decode(); break;
        case 'device':
          if (b.getAttribute('aria-disabled') === 'true') return;
          pickDevice(b.getAttribute('data-value'));
          break;
        case 'device-commit': commitDevice(); break;
        case 'file-change': changeFile(b.getAttribute('data-kind')); break;     // SPEC 26e
        case 'file-remove': removeFile(b.getAttribute('data-kind')); break;
        case 'reload': window.location.reload(); break;
        case 'edit-section':
          if (b.getAttribute('data-target') === 'vin') focusEl(editVinBtn);   // focus only, never triggers it
          else focusHeading(b.getAttribute('data-target'));
          break;
        case 'cta':
          if (e.detail > 1) break;     // the 2nd click of a double click (keyboard activation has detail 0)
          onCta(e.detail > 0);
          break;
        default: break;
      }
    }
    function onPageShow(e) {
      // bfcache restore after leaving for /cart or /checkout: never re-run a redirect; release a busy action (and
      // ignore any late answer to the old request); after a verified add, unlock the form and keep the success
      // notice only while /cart.js still holds the whole configuration (reconcileCart); the action re-checks the
      // cart before it continues, so the same lines are never posted twice and a missing line is added again
      if (!e.persisted) return;
      cancelRedirect();
      if (S.submit.status === 'busy' || S.submit.status === 'success') {
        releaseCart();
        S.submit = { status: S.submit.status === 'success' && S.added ? 'added' : 'idle', message: '', detail: '' };
        if (S.submit.status === 'idle') S.added = null;
        render();                    // unlock the purchase controls
      }
      reconcileCart();
    }
    function onPageHide() { cancelRedirect(); }
    // One /cart.js read after a bfcache restore. theme-notes 6: a restored page can carry a stale market currency, so
    // a changed cart currency reloads the page. SPEC 5: a restored "Item Added" configuration that is no longer
    // completely in the cart (emptied or edited elsewhere) drops the added state and its notice, so the action adds
    // it again instead of claiming it (onCta re-checks the cart in any case).
    function reconcileCart() {
      getCart().then(function (cart) {
        if (!alive || !cart) return;
        if (currencyChanged(cart, data.currency)) { window.location.reload(); return; }
        if (S.submit.status !== 'added' || !S.added) return;
        var chk = cartGroupCheck(cart, S.added.items, S.added.fingerprint);
        if (chk.group && !chk.missing.length && !chk.upgrade.length) return;   // SPEC 18a: unmarked lines need the action
        S.submit = { status: 'idle', message: '', detail: '' };
        S.added = null;
        render();
      });
    }
    function onResize() { updateSticky(); }

    root.addEventListener('submit', onSubmit);
    root.addEventListener('input', onInput);
    root.addEventListener('change', onChange);
    root.addEventListener('focusout', onFocusOut);
    root.addEventListener('click', onClick);
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('pointerup', onPointerUp, true);
    document.addEventListener('pointercancel', endPointer, true);
    document.addEventListener('click', endPointer, false);   // bubble phase: after the root handler and the target
    window.addEventListener('pageshow', onPageShow);
    window.addEventListener('pagehide', onPageHide);
    window.addEventListener('resize', onResize);

    render();

    var api = {
      destroy: function () {
        alive = false;
        clearTimeout(timers.quote); clearTimeout(timers.redirect); clearTimeout(timers.live); clearTimeout(ptr.timer);
        releaseCart();
        root.removeEventListener('submit', onSubmit);
        root.removeEventListener('input', onInput);
        root.removeEventListener('change', onChange);
        root.removeEventListener('focusout', onFocusOut);
        root.removeEventListener('click', onClick);
        document.removeEventListener('pointerdown', onPointerDown, true);
        document.removeEventListener('pointerup', onPointerUp, true);
        document.removeEventListener('pointercancel', endPointer, true);
        document.removeEventListener('click', endPointer, false);
        window.removeEventListener('pageshow', onPageShow);
        window.removeEventListener('pagehide', onPageHide);
        window.removeEventListener('resize', onResize);
      },
      getState: function () { return JSON.parse(JSON.stringify(S)); },
      ctx: function () { return JSON.parse(JSON.stringify(ctxOf())); }
    };
    return api;
  }

  /* =========================================================================
     11. Boot (page load + theme editor)
     ========================================================================= */
  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-pk247]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__pk247) continue;
      roots[i].__pk247 = createApp(roots[i]);
      instances.push(roots[i].__pk247);
    }
  }
  function unboot(scope) {
    var roots = (scope || document).querySelectorAll('[data-pk247]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__pk247) continue;
      roots[i].__pk247.destroy();
      instances.splice(instances.indexOf(roots[i].__pk247), 1);
      roots[i].__pk247 = null;
    }
  }

  window.PK247 = {
    version: RULES_VERSION,
    __test: {
      earlyApplies: earlyApplies, cmcApplies: cmcApplies, cmcCcApplies: cmcCcApplies, cmdFamily: cmdFamily, earlyFamily: earlyFamily, earlyProblem: earlyProblem, earlyPatcher: earlyPatcher,
      idleSoundsFor: idleSoundsFor, fileTypesFor: fileTypesFor, engineOptionsFor: engineOptionsFor, CMD_FAMILIES: CMD_FAMILIES,
      RULES_VERSION: RULES_VERSION, ROUTES: ROUTES, TRANS_ADDON: TRANS_ADDON, EZ_VARIANTS: EZ_VARIANTS, MANUAL: MANUAL, YES_NO: YES_NO,
      ENGINE_OPTIONS: ENGINE_OPTIONS, PRESSURES: PRESSURES, SHIFT_POINTS: SHIFT_POINTS, FILE_TYPES: FILE_TYPES,
      normVin: normVin, vinCheckDigitOk: vinCheckDigitOk, vinProblem: vinProblem,
      gateCodes: gateCodes, buildIdentity: buildIdentity, identify: identify, resolveRoute: resolveRoute, resolveManual: resolveManual,
      manualOptions: manualOptions, engineLabel: engineLabel, vehicleTitle: vehicleTitle, vehicleProperty: vehicleProperty,
      resolveVariant: resolveVariant, efiDefFor: efiDefFor, routeOffer: routeOffer,
      emptyForm: emptyForm, applyField: applyField, applyDevice: applyDevice,
      activeConfig: activeConfig, validate: validate, computeQuote: computeQuote, fingerprint: fingerprint, gateApplies: gateApplies,
      ecmIdsApply: ecmIdsApply, transOffered: transOffered, INJECTORS: INJECTORS, injectorsApply: injectorsApply,
      orderData: orderData, orderJson: orderJson, autoPatchReason: autoPatchReason, ATTR_BUDGET_MS: ATTR_BUDGET_MS, TEXT_MAX: TEXT_MAX,
      ORDER_SOURCE_KEY: ORDER_SOURCE_KEY, ORDER_SOURCE_VALUE: ORDER_SOURCE_VALUE,
      PO_KEY: PO_KEY, poProblem: poProblem, cabChassisVin: cabChassisVin, patcherSerialOk: patcherSerialOk,   // SPEC 21
      DRIVES: DRIVES, TCASES: TCASES, GM_ENGINES: GM_ENGINES, driveFromVpic: driveFromVpic, driveApplies: driveApplies,
      decodedDrive: decodedDrive, driveOf: driveOf, driveSourceOf: driveSourceOf, ezEcApplies: ezEcApplies, gmEngine: gmEngine,
      buildCartPayload: buildCartPayload, moneyFormatter: moneyFormatter, perfFor: perfFor, perfLevels: perfLevels, pageGains: pageGains, pageGainFor: pageGainFor,
      dynoCurves: dynoCurves, dynoSvg: dynoSvg, DYNO: DYNO, dynoYMax: dynoYMax, gainLabel: gainLabel,
      // SPEC 22 (SCT)
      DEVICES: DEVICES, SCT60_LEVELS: SCT60_LEVELS, SCT64_LEVELS: SCT64_LEVELS, SCT_TURBOS: SCT_TURBOS, SCT_INJECTORS: SCT_INJECTORS,
      TCU_STRATEGIES: TCU_STRATEGIES, SCT_TUNE_TYPES: SCT_TUNE_TYPES, SCT_SENSORS: SCT_SENSORS, sctHasInput: sctHasInput, sctDef: sctDef, sctLevelsOf: sctLevelsOf, sctLevelLabels: sctLevelLabels,
      sctSerialProblem: sctSerialProblem, strategyProblem: strategyProblem, routeDevices: routeDevices, deviceOk: deviceOk, routeRules: routeRules,
      cartGroupCheck: cartGroupCheck, cartCurrency: cartCurrency, currencyChanged: currencyChanged,
      // SPEC 23
      FLAG_DEFAULTS: FLAG_DEFAULTS, flagOn: flagOn, productPages: productPages, rumbleNoteApplies: rumbleNoteApplies,
      SENSORS_DEFAULT: SENSORS_DEFAULT, IDLE_SOUNDS: IDLE_SOUNDS, SCT_AUTOPATCH: SCT_AUTOPATCH, sct60Family: sct60Family, sctPatcher: sctPatcher,
      SCT_SERIAL_PREFIXES: SCT_SERIAL_PREFIXES, ccApplies: ccApplies, ccSotfOff: ccSotfOff, idleApplies: idleApplies, tuneTypesFor: tuneTypesFor,
      tuneLabel: tuneLabel,
      // SPEC 24
      efiDeviceDesc: efiDeviceDesc, linkSerialValid: linkSerialValid, LINK_SERIAL_PREFIXES: LINK_SERIAL_PREFIXES, ccPatcherVin: ccPatcherVin,
      // SPEC 26 (HP Tuners L5P)
      HPT_AUTOPATCH: HPT_AUTOPATCH, HPT_INFOLOG_STRICT: HPT_INFOLOG_STRICT, HPT_OS_PROFILES: HPT_OS_PROFILES, HPT_UPLOAD_KEYS: HPT_UPLOAD_KEYS,
      HPT_INFOLOG_MAX: HPT_INFOLOG_MAX, HPT_STOCK_MAX: HPT_STOCK_MAX, CUMMINS_HPT_STOCK_MAX: CUMMINS_HPT_STOCK_MAX, CUMMINS_HPT_MODES: CUMMINS_HPT_MODES, cumminsHpt: cumminsHpt, DEFAULT_UPLOAD_TIMEOUT: DEFAULT_UPLOAD_TIMEOUT, TUNE_TYPES: TUNE_TYPES,
      hptSerialNorm: hptSerialNorm, hptSerialProblem: hptSerialProblem, hptFileName: hptFileName, hptFileSize: hptFileSize,
      parseInfolog: parseInfolog, infologPreProblem: infologPreProblem, infologProblem: infologProblem, infologMatches: infologMatches, stockProblem: stockProblem,
      hptFileKey: hptFileKey, hptLevel: hptLevel, hptTuneLabel: hptTuneLabel, hptUploadsOk: hptUploadsOk, hptAutoPatchReason: hptAutoPatchReason,
      hptFormFields: hptFormFields, hptCartLine: hptCartLine, hptReplyLine: hptReplyLine, hptHasInput: hptHasInput,
      instances: function () { return instances.slice(); }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { unboot(e.target); });
})();
